export default {
  "bcase": {
    "header": {
      "tooltip": {
        "save": "Uložiť",
        "edit_enable": "Povoliť úpravy",
        "edit_disable": "Zakázať úpravy",
        "maximize": "Maximalizovať",
        "minimize": "Minimalizovať",
        "attachments": "Prílohy"
      }
    }
  },
    "oauth2_consent": {
        "title": "Povoliť aplikácii {application} prístup k Liftbase?",
        "intro": "Pred pokračovaním skontrolujte, ku ktorým údajom bude mať táto aplikácia prístup.",
        "application": "Aplikácia",
        "client_id": "ID aplikácie",
        "callback": "Cieľ spätného volania",
        "identity_notice": "Názov aplikácie pochádza z pripájajúcej sa aplikácie. Pred povolením overte cieľ spätného volania.",
        "permissions": "Oprávnenie",
        "duration": "Trvanie prístupu",
        "token_lifetime": "Platnosť tokenu",
        "token_lifetime_value": "{accessMinutes} minút",
        "renewal": "Obnovenie bez výzvy",
        "renewal_value": "až {authorizationDays} dní",
        "readonly": "Len čítanie",
        "notice": "Prístup zostáva obmedzený vašimi existujúcimi oprávneniami Liftbase a platí iba pre túto aplikáciu.",
        "allow": "Povoliť prístup",
        "deny": "Odmietnuť",
        "submit_error": "Autorizáciu sa nepodarilo spustiť. Skúste to znova.",
        "submit_error_invalid_request": "Táto žiadosť o autorizáciu vypršala alebo je neplatná. Spustite pripojenie znova v aplikácii.",
        "submit_error_invalid_redirect": "Cieľ návratu aplikácie je neplatný. Spustite pripojenie znova.",
        "error_title": "Žiadosť o autorizáciu je neplatná",
        "error_description": "Vráťte sa do aplikácie a spustite pripojenie znova.",
        "unverified_title": "Neoverená aplikácia",
        "unverified_warning": "Táto aplikácia nebola spoločnosťou Liftbase overená ako dôveryhodný poskytovateľ tretích strán. Zobrazený názov môže pochádzať od iného poskytovateľa. Pred povolením prístupu dôkladne skontrolujte URL presmerovania.",
        "scope": {
            "mcp": {
                "title": "Čítanie povolených údajov Liftbase",
                "description": "Nákupy, faktúry, zmluvy, workflow, bankové výpisy a likvidita — len čítanie, bez zápisu."
            }
        }
    },
    "administration": "Administrácia",
    "admin_page": {
        "no_permission": "Nemáte oprávnenie do oblasti správy.",
        "confirm_before_delete_msg": "Naozaj chcete odstrániť tento záznam? (Urobil som})",
        "confirm_before_delete_from_db_msg": "Naozaj chcete odstrániť tento záznam? (Urobil som})",
        "confirm_before_delete_from_db_title": "Natrvalo odstrániť",
        "confirm_before_delete_from_db_btn": "Odstrániť",
        "block_user_msg": "Naozaj chcete zablokovať používateľa {name}? Osoba sa potom už nemôže prihlásiť.",
        "block_user_title": "Kontrolný blok",
        "block_user_btn": "Uzamknite sa",
        "unblock_user_msg": "Naozaj chcete odblokovať používateľa {name}? Osoba sa potom môže znova prihlásiť.",
        "unblock_user_title": "Odomknúť prihlásenie",
        "unblock_user_btn": "Odomknúť",
        "tour": {
            "menu_title": "oblasti",
            "menu": "Tu vidíte rôzne oblasti správy, v ktorých môžete ukladať a upravovať kmeňové dáta a vykonávať konfigurácie.",
            "client_menu_title": "Riadiť spoločnosti",
            "client_menu": "Tu môžete pridávať, zobrazovať alebo upravovať svoje spoločnosti.",
            "client_list": "Tu si môžete pozrieť zoznam všetkých spoločností.",
            "new_client": "Kliknutím sem vytvoríte spoločnosť.",
            "view_mode": "<p>Tu môžete prepnúť zo zobrazenia zoznamu do zobrazenia tabuľky, aby ste mohli uložiť viacero záznamov kmeňových dát naraz alebo aby ste mali lepší prehľad.</p> Zobrazenie tabuľky je užitočné napríklad aj pri exporte alebo importe dát. . Po úprave nezabudnite tabuľku uložiť."
        }
    },
    "version": "Verzia",
    "yes": "A",
    "no": "Nie",
    "recommended": "Odporúčané",
    "never": "NIE",
    "add": "Pridať",
    "save": "Uložiť",
    "cancel": "Zrušiť",
    "apply": "Použiť",
    "edit": "Upraviť",
    "delete": "Odstrániť",
    "next": "Ďalej",
    "back": "späť",
    "finish": "Skončiť",
    "ok": "Dobre",
    "open": "OTVORENÉ",
    "dashboard": "Dashboard",
    "dashboards": "Dashboards",
    "einvoice_dashboard": "Dashboard e‑faktúr",
    "invoice_dashboard": "Incoming Invoice Dashboard",
    "outgoing_invoice_dashboard": "Outgoing Invoice Dashboard",
    "overview": "Prehľad",
    "operator": "Operátor",
    "profile": "Profil",
    "help": "Pomoc",
    "logout": "Odhlásiť sa",
    "tenant_switcher": {
        "error": "Tenant sa nepodarilo zmeniť.",
        "error_passkey": "Prepnutie tenantu nie je dostupne pre passkey relacie.",
        "error_saml": "Tento tenant nie je mozne otvorit z aktualnej SSO relacie."
    },
    "list_view": "Zobrazenie zoznamu",
    "table_view": "Tabuľkový pohľad",
    "archive": "archív",
    "active": "Aktívne",
    "email": "E-mail",
    "name": "názov",
    "tax": "daň (%)",
    "value": "Suma",
    "number": "číslo",
    "currency": "mena",
    "actions": "Akcia",
    "system": "Systém",
    "from": "od",
    "of": "z",
    "until": "bis",
    "up_to": "bis",
    "show_more": "Zobraziť viac",
    "refresh": "Obnoviť",
    "calculate": "Vypočítať",
    "calc_brutto_from_net": "Vypočítať hrubú zo čisté",
    "calc_net_from_brutto": "Vypočítať čistú z hrubej",
    "cost_center_id": "Nákladové stredisko",
    "cost_centers": "Nákladové strediská",
    "budget_id": "Rozpočet",
    "budgets": "Rozpočty",
    "branch_id": "Pobočka",
    "branches": "Pobočky",
    "employee_id": "Zamestnanec",
    "employees": "Zamestnanec",
    "vehicles": "Motorové vozidlá",
    "financial_dimension_id": "Finančný rozmer",
    "financial_dimensions": "Finančný rozmer",
    "tax_group_id": "Skupina dane z predaja",
    "tax_groups": "Skupiny dane z predaja",
    "tax_item_group_id": "Skupina položiek dane z predaja",
    "tax_item_groups": "Skupiny položiek dane z predaja",
    "profit_center_id": "Ziskové stredisko",
    "profit_centers": "Zisková centrá",
    "client_id": "Spoločnosť",
    "clients": "Spoločnosť",
    "department_id": "oddelenie",
    "departments": "oddelenia",
    "d365_branch_id": "Pobočka",
    "d365_employee_id": "Zamestnanec",
    "d365_department_id": "D365 oddelenie",
    "d365_area_id": "D365 oblasť",
    "d365_labor_wert_id": "D365 laboratórna hodnota",
    "d365_project_id": "D365 projekt",
    "d365_sales_channel_id": "D365 predajný kanál",
    "d365_vehicle_id": "Motorové vozidlo",
    "d365_branches": "Pobočky",
    "d365_employees": "Zamestnanec",
    "d365_departments": "D365 oddelenia",
    "location_id": "Poloha",
    "consignee_id": "Príjem tovaru",
    "address_id": "Adresa dodania",
    "cost_type_id": "Typ nákladu",
    "lb_user_id": "Osoba",
    "users": "osôb",
    "task_group_id": "Skupina úloh",
    "task_groups": "Skupiny úloh",
    "user_task_group": "Používateľ/Skupina úloh",
    "user_task_groups": "Používatelia/Skupiny úloh",
    "products": "Katalóg produktov",
    "product_group_id": "Skupina produktov",
    "product_groups": "Skupiny produktov",
    "supplier_id": "Dodávateľ",
    "business_partner_id": "Obchodný partner",
    "suppliers": "Dodávateľ",
    "business_partners": "Obchodní partneri",
    "procurement_id": "Nákupná objednávka",
    "procurements": "Požiadavky na nákup",
    "contract_id": "Zmluva",
    "contracts": "Zmluvy",
    "user_select_product_id": "Osoba „výber produktu“.",
    "user_send_order_id": "Osoba „úloha“",
    "user_clearing_id": "Osoba „objasňujúca nákup“",
    "user_consignee_id": "Osoba „Príjem tovaru“.",
    "user_invoice_manual_check_id": "Osoba „Manuálna kontrola (faktúra)“",
    "user_invoice_clearing_id": "Osoba „objasnenie účtovníctva“",
    "user_accounting_id": "Používateľ „Účtovníctvo“",
    "user_contract_clearing_id": "Osoba „objasnenie zmluvy“",
    "ledger_account_id": "Účet hlavnej knihy",
    "ledger_accounts": "Účty hlavnej knihy",
    "posting_key_id": "Daňový kľúč",
    "posting_keys": "Daňový kľúč",
    "permission_id": "Skupina povolení",
    "permissions": "Autorizačné skupiny",
    "invoices": "účty",
    "invoice_id": "Faktúra",
    "outgoing_invoice_id": "Odchádzajúca faktúra",
    "outgoing_invoices": "Výstupné faktúry",
    "incoming_revenue_type": "Typ príjmu",
    "incoming_revenue_type_id": "Typ príjmu",
    "configurations": "Konfigurácie",
    "marketplace_id": "Trhovisko",
    "provider_id": "Poskytovateľ trhoviska",
    "notes": "Poznámka",
    "search": "Hľadaj",
    "no_data": "Nenašli sa žiadne záznamy",
    "months": "Sladké",
    "select_valid_option": "Vyberte platný záznam.",
    "price_restricted": "Informácie o cenách sú momentálne deaktivované.",
    "procurement_line": {
        "description": "Produkt",
        "item_number": "Číslo položky",
        "is_cost_center_fixed": "Blokovať nákladové stredisko pre túto položku",
        "image_url": "Adresa URL obrázka",
        "webshop_url": "Adresa URL obchodu",
        "offer_number": "Číslo ponuky",
        "offer_date": "Dátum ponuky",
        "include_tax": "vrátane {tax} DPH",
        "offer_msg": "Po ponuke {offer_number}",
        "offer_date_msg": "od {offer_date}",
        "delivery_completed": "Položka dokončená",
        "total_price_brutto": "Celková hrubá suma",
        "total_price_netto": "Celková čistá suma",
        "type_total_price_brutto": "currency",
        "type_price_brutto": "currency",
        "type_total_price_netto": "currency",
        "type_price_netto": "currency"
    },
    "product_catalog": {
        "description": "Článok",
        "alias": "Popis pre vyhľadávanie",
        "item_number": "Číslo položky",
        "is_cost_center_fixed": "Blokovať nákladové stredisko pre túto položku",
        "image_url": "Adresa URL obrázka",
        "webshop_url": "Adresa URL obchodu",
        "offer_number": "Číslo ponuky",
        "offer_date": "Dátum ponuky",
        "type_price_netto": "currency",
        "type_price_brutto": "currency",
        "form_sequence": "name,item_number,product_group_id,supplier_id,location_id,cost_center_id,is_cost_center_fixed,tax,price_netto,price_brutto,unit,image_url,webshop_url,offer_number,offer_date",
        "page": {
            "new": "Nový produkt",
            "supplier_tooltip": "Vyberte doručovaciu spoločnosť z kmeňových údajov alebo pridajte novú zadaním nového názvu.",
            "supplier_new_tooltip": "Tento dodávateľ sa uloží do vašich kmeňových údajov, keď pridáte produkt.",
            "should_save": "Uložiť do katalógu produktov",
            "sections": {
                "basic": "Základné údaje",
                "supplier": "Klasifikácia a dodávateľ",
                "pricing": "Ceny a daň",
                "accounting": "Účtovanie",
                "media_offer": "Médiá a ponuka",
                "permissions": "Oprávnenia"
            },
            "validation": {
                "name_required": "Zadajte meno.",
                "supplier_required": "Vyberte doručovaciu spoločnosť alebo zadajte novú.",
                "image_url_invalid": "Prosím vložte platnú URL.",
                "webshop_url_invalid": "Prosím vložte platnú URL.",
                "tax_invalid": "Uveďte platnú daň."
            },
            "tour": {
                "name": "Zadajte zmysluplný názov produktu.",
                "number": "Tu môžete zadať číslo položky produktu.",
                "product_group": "Vyberte, do ktorej skupiny produktov produkt patrí.",
                "supplier": "Vyberte, ktory dodávateľ produkt ponúka alebo u ktorej si ho chcete objednať.",
                "price": "Zadajte sadzbu dane a čistú alebo brutto cenu. Ďalšia cena sa potom vypočíta pomocou sadzby dane.",
                "unit": "Zadajte jednotku, v ktorej sa výrobok meria, napr. „kus“, „kg“ alebo „liter“.",
                "url": "Tu môžete pridať adresu URL obrázka k produktu. Môžete tiež pridať odkaz na stránku položky obchodu, ak je k dispozícii.",
                "offer": "Ak existuje ponuka na produkt, je možné sem zadať číslo a dátum ponuky, aby sa zobrazili v objednávkovom PDF.",
                "btn_save": "Po pridaní všetkých informácií uložte produkt do katalógu produktov."
            }
        }
    },
    "product_group": {
        "form_sequence": "name,description,user_select_product_id",
        "page": {
            "new": "Nová skupina produktov",
            "no_product_group": "Bez skupiny položiek",
            "validation": {
                "name_required": "Zadajte meno."
            },
            "tour": {
                "name": "Zadajte zmysluplný názov pre skupinu produktov.",
                "btn_save": "Po zadaní všetkých informácií pridajte skupinu produktov."
            }
        }
    },
    "procurement": {
        "description": "Nákupná objednávka",
        "order_description": "Objednávka",
        "name": "Označenie",
        "number": "Číslo objednávky",
        "order_number_formatted": "Číslo objednávky",
        "contract_number": "Číslo zmluvy",
        "creator_id": "Vytvoril(a)",
        "created_at": "Dátum vytvorenia",
        "delivery_date": "dátum doručenia",
        "delivery_address_id": "Adresa dodania",
        "billing_address_text": "fakturačná adresa",
        "status": "Postavenie",
        "show_notes_pdf": "Zobraziť v PDF objednávky",
        "open_value": "Otvorená hodnota objednávky",
        "open_value_recurring": "∞ dKueZ",
        "open_value_exceeds_with_invoice": "Táto faktúra prekračuje hodnotu objednávky.",
        "total_brutto": "Celkom s DPH",
        "total_netto": "Celková netto",
        "total_netto_abbr": "-Sieť",
        "payment_in_advance": "Platba vopred",
        "has_invoices": "Faktúra zaevidovaná",
        "invoice_count": "Faktúry (množstvo)",
        "completely_invoiced": "Úplne fakturované",
        "is_fully_allocated": "Úplne fakturované",
        "payment_timing": "Typ platby",
        "usage_type": "Frekvencia",
        "type": "Typ objednávky",
        "type_options": {
            "single_invoice": "eKuez s jednou faktúrou",
            "recurring_invoice": "dKuez s jednou faktúrou",
            "recurring_contract": "dKuez s opakovanou faktúrou"
        },
        "statuses": {
            "open": "Výber produktu",
            "approved": "uvedenie do prevádzky",
            "ordered": "Čakanie na doručenie",
            "declined": "Odmietnuté",
            "completed": "Dokončené",
            "approval": "Schválenie",
            "clearing": "Objasnenie nákupu",
            "draft": "Návrh"
        },
        "page": {
            "ai_fill_menu": "Vyplniť objednávku pomocou AI",
            "completely_invoiced_auto_tooltip": "Automaticky označené systémom, pretože suma alokovaná faktúrami je rovnaká alebo vyššia ako hodnota objednávky.",
            "completely_invoiced_final_invoice_tooltip": "Označené ako úplne fakturované pomocou {invoices}.",
            "completely_invoiced_final_invoice_tooltip_prefix": "Označené ako úplne fakturované pomocou ",
            "completely_invoiced_final_invoice_tooltip_separator": ", ",
            "completely_invoiced_final_invoice_tooltip_suffix": ".",
            "ai": {
                "title": "Asistent nákupu (AI)",
                "months": "Obdobie (mesiace)",
                "products_limit": "Produkty (počet)",
                "suppliers_limit": "Dodávatelia (počet)",
                "contracts_limit": "Zmluvy (počet)",
                "order_without_template_btn": "Objednať bez šablóny",
                "or_create_based_on_existing_msg": "alebo vytvorte novú objednávku na základe nasledujúcich existujúcich objednávok alebo zmlúv:",
                "recent_products": "Vaše naposledy objednané produkty",
                "top_products": "Top produkty",
                "top_suppliers": "Top dodávatelia",
                "orders_count": "{n} objednávok",
                "active_contracts": "Aktívne zmluvy",
                "contract_end_date": "Dátum ukončenia",
                "procurements_count": "{n} objednávok",
                "loading_text": "Spracováva sa návrh AI…",
                "processing_title": "Vytvára sa vaša objednávka pomocou AI",
                "processing_subtitle": "Môže to trvať 15–20 sekúnd. Prosím, nechajte túto stránku otvorenú.",
                "invoices_count": "{n} faktúr",
                "msg_success": "Údaje objednávky boli automaticky predvyplnené",
                "msg_not_found": "Nenašla sa žiadna zodpovedajúca objednávka",
                "msg_failed": "Návrh AI zlyhal",
                "msg_not_possible": "Predvyplnenie AI nie je možné"
            },
            "new_from_contract": "Objednávka zo zmluvy",
            "no_delivery_address": "Žiadna doručovacia adresa",
            "no_budget": "Žiadny rozpočet",
            "new": "Nová požiadavka na nákup",
            "create_btn": "Spustite požiadavku na nákup",
            "copy_btn_tooltip": "Kopírovať žiadosť o objednávku",
            "magic_suggestions_btn_tooltip": "Získajte inteligentné návrhy na základe dynamických kritérií (nedávne nákupy, dodávatelia, zmluvy). Podľa nastavení nájomcu môžu vzniknúť náklady na AI.",
            "magic_suggestions_no_data": "Pre vybrané kritériá sa nenašli žiadne návrhy AI.",
            "magic_suggestions_applied": "Návrhy AI boli použité.",
            "magic_suggestions_dialog": {
                "title": "Návrhy pre túto požiadavku na nákup",
                "message": "Vyberte polia, ktoré chcete vyplniť na základe návrhov AI.",
                "info_based_on_last_order": "Tento návrh bol vygenerovaný AI na základe vašej poslednej objednávky.",
                "no_data": "Pre túto požiadavku na nákup neboli nájdené žiadne návrhy."
            },
            "offer_document": {
                "add_from_document": "Pridať z ponuky",
                "dialog_title": "Importovať položky z ponuky",
                "loading_text": "Rozpoznávanie ponuky...",
                "upload_info1": "Presuňte PDF ponuky sem <br>alebo <br> <em>vyberte súbor</em>.",
                "upload_info2": "PDF súbory do 30 MB.",
                "preview_message": "Vyberte položky, ktoré sa majú pridať ako produkty.",
                "no_lines": "Nenašli sa žiadne položky ponuky.",
                "new_upload": "Zahodiť a nahrať znova",
                "retry": "Skúsiť znova",
                "retry_wait": "alebo počkajte ešte niekoľko sekúnd",
                "file_invalid": "Nahrávajte iba PDF súbory.",
                "file_too_large": "Nahrávajte iba súbory do 30 MB.",
                "extract_failed": "Ponuku sa nepodarilo rozpoznať.",
                "file_save_failed": "PDF ponuky sa nepodarilo uložiť.",
                "lines_applied": "Položky ponuky boli pridané.",
                "supplier_required": "Pred importom položiek vyberte dodávateľa.",
                "supplier_recognized": "Rozpoznaný dodávateľ: {supplier_name}.",
                "supplier_missing": "Vyberte alebo vytvorte dodávateľa.",
                "create_supplier": "Vytvoriť \"{supplier_name}\"",
                "create_supplier_confirm_title": "Vytvoriť dodávateľa",
                "create_supplier_confirm_message": "Chcete vytvoriť \"{supplier_name}\" ako nového dodávateľa?",
                "create_supplier_confirm_btn": "Vytvoriť",
                "create_supplier_success": "Dodávateľ vytvorený.",
                "create_supplier_failed": "Dodávateľa sa nepodarilo vytvoriť.",
                "supplier_note_website": "Web",
                "supplier_note_contact": "Kontakt",
                "supplier_note_extra_ibans": "Ďalšie IBANy"
            },
            "delivery_date_tooltip": "Dátum dodania je vytlačený na objednávkovom PDF a môže byť následne zaslaný doručovacej spoločnosti.",
            "order_sender": "uvedenie do prevádzky",
            "product_selector": "Výber produktu",
            "product_search": "Vyhľadajte produkty",
            "before_leave_msg": "Vaša požiadavka na objednávku nebola uložená. Naozaj chcete opustiť stránku?",
            "confirm_without_approval_limit_msg": "Žiadna z vybratých osôb nemá potrebný limit uvoľnenia pre hodnotu tejto objednávky. Príslušné vydania môžu byť pridané neskôr. Ste si istý, že chcete pokračovať?",
            "confirm_without_approval_limit_title": "Limit uvoľnenia",
            "confirm_product_selection_without_product_msg": "Nevybrali ste produkt. Ste si istý, že chcete pokračovať?",
            "confirm_product_selection_without_product_title": "Nie je vybraný žiadny produkt",
            "no_approval_limit_msg": "Váš limit zúčtovania nie je dostatočný pre túto objednávku. Pridajte na schválenie ďalšiu osobu, ktorá má dostatočný limit schválenia.",
            "no_approval_limit_title": "Limit uvoľnenia",
            "product_group_missing_msg": "Všetky produkty musia byť zaradené do skupiny produktov. Prejdite na kartu Skupiny produktov nad zoznamom produktov a priraďte každý produkt ku skupine produktov.",
            "product_group_missing_title": "Priradiť skupinu produktov",
            "product_group_missing_btn": "Rozumel",
            "min_approval_one_person": "1 osoba",
            "min_approval_qty": "{qty} rôznych ľudí",
            "min_approval_error_msg": "Vydanie nie je dostatočné pre túto kúpnu požiadavku. Pridajte ďalšiu osobu na zdieľanie. Táto požiadavka na nákup musí byť schválená <b>aspoň {min_approval_msg}</b>.",
            "min_approval_error_title": "Uvoľnenie nie je dostatočné",
            "order_not_completed_msg": "Nezadali ste ani nepotvrdili všetky objednávky. V zozname produktov sa uistite, že ste si objednali všetky produkty a v prípade potreby ich potvrďte pre pokračovanie.",
            "order_not_completed_title": "Najprv zadajte objednávky",
            "order_not_completed_btn": "Rozumel",
            "confirm_delivery_not_completed_msg": "Nepotvrdili ste všetky príjemky tovaru. Naozaj chcete dokončiť požiadavku na nákup? <br> <i>Túto akciu nie je možné vrátiť späť</i>.",
            "confirm_delivery_not_completed_title": "Čakajúce potvrdenky o tovare",
            "confirm_delivery_not_completed_btn": "Dokončiť",
            "default_confirm_btn": "ďalej",
            "budget_exceeded_msg": "Rozpočet bol prekročený",
            "approval_limit_exceeded_msg": "Prekročený limit uvoľnenia",
            "external_order_number_msg": "Zadajte externé číslo objednávky.",
            "external_order_number_title": "Zadajte externé číslo objednávky",
            "no_edit_permission": "Nemáte povolenie na úpravu údajov. Ak chcete vykonať zmeny v údajoch, odošlite žiadosť o objednávku prostredníctvom akcií na objasnenie.",
            "add_invoice_after_order_message": "Faktúru môžete vytvoriť po spustení požiadavky na nákup.",
            "no_invoice": "Pre túto požiadavku na nákup zatiaľ neboli zaevidované žiadne faktúry.",
            "tabs": {
                "lines": "Položky",
                "invoices": "Faktúry"
            },
            "delivery_dialog": {
                "title": "Potvrďte príjem tovaru",
                "confirm_btn": "Potvrďte",
                "message": "Zadajte posledné prijaté množstvo.<br> Chýba <b>{missing_qty} z {quantity}</b> {unit}.",
                "qty_exceeded_msg": "Chýbajúce množstvo tovaru nesmie byť prekročené.",
                "qty_must_be_greater_msg": "Množstvo tovaru musí byť väčšie ako 0.",
                "invalid_format": "Použite platný formát čísla."
            },
            "order_sender_dialog": {
                "title": "Predbežné zadanie úlohy",
                "info": "Osoba v kroku „Objednávka“ je výsledkom rôznych predbežných pridelení zodpovedných ľudí podľa oddelenia, spoločnosti, predbežného pridelenia globálnej role a osoby, ktorá objednávku vytvorila. Osoba v hornej časti zoznamu je vopred priradená k úlohe."
            },
            "consignee_dialog": {
                "title": "Predbežné pridelenie z príjmu tovaru",
                "info": "Osoba v kroku „Prijatie tovaru“ je výsledkom rôznych predbežných pridelení zodpovedných ľudí podľa oddelenia, spoločnosti, predbežného priradenia globálnej role a osoby, ktorá vytvorila objednávku. Osoba v hornej časti zoznamu je vopred priradená k úlohe."
            },
            "select_product_dialog": {
                "title": "Predbežné zadanie výberu produktu",
                "info": "Osoba v kroku „Výber produktu“ je výsledkom rôznych predbežných pridelení zodpovedných ľudí podľa oddelenia, spoločnosti, predbežného pridelenia globálnej role a osoby, ktorá vytvorila objednávku. Osoba v hornej časti zoznamu je vopred priradená k úlohe."
            },
            "marketplace_change_dialog": {
                "title": "Objednávka bude zrušená",
                "info": "Bola zistená zmena spoločnosti. Na trhu {marketplace_name} však existuje objednávka, ktorá nie je spojená s novou spoločnosťou {client_name}. Ak budete pokračovať, táto objednávka bude zrušená.",
                "btn_confirm": "Zrušiť objednávku"
            },
            "dialog_assignment": {
                "department_form": "Oddelenie vo formulári",
                "department_creator": "Oddelenie objednávateľa",
                "client_form": "Spoločnosť vo forme",
                "client_creator": "Spoločnosť osoby, ktorá zadáva objednávku",
                "no_selection": "ešte nevybraté",
                "no_action": "nepoužiteľné",
                "configuration": "Globálne predvolené"
            },
            "draft": {
                "title": "Návrh",
                "save": "uložiť koncept",
                "delete": "Odstrániť návrh",
                "confirm_before_delete_msg": "Naozaj chcete natrvalo odstrániť tento koncept?",
                "confirm_before_delete_title": "Odstrániť návrh",
                "confirm_before_delete_btn": "Odstrániť"
            },
            "punchout": {
                "pending_msg": "Existujú vynikajúce produkty z punču.",
                "error_title": "Chyba pri vyrazení",
                "error_msg": "Došlo k chybe. Skontrolujte konfigurácie vytlačenia alebo kontaktujte niekoho s oprávneniami správcu.",
                "error_start_url_msg": "Nebola poskytnutá žiadna spúšťacia adresa URL, takže Punch-out nie je možné spustiť.",
                "error_invalid_domain_msg": "Prihlasovacie údaje sú neplatné. Skontrolujte konfiguráciu punch-out alebo kontaktujte svojho administrátora.",
                "error_invalid_credentials_msg": "{provider} odmietol prihlásenie pre e-mail \"{email}\", pretože doména \"{domain}\" nie je povolená v účte {provider}. Punch-out preto nie je možné spustiť.",
                "no_config": "Najprv uložte konfiguráciu, aby ste mohli použiť dierovanie.",
                "no_config_by_client": "Tento dodávateľ nie je povolený pre aktuálne vybranú spoločnosť. <br>Prosím, vyberte kompatibilnú spoločnosť alebo upravte nastavenia.",
                "pending_dialog": {
                    "title": "Čakajúce produkty z punchout",
                    "add_products": "Pridať do objednávky",
                    "add_all_products": "Pridajte všetko do objednávky",
                    "delete_products": "Odstráňte produkty"
                },
                "log_dialog": {
                    "title": "{supplier_name} Žiadosť",
                    "request": "Žiadosť",
                    "response": "Odpoveď",
                    "no_log": "Žiadny záznam",
                    "url": "Url",
                    "header": "Header",
                    "method": "Method",
                    "body": "Body"
                },
                "delete_dialog": {
                    "title": "Odstrániť produkty od {supplier} #{index}",
                    "info1": "Naozaj chcete odstrániť všetky nasledujúce produkty z {supplier} #{index}?",
                    "info2": "Túto akciu nie je možné vrátiť späť.",
                    "delete_btn": "Odstrániť"
                },
                "loading": "Dokončite výber produktu v kontextovom okne, ktoré sa otvorí. Ak sa neotvorí žiadne kontextové okno, musíte ho najskôr povoliť.",
                "can_not_edit": "Vyrazené výrobky nie je možné meniť. Vykonajte dierovanie znova. alebo vymažte celý nákupný košík.",
                "no_provider_found": "Žiaľ, vybraný poskytovateľ dierovania momentálne nie je podporovaný."
            },
            "download_pdf": {
                "title": "Stiahnuť PDF",
                "confirm_btn": "Potvrdiť",
                "title_confirm_save_changes": "Uložiť neuložené údaje",
                "text_confirm_save_changes": "Chcete uložiť neuložené údaje a aplikovať ich na dokument o nákupe?",
                "invalid_form": "Prosím, vyplňte všetky povinné polia vo formulári pred pokračovaním v akcii."
            },
            "lines": {
                "no_line": "Nie sú vybraté žiadne produkty, pridajte produkty.",
                "add_lines_from_contract": "Pridať všetky položky zo zmluvy",
                "show_all_info": "rozšírený pohľad",
                "invoice": {
                    "title": "Faktúra",
                    "created_at": "Zaznamenané",
                    "date": "Dátum faktúry",
                    "created_by": "Vytvoril"
                },
                "automatic_order": "Odoslať elektronicky",
                "automatic_ordered": "Zaslané elektronicky",
                "supplier_connect_order": "Odoslať cez SupplierConnect",
                "manual_order_confirmation": "Potvrdiť ručne",
                "confirm_order": "Potvrďte objednávku",
                "finish_order": "Dokončite zadanie",
                "order_finished": "Komisia dokončená",
                "confirm_order_tooltip": "Upozorňujeme, že objednávku musíte zadať doručovacej spoločnosti <b>e-mailom</b>, <br> objednávka sa <b>neprenesie elektronicky.</b>",
                "ordered_at": "Prenesené",
                "ordered_by": "Objednal",
                "confirm_receipt": "Potvrďte príjem tovaru",
                "no_cost_center": "Žiadne nákladové stredisko",
                "include_taxes": "vrátane DPH",
                "budget": "Rozpočet",
                "no_budget": "Žiadny rozpočet",
                "no_product_group": "Žiadna skupina produktov",
                "no_ledger_account": "Žiadny účtovný účet",
                "select_product": "Výber produktu",
                "quantity_to_show": "prijaté: <b>{quantity_received}/{quantity}</b>",
                "delivery_completed": "Položka dokončená",
                "from": "z",
                "item_number": "Položka č. #",
                "delete_msg": "Naozaj chcete odstrániť tento produkt?",
                "delete_title": "Odstráňte produkt",
                "delete_btn": "Odstrániť",
                "automatic_order_dialog": {
                    "confirm_order": "Odošlite žiadosť",
                    "confirm_order_btn": "Predložiť",
                    "finish_order": "dokončiť objednávku",
                    "finish_order_btn": "Dokončiť",
                    "info1": "Chcete túto objednávku zaslať <span style=\"font-weight: bold\">teraz záväzne elektronicky </span>doručovacej spoločnosti <span style=\"font-weight: bold\">?</span>",
                    "info2": "Túto akciu nie je možné vrátiť späť."
                },
                "order_dialog": {
                    "confirm_order": "Potvrďte objednávku",
                    "confirm_order_btn": "Potvrďte",
                    "finish_order": "Dokončite zadanie",
                    "finish_order_btn": "Dokončiť",
                    "info1": "Poslali ste objednávku doručovacej spoločnosti? (napr. e-mailom alebo faxom)",
                    "info2": "Túto akciu nie je možné vrátiť späť."
                },
                "more_actions": {
                    "delete_products": "Odstráňte produkty",
                    "add_external_id": "Zadajte externé číslo objednávky",
                    "download_pdf": "Objednávka (PDF)",
                    "download_pdf_with_attachments": "Objednávka vrátane prílohy PDF",
                    "write_email": "Písať",
                    "email_with_pdf": "E-Mail vrátane PDF",
                    "show_cxml": "Zobraziť Punchout CXML"
                },
                "file": {
                    "open_btn": "Otvorte PDF",
                    "add_btn": "Pridať PDF",
                    "upload_info1": "Presuňte myšou <br>alebo <br> <em>Vyberte súbor</em>.",
                    "upload_info2": "Súbory PDF do veľkosti 10 MB.",
                    "delete_msg": "Naozaj chcete odstrániť tento dokument?",
                    "delete_title": "Odstrániť dokument",
                    "delete_btn": "Odstrániť",
                    "delete_error_msg": "Dokument sa nepodarilo odstrániť."
                }
            },
            "validation": {
                "delivery_date_format": "Zadajte dátum doručenia.",
                "client_id_required": "Vyberte spoločnosť.",
                "department_id_required": "Vyberte oddelenie.",
                "department_id_required_client_missing": "Najprv vyberte firmu.",
                "cost_center_id_required": "Vyberte nákladové stredisko.",
                "cost_center_id_required_filters_missing": "Najprv vyberte firmu a oddelenie.",
                "cost_center_id_required_department_missing": "Najprv vyberte oddelenie.",
                "cost_center_id_required_client_missing": "Najprv vyberte firmu.",
                "ledger_account_id_required": "Vyberte, prosím, účtovný účet.",
                "consignee_id_required": "Vyberte zodpovednú osobu.",
                "delivery_address_id_required": "Vyberte dodaciu adresu.",
                "billing_address_text_required": "V konfigurácii spoločnosti chýba fakturačná adresa.",
                "usage_type_required": "Vyberte rytmus.",
                "payment_timing_required": "Vyberte typ platby."
            },
            "tour": {
                "main": {
                    "description": "V prvých poliach uveďte názov žiadosti o objednávku, svoju spoločnosť a oddelenie, pre ktoré má byť objednávka uskutočnená. Oddelenie sa filtruje podľa spoločnosti a nákladové stredisko podľa oddelenia.",
                    "organization": "Tu zadáte firmu, oddelenie a nákladové stredisko, pre ktoré sa má zadať požiadavka na nákup. Oddelenie je filtrované podľa spoločnosti a nákladové stredisko podľa oddelenia.",
                    "address": "Dodacia adresa, ktorú je potrebné oznámiť doručovacej spoločnosti. Môžete si vybrať z adries spoločnosti, príjemcu tovaru a vašich adries.",
                    "total": "Tu vidíte celkovú hodnotu vašej objednávky, ktorá je súčtom vybraných produktov.",
                    "delivery_date": "Dátum dodania je možné zaznamenať na účely dokumentácie po prevzatí tovaru. Nebude zaslaný doručovacej spoločnosti.",
                    "product_selector": "Tu môžete vidieť, ktorá osoba je zodpovedná za výber produktu v ďalšom kroku. Závisí to od rôznych predzadaní, ktoré si môžete podrobnejšie pozrieť po kliknutí na ikonu info.",
                    "order_sender": "Tu vidíte, ktorá osoba je zodpovedná za zadanie objednávky v predposlednom kroku. Závisí to od rôznych predzadaní, ktoré si môžete podrobnejšie pozrieť po kliknutí na ikonu info.",
                    "consignee": "Tu vyberte osobu, ktorá má tovar prevziať. V poslednom kroku žiadosti o objednávku potom vybraná osoba potvrdí prijatie objednaného tovaru a dokončí požiadavku na objednávku.",
                    "approvers": "Tu môžete vidieť, či bolo pre vybrané nákladové stredisko nakonfigurované vydanie. Môžete tiež pridať viac ľudí na zdieľanie.",
                    "product_search": "Tu môžete vyhľadať produkt z interného katalógu produktov a pridať ho do požiadavky na objednávku.",
                    "punchout": "Tu si môžete vybrať produkty z integrovaných trhovísk, ako sú Amazon alebo Mercateo. Po schválení požiadavky na objednávku je možné takto uskutočnený výber produktov jednoducho elektronicky preniesť na trhovisko a tak objednať.",
                    "new_product": "Ak Vami požadovaný produkt ešte nie je v katalógu produktov, môžete ho pridať do požiadavky objednávky tu.",
                    "save_btn": "Po zhromaždení všetkých informácií môžete spustiť požiadavku na objednávku a presunúť ju na ďalší krok."
                },
                "product": {
                    "pdf": "Kliknutím sem môžete pridať dokumenty k produktu.",
                    "remove": "Produkty môžete z výberu aj odstrániť kliknutím sem.",
                    "more_actions": "Po prijatí tu môžete zadať číslo externej objednávky.",
                    "tabs": "Tu môžete zoskupiť pohľad na vaše produkty podľa doručovacej spoločnosti, nákladového strediska alebo skupiny produktov.",
                    "expand_view": "Tu môžete zobraziť alebo skryť rozšírené nastavenia pre produkty, aby ste im mohli priradiť nákladové stredisko, dodaciu adresu alebo skupinu produktov."
                },
                "new_product": {
                    "name": "Zadajte zmysluplný názov produktu.",
                    "number": "Môžete tiež zadať číslo výrobku pre produkt.",
                    "supplier": "Vyberte, ktory dodávateľ produkt ponúka alebo u ktorej si ho chcete objednať.",
                    "price": "Zadajte sadzbu dane a čistú alebo brutto cenu. Ďalšia cena sa potom vypočíta pomocou sadzby dane.",
                    "unit": "Uveďte jednotku, v ktorej sa výrobok meria, napr. Napríklad „kus“, „kg“ alebo „liter“.",
                    "url": "Tu môžete pridať adresu URL obrázka k produktu. Môžete tiež pridať odkaz na stránku položky obchodu, ak je k dispozícii.",
                    "offer": "Ak existuje ponuka na produkt, je možné sem zadať číslo a dátum ponuky, aby sa zobrazili v objednávkovom PDF.",
                    "should_save": "Tu si môžete vybrať, či sa má nový produkt uložiť do katalógu produktov. To znamená, že konkrétny produkt je možné pridať aj do ďalších objednávok.",
                    "save_btn": "Po zhromaždení všetkých informácií pridajte produkt do požiadavky na nákup."
                },
                "cost_center_view": "Nákladové strediská môžu byť tiež priradené k jednotlivým produktom v požiadavke na nákup. Pre produkt je potom možné zvoliť dodacie adresy uložené v nákladovom stredisku.",
                "product_group_view": "Každému produktu je možné priradiť skupinu produktov. Osoba zodpovedná za skupinu produktov potom dostane na časovej osi úlohu upraviť alebo potvrdiť výber produktov.",
                "send_order": {
                    "send_btn": "V objednávkovom kroku môžete objednávku odoslať elektronicky alebo objednávku zadanú doručovateľskej spoločnosti potvrdiť emailom.",
                    "more_actions": "Vo voľbách pre vybrané doručovacie spoločnosti si môžete vygenerovať objednávkové PDF alebo e-mail s alebo bez objednávkového PDF doručovacej spoločnosti. Týmto spôsobom môžete zadať objednávku spoločnosti alebo napr. B. objasniť dotaz e-mailom."
                },
                "delivery_btn": "Ak ste dostali čiastočnú dodávku alebo celý tovar, môžete to uviesť tu. Položky tu môžete tiež označiť ako dokončené. Potvrdené prevzatie tovaru je následne zaznamenané aj v časovej osi."
            }
        }
    },
    "quantity": "Dav",
    "price_netto": "Internetová cena",
    "price_brutto": "Hrubá cena",
    "unit": "Jednotka",
    "default_unit": "Kus",
    "tenant": {
        "tab_general": "Všeobecné informácie",
        "description": "Nájomca",
        "main_language": "Jazyk náhrady",
        "show_invoices": "Zobraziť ponuku faktúr",
        "monthly_document_limit": "Dokumenty za mesiac",
        "base_price": "Základná cena",
        "price_extra_document": "Cena každého ďalšieho dokumentu",
        "monthly_procurement_limit": "BANF mesačne v základnej cene",
        "monthly_invoice_limit": "Vyúčtovanie mesačne v základnej cene",
        "base_price_procurement": "Základná cena BANF",
        "base_price_invoice": "Fakturačná základná cena",
        "price_extra_procurement": "Cena každej ďalšej objednávky",
        "price_extra_invoice": "Cena každej ďalšej faktúry",
        "invoice_recognition_unit_price": "Cena za rozpoznanie faktúry na dokument",
        "invoice_recognition_custom_field_unit_price": "Cena za doklad s vlastnými poľami",
        "ai_validation_unit_price": "Cena za validáciu AI vrátane skórovania na doklad",
        "easybill_id": "Easybill ID",
        "bank_account": "Číslo účtu",
        "bank_account_owner": "Osoba, ktorá vedie účet",
        "bank_bic": "BIC",
        "bank_country": "Krajina banky",
        "bank_code": "Smerové číslo banky",
        "bank_iban": "IBAN",
        "bank_name": "názov banky",
        "address": "fakturačná adresa",
        "sepa_agreement": "Schéma SEPA inkasa",
        "sepa_agreement_date": "SEPA - dátum prijatia poverenia",
        "sepa_mandate_reference": "Referencia mandátu",
        "automatic_billing": "Automaticky vytvoriť fakturáciu",
        "automatic_billing_mail": "Posielajte fakturáciu automaticky e-mailom",
        "bank": "Bankové údaje",
        "datev": "DATEV",
        "billing_address_name": "Podnikanie",
        "billing_address_consignee_name": "Meno príjemcu",
        "billing_address_street": "Ulica a číslo.",
        "billing_address_zipcode": "PLZ",
        "billing_address_city": "Mesto",
        "billing_address_state": "Federálny štát",
        "billing_address_country": "Pôda",
        "billing_address_phone": "Telefónne číslo",
        "billing_email": "Fakturačný email",
        "contact": "kontaktné údaje",
        "sepa": "SEPA inkaso",
        "add_sepa": "Vložiť SEPA inkaso",
        "remove_sepa": "SEPA inkaso zrušené",
        "import_invoice_email": "Automatické vytváranie faktúr cez email",
        "send_email_notifications": "Posielať e-mailové upozornenia",
        "storage_usage": "Využitie úložiska",
        "storage_current": "Aktuálne využitie",
        "storage_included_gb": "Zahrnuté úložisko (GB)",
        "storage_price_per_gb": "Cena za každý ďalší GB",
        "storage_free_included": "Zahrnutý bezplatný objem",
        "storage_billable": "Fakturovateľné GB",
        "storage_billable_price": "Mesačné dodatočné náklady",
        "storage_billing_hint": "Prvých {included} GB je bezplatných. Každý ďalší začatý GB sa účtuje sumou {price}.",
        "tab_mailbox": "Poštové schránky",
        "debit_credit_reverse": "Vymeniť účet/protiúčet",
        "default_decimal_places": "Predvolené desatinné miesta",
        "tab_sso": "Single Sign-On (SAML)",
        "sso_saml_enabled": "Povoliť SAML prihlásenie",
        "sso_saml_provider_label": "Text tlačidla prihlásenia",
        "sso_saml_entity_id": "Entity ID identity providera",
        "sso_saml_sso_url": "SSO URL identity providera",
        "sso_saml_x509_cert": "X509 certifikát identity providera (PEM)",
        "sso_saml_sp_entity_id": "Entity ID service providera (voliteľné)",
        "sso_saml_attr_email": "Názov atribútu e-mailu (voliteľné)",
        "sso_saml_help": "Zapnite až po zadaní hodnôt od identity providera.",
        "sso_saml_validation_required": "Vyplňte všetky povinné SAML polia."
    },
    "datev_access": {
        "description": "Integrácia DATEV",
        "label_log": "Spoločnosť DATEV (datev_client_id)",
        "label_log_fields": "datev_client_id",
        "connected_info": "Pripojenie k DATEV bolo nadviazané.",
        "disconnected_info": "Pripojenie k DATEV bolo odstránené.",
        "connected_client_info": "Pripojenie k spoločnosti DATEV {datev_client_id} bolo nadviazané.",
        "disconnected_client_info": "Pripojenie k spoločnosti DATEV {datev_client_id} bolo deaktivované."
    },
    "ms365_access": {
        "description": "Integrácia D365",
        "connected_info": "Pripojenie k D365 bolo nadviazané.",
        "disconnected_info": "Pripojenie k D365 bolo odstránené.",
        "data_loaded_info": "Údaje z D365 boli manuálne načítané.",
        "journal_created_info": "Denník D365 bol pridaný.<br>Názov denníka: {journal_name} <br>URL organizácie: {org_url}.",
        "journal_edited_info": "Názov denníka D365 bol upravený: {journal_name}."
    },
    "client": {
        "description": "Spoločnosť",
        "alias": "Alias spoločnosti",
        "tab_invoice_recognition_prompt": "Vlastný prompt",
        "min_approval": "Minimálny počet schvaľovateľov",
        "branch_required": "Pobočka je povinná pre formulár faktúry.",
        "department_required": "Oddelenie je potrebné pre formulár faktúry.",
        "cost_center_required": "Nákladové stredisko je povinné pre objednávkový formulár.",
        "client_number": "Číslo",
        "consultant_number": "Číslo poradcu",
        "ledger_account_length": "Dĺžka účtovného účtu",
        "vat_number": "ID č.",
        "address_name": "názov",
        "consignee": "Meno príjemcu – fakturačná adresa",
        "dropoff_location": "Názov miesta doručenia - fakturačná adresa",
        "address": "Ulica a číslo - fakturačná adresa",
        "address_complement": "Ulica 2 – fakturačná adresa",
        "country": "Krajina – fakturačná adresa",
        "zipcode": "PSČ – fakturačná adresa",
        "city": "Mesto – fakturačná adresa",
        "phone_country_code": "Krajina telefónu – fakturačná adresa",
        "phone_number": "Telefónne číslo – fakturačná adresa",
        "can_delete_document_directly": "Dokumenty je možné vymazať bez upresnenia.",
        "default_product_tax": "Štandardná daňová sadzba (%)",
        "default_product_currency": "Predvolená mena",
        "default_product_unit": "Predvolená jednotka",
        "invoice_recognition_prompt": "Vlastný prompt pre rozpoznanie faktúr",
        "form_sequence": "name,email,client_number,currency,min_approval,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id,user_invoice_manual_check_id,user_invoice_clearing_id",
        "page": {
            "tab_general": "Všeobecné informácie",
            "tab_invoice_recognition_prompt": "Vlastný prompt",
            "tab_bank_data": "Bankové údaje",
            "tab_billing_address": "fakturačná adresa",
            "tab_shipping_address": "Doručovacie adresy",
            "tab_default_roles": "Predvolená všeobecná rola",
            "tab_communication_signature": "Podpis komunikácie",
            "tab_permissions": "Autorizačné skupiny",
            "tab_departments": "Oddelenia",
            "tab_cost_centers": "Nákladová miesta",
            "tab_ledger_accounts": "Účty hlavnej knihy",
            "tab_required_fields": "Povinné polia",
            "tab_datev_csv": "DATEV CSV Export",
            "new": "Nová spoločnosť",
            "invoice_recognition_prompt_placeholder": "Napr. použite tieto pokyny pri rozpoznávaní faktúr pre túto spoločnosť.",
            "select_logo": "Vyberte logo",
            "select_logo_tooltip_content": "Pridajte logo, ktoré bude vytlačené na objednávkovom dokumente vašich schválených objednávok. <br/> Najlepšie je nasnímať súbor obrázka s priehľadným pozadím.",
            "communication_signature_html": "Podpis komunikácie s dodávateľom",
            "communication_signature_html_hint": "Tento HTML podpis sa automaticky predvyplní v externej komunikácii s dodávateľom v dokumente. Podporované je HTML formátovanie.",
            "communication_signature_editor_visual": "Vizuálne",
            "communication_signature_editor_html": "HTML",
            "communication_signature_editor_visual_disabled_hint": "Vizuálny editor je pre tento HTML kód vypnutý, aby sa zachovalo jeho formátovanie.",
            "communication_signature_placeholders": "Zástupné symboly",
            "communication_signature_placeholders_hint": "Kliknutím na zástupný symbol ho vložíte na aktuálnu pozíciu kurzora v HTML editore.",
            "communication_signature_placeholder_first_name": "Meno zamestnanca",
            "communication_signature_placeholder_last_name": "Priezvisko zamestnanca",
            "communication_signature_placeholder_name": "Celé meno zamestnanca",
            "communication_signature_placeholder_email": "E-mail zamestnanca",
            "communication_signature_placeholder_company_name": "Názov spoločnosti",
            "communication_signature_placeholder_company_email": "E-mail spoločnosti",
            "communication_signature_preview": "Náhľad podpisu",
            "communication_signature_preview_hint": "Používa ukážkové údaje zamestnanca a aktuálne údaje spoločnosti, ak sú vyplnené.",
            "communication_signature_preview_empty": "Pridajte vyššie podpis, aby sa tu zobrazil náhľad.",
            "select_letterhead": "Vyberte hlavičkový papier",
            "select_letterhead_tooltip_content": "Pridajte hlavičkový papier, ktorý bude vytlačený na objednávkový dokument vašich schválených objednávok.",
            "billing_address": "fakturačná adresa",
            "state_placeholder": "Select state/region",
            "state_tooltip_content": "Used to calculate holidays.",
            "roles": "Predvolená všeobecná rola",
            "user_clearing_id_tooltip_content": "Na objasnenie objednávkových procesov.",
            "user_invoice_clearing_id_tooltip_content": "Na objasnenie pri podávaní faktúry.",
            "bank_accounts_title": "Bankové účty",
            "bank_accounts_hint": "Tu môžete spravovať viac firemných bankových účtov. IBAN a BIC sa pri zadaní validujú.",
            "bank_accounts_empty": "Zatiaľ neboli pridané žiadne ďalšie bankové účty.",
            "add_bank_account": "Pridať bankový účet",
            "bank_account_label": "Označenie",
            "bank_account_holder": "Majiteľ účtu",
            "bank_account_bank_name": "Názov banky",
            "bank_account_iban": "IBAN",
            "bank_account_bic": "BIC",
            "no_selection": "Nie je pridelené konkrétnej spoločnosti, preto patrí všetkým spoločnostiam.",
            "validation": {
                "name_required": "Zadajte meno.",
                "name_max_length": "Môže obsahovať maximálne 50 znakov.",
                "email_invalid": "Prosím zadajte platnú emailovú adresu.",
                "iban_invalid": "Zadajte platné číslo IBAN.",
                "bic_invalid": "Zadajte platný BIC.",
                "bank_account_iban_required": "Zadajte IBAN pre tento bankový účet.",
                "bank_account_iban_duplicate": "Tento IBAN už bol pridaný.",
                "bank_accounts_invalid": "Skontrolujte sekciu bankových účtov.",
                "client_number_invalid": "Zadajte platné číslo.",
                "min_approval_invalid": "Zadajte platné číslo.",
                "address_incomplete": "Vyplňte povinné údaje o adrese.",
                "delivery_address_missing": "Pridajte aspoň dodaciu adresu.",
                "error_address_incomplete": "Prosím, doplňte povinné údaje pre dodaciu adresu."
            },
            "tour": {
                "name": "Najprv zadajte názov vašej spoločnosti.",
                "email": "Zadajte e-mailovú adresu vašej spoločnosti, na ktorú má byť zaslaná faktúra napr.",
                "timeline_assignment": "Voliteľne môžete vopred prideliť zodpovedné osoby pre spoločnosť pre rôzne kroky požiadaviek na nákup. Napríklad, ak je vždy jedna osoba, ktorá má zadať objednávku.",
                "billing_address": "Fakturačná adresa je potrebná pre objednávku a môže byť zaslaná doručovacej spoločnosti spolu s objednávkou.",
                "shipping_address": "Tu môžete zadať jednu alebo viac doručovacích adries, z ktorých si môžete vybrať v požiadavke na nákup.",
                "btn_save": "Po zhromaždení všetkých potrebných informácií pridajte spoločnosť."
            }
        }
    },
    "client_form_config": {
        "field": "Pole",
        "form": "Formulár",
        "required": "Povinné",
        "not_available_for_d365": "Konfigurácia povinných polí pre faktúry nie je k dispozícii, pretože pri integrácii s D365 sa používajú validačné pravidlá D365."
    },
    "department": {
        "description": "Oddelenie",
        "code": "Číslo",
        "form_sequence": "name,code,client_id,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id",
        "page": {
            "new": "Nové oddelenie",
            "tab_general": "Všeobecné",
            "tab_clients": "Klienti",
            "tab_cost_centers": "Nákladová miesta",
            "tab_approvers": "Schváľovatelia",
            "tab_permissions": "Skupiny oprávnení",
            "tab_employees": "Zamestnanci",
            "tab_assignment": "Priradenia rolí",
            "validation": {
                "name_required": "Zadajte meno.",
                "email_required": "Prosím zadajte platnú emailovú adresu."
            },
            "tour": {
                "name": "Najprv zadajte názov oddelenia.",
                "client": "Ak oddelenie priradíte spoločnosti, oddelenie možno vybrať iba v tejto spoločnosti pri vytváraní požiadavky na nákup.",
                "timeline_assignment": "Môžete určiť osoby v oddelení, ktoré sú zodpovedné za rôzne kroky požiadavky na nákup. Napríklad, ak na oddelení príjmu tovaru je vždy jedna osoba.",
                "cost_centers": "Tu môžete k oddeleniu priradiť už vytvorené nákladové strediská. Ak nepriradíte nákladové strediská, požiadavky na nákup oddelení môžu vybrať iba nákladové strediská, ktoré nie sú priradené žiadnemu oddeleniu.",
                "employees": "Tu môžete pridať rôznych ľudí, ktorí budú priradení k tomuto oddeleniu. Ak ľudia v tomto oddelení vytvoria požiadavku na nákup, oddelenie je predvyplnené.",
                "btn_save": "Po zadaní všetkých informácií pridajte oddelenie."
            }
        }
    },
    "permission": {
        "description": "Skupina povolení",
        "name": "Označenie",
        "page": {
            "new": "Nová skupina povolení",
            "validation": {
                "name_required": "Zadajte meno."
            },
            "tour": {
                "name": "Tu môžete vytvoriť skupinu oprávnení. Túto skupinu potom môžete priradiť k rôznym entitám (oddelenia, produkty z katalógu produktov, skupiny produktov atď.). Ľuďom môžete priradiť aj jednu alebo viac skupín oprávnení. Ak nechcete, aby mala entita obmedzenia povolení, nepriraďujte skupinu."
            },
            "no_selection": "Žiadne obmedzenia skupiny povolení, preto sú viditeľné pre všetkých."
        }
    },
    "task_group": {
        "description": "Skupina úloh",
        "name": "Názov",
        "priority_approval_limit": "Úroveň priority schvaľovacieho limitu",
        "page": {
            "new": "Nová skupina úloh",
            "validation": {
                "name_required": "Prosím, zadajte názov."
            },
            "tour": {
                "name": "Tu môžete vytvoriť skupinu úloh. Potom môžete priradiť úlohy do tejto skupiny."
            },
            "no_selection": "Žiadna vybraná skupina úloh"
        }
    },
    "budget": {
        "description": "rozpočty",
        "label_log": "value€ (start - end)",
        "label_log_fields": "value,start,end",
        "value": "Suma",
        "type_value": "currency",
        "start": "Platnosť od",
        "end": "Dátum spotreby",
        "add_foreach_ledger_account": "Vložiť všetky účtovné účty",
        "component": {
            "validation": {
                "end_date_before_start_date": "Dátum ukončenia nemôže byť skorší ako dátum začiatku.",
                "end_date_required": "Dátum ukončenia tu nemôže byť prázdny.",
                "time_overlap": "Rozpočty sa nesmú časovo prekrývať.",
                "field_missing": "Zadajte všetky informácie."
            }
        }
    },
    "address": {
        "description": "Adresa dodania",
        "description_plural": "Doručovacie adresy",
        "address_name": "názov",
        "consignee": "Meno príjemcu",
        "dropoff_location": "Názov miesta odovzdania",
        "address": "Ulica a číslo.",
        "address_complement": "Ulica 2",
        "complement": "Ulica 2",
        "country": "Pôda",
        "zipcode": "PLZ",
        "city": "Mesto",
        "phone_country_code": "Telefónna krajina",
        "phone_number": "Telefónne číslo",
        "component": {
            "new": "Nová adresa doručenia",
            "copy_btn": "Skopírujte fakturačnú adresu",
            "required_field": "Vyplňte povinné údaje o adrese.",
            "phone_required": "Zadajte obe informácie.",
            "no_address": "Žiadna doručovacia adresa"
        }
    },
    "cost_center": {
        "name": "Označenie",
        "number": "číslo",
        "free_budget": "Voľný rozpočet",
        "description": "Nákladové stredisko",
        "label_log": "cost_center_name",
        "budgets": "rozpočty",
        "form_sequence": "name,number",
        "page": {
            "new": "Nové nákladové stredisko",
            "department_tooltip_content": "Ktoré oddelenia môžu používať toto nákladové stredisko.",
            "tab_general": "Všeobecné",
            "tab_budgets": "Rozpočty",
            "tab_shipping_address": "Dodacie adresy",
            "tab_approvers": "Schválitelia",
            "tab_permissions": "Skupiny oprávnení",
            "tab_departments": "Oddelenia",
            "tab_clients": "Klienti",
            "validation": {
                "name_required": "Zadajte meno.",
                "number_required": "Zadajte číslo.",
                "number_length": "Môže obsahovať maximálne 36 číslic a písmená a medzery sa môžu vyskytovať iba v strede.",
                "number_exists": "Číslo už existuje."
            },
            "tour": {
                "name_number": "Zadajte názov a jedinečné číslo pre nákladové stredisko.",
                "budget": "K svojmu nákladovému stredisku môžete priradiť rôzne rozpočty a rozpočty prideliť aj na účet hlavnej knihy.",
                "approver": "Tu môžete voliteľne definovať, ktorí ľudia by mali uvoľniť požiadavky na nákup s týmto nákladovým strediskom. Pri vytváraní požiadaviek na nákup je možné pridať ďalšie vydania.",
                "department": "Tu môžete definovať, v ktorých oddeleniach sa môže nákladové stredisko používať. Ak sem nepridáte žiadne oddelenia, nákladové stredisko je možné vybrať vo všetkých oddeleniach.",
                "btn_save": "Po zadaní všetkých potrebných informácií pridajte nákladové stredisko do databázy."
            }
        }
    },
    "bank_statement": {
        "abbr": "BS",
        "description": "Nahrať bankový výpis",
        "transactions_menu": "Transakcie z bankových výpisov",
        "page": {
            "upload": {
                "title": "Nahrať bankový výpis",
                "info": "Nahrajte štruktúrovaný bankový výpis.",
                "client_hint": "Vybraná spoločnosť bude priradená k nahranému bankovému výpisu a jeho transakciám.",
                "client_required": "Pred nahraním prosím vyberte spoločnosť.",
                "supported_hint": "Podporuje XML camt.052/.053/.054 a textové súbory MT940.",
                "error_invalid": "Podporované formáty sú XML camt.052, camt.053, camt.054 a textové bankové výpisy MT940.",
                "abort_upload": "Zrušiť nahrávanie",
                "processing_in_background_notice": "Bankový výpis bol uložený. {count} položiek sa teraz spracúva na pozadí.",
                "large_statement_notice": "Bankový výpis s {count} položkami bol nahraný. Automatické párovanie bolo pri tomto veľkom nahraní preskočené, aby sa nahranie nezablokovalo.",
                "account_identifier_match_notice": "Nahraný výpis obsahuje iba identifikátor účtu {identifier}, nie platný IBAN. Nevytvoril sa žiadny nový firemný bankový účet. Tento identifikátor patrí k už uloženému IBAN {iban}.",
                "account_identifier_only_notice": "Nahraný výpis obsahuje iba identifikátor účtu {identifier}, nie platný IBAN. Pre toto nahranie sa nevytvoril žiadny nový firemný bankový účet.",
                "update_client_iban": "Pridať IBAN ako nový účet",
                "continue_without_update": "Pokračovať bez pridania účtu",
                "continue_upload": "Pokračovať v nahraní",
                "statement_account_title": "Účet v nahranom výpise",
                "statement_account_hint": "Tento IBAN bol rozpoznaný v nahranom bankovom výpise.",
                "client_accounts_title": "Aktívne firemné bankové účty",
                "client_accounts_count": "{count} aktívne",
                "client_accounts_table_label": "Označenie",
                "client_accounts_table_bank": "Banka",
                "client_accounts_table_account_holder": "Majiteľ účtu",
                "client_accounts_table_bic": "BIC",
                "client_accounts_table_iban": "IBAN",
                "client_iban_missing_title": "Chýba firemný bankový účet",
                "client_iban_missing_intro": "Pre spoločnosť {clientName} ešte nie je v master data uložený žiadny zodpovedajúci aktívny firemný bankový účet.",
                "client_iban_mismatch_title": "Firemný bankový účet sa líši",
                "client_iban_mismatch_intro": "IBAN vo výpise sa líši od aktívnych firemných bankových účtov uložených v master data spoločnosti {clientName}.",
                "client_iban_document": "IBAN vo výpise: {iban}",
                "client_iban_masterdata": "Existujúci firemný bankový účet: {iban}",
                "client_iban_masterdata_empty": "V master data ešte nie je uložený žiadny aktívny firemný bankový účet.",
                "client_iban_update_question": "Chcete pred nahraním pridať tento IBAN ako nový firemný bankový účet?",
                "client_iban_readonly_hint": "V nahrávaní môžete pokračovať bez vytvorenia nového firemného bankového účtu."
            },
            "form": {
                "title": "Bankový výpis",
                "back_to_upload": "Nové nahratie",
                "delete": "Vymazať bankový výpis",
                "delete_confirm_title": "Vymazať bankový výpis",
                "delete_confirm_message": "Naozaj chcete tento bankový výpis vymazať? Existujúce priradenia sa odpoja a príznaky úhrady z bankového výpisu sa vrátia späť, ak pochádzajú iba z tohto výpisu.",
                "delete_success": "Bankový výpis bol vymazaný.",
                "delete_error": "Bankový výpis sa nepodarilo vymazať.",
                "download": "Stiahnuť súbor",
                "format": "Formát",
                "status": "Stav",
                "account_iban": "Účet",
                "account_owner": "Majiteľ účtu",
                "period": "Obdobie",
                "matched_entries": "Automaticky priradené",
                "processing_title": "Bankový výpis sa spracúva",
                "processing_notice": "Nahratie už bolo uložené. {inserted} z {count} položiek už bolo importovaných; zvyšok sa ešte na pozadí importuje a páruje. Stav si skontrolujete tlačidlom na obnovenie, keď budete chcieť.",
                "processing_matching_title": "Polozky su importovane, sparovanie este bezi",
                "processing_matching_notice": "Vsetkych {count} poloziek uz bolo importovanych a teraz sa na pozadi sparuju. Zatial bolo automaticky priradenych {matched} poloziek. Stav si skontrolujete tlacidlom na obnovenie, ked budete chciet.",
                "processing_refresh": "Obnoviť stav",
                "processing_finished_notice": "Spracovanie bankového výpisu bolo dokončené.",
                "entries": "Položky",
                "entry_index": "Poz.",
                "booking_date": "Dátum zaúčtovania",
                "value_date": "Valuta",
                "amount": "Suma",
                "counterparty": "Protistrana",
                "reference": "Účel platby",
                "match_status": "Spárovanie",
                "matched_invoice": "Priradená faktúra",
                "status_labels": {
                    "processing": "Spracúva sa",
                    "processed": "Spracované",
                    "partial": "Čiastočne spracované",
                    "failed": "Zlyhalo"
                },
                "match_status_labels": {
                    "unmatched": "Nepriradené",
                    "matched": "Priradené",
                    "ambiguous": "Nejednoznačné",
                    "ignored": "Ignorované"
                }
            },
            "list": {
                "identifier": "Identifikátor",
                "uploaded_at": "Nahrané dňa",
                "empty": "Zatiaľ nebol nahraný žiadny bankový výpis."
            },
            "transactions": {
                "title": "Transakcie z bankových výpisov",
                "subtitle": "Centrálny prehľad všetkých položiek bankových výpisov. Najprv vyberte spoločnosť; filter dodávateľa je voliteľný.",
                "clear_filters": "Obnoviť filtre",
                "client_required_notice": "Na zobrazenie transakcií najprv vyberte spoločnosť.",
                "empty": "Nenašli sa žiadne transakcie.",
                "no_permission": "Nemáte oprávnenie otvoriť toto zobrazenie.",
                "active_filters": "Aktívne filtre",
                "transaction_date": "Dátum transakcie",
                "direction": "Typ",
                "incoming": "Príjem",
                "outgoing": "Výdaj",
                "client": "Spoločnosť",
                "supplier": "Dodávateľ",
                "account_filter": "Účet",
                "statement": "Otvoriť bankový výpis",
                "amount_filter": "Typ sumy",
                "transaction_type": "Typ transakcie",
                "text_search": "Textový filter",
                "text_search_placeholder": "Hľadať vo vybraných stĺpcoch",
                "text_search_columns": "Stĺpce vyhľadávania",
                "text_search_columns_placeholder": "Vyberte stĺpce",
                "export": "Exportovať XLSX",
                "export_success": "XLSX export bol vytvorený.",
                "export_error": "XLSX export sa nepodarilo vytvoriť.",
                "export_empty": "Pre aktuálne filtre nie sú k dispozícii žiadne transakcie na export.",
                "export_end_balance": "Konečný zostatok",
                "export_adjustment_type": "Vyrovnávacie zaúčtovanie",
                "export_adjustment_description": "Vyrovnávacie zaúčtovanie pre chýbajúce pokrytie výpisom ({from} - {to})",
                "export_gap_description": "Chýbajúce pokrytie výpisom ({from} - {to})",
                "transaction_type_labels": {
                    "transfer": "Bankový prevod",
                    "direct_debit": "SEPA inkaso",
                    "card": "Platba kartou",
                    "standing_order": "Trvalý príkaz",
                    "fee": "Poplatok",
                    "cash": "Hotovosť",
                    "refund": "Vrátenie peňazí"
                },
                "description": "Popis",
                "coverage_gap_alert_title": "Zistené medzery v pokrytí bankových výpisov",
                "coverage_gap_alert_summary": "{days} deň/dní vo vybranom období nie je pokrytý žiadnym nahraným bankovým výpisom.",
                "coverage_gap_row_label": "Chýbajúce pokrytie: {from} - {to} ({days} deň/dní)",
                "coverage_gap_row_context_between": "Medzera medzi {previous} a {next}.",
                "coverage_gap_row_context_before_first": "Vo vybranom období nie je žiadny skorší výpis. Ďalší dostupný výpis: {next}.",
                "coverage_gap_row_context_after_last": "Vo vybranom období nie je žiadny neskorší výpis. Posledný dostupný výpis: {previous}.",
                "coverage_gap_row_context_unknown": "Pre túto medzeru sa nenašli susedné bankové výpisy.",
                "coverage_gap_closing_balance_difference": "Rozdiel konečného zostatku A/B: {previous} -> {next} ({difference}).",
                "coverage_gap_closing_balance_difference_unavailable": "Rozdiel konečného zostatku A/B nie je pre jeden alebo oba výpisy dostupný.",
                "manual_match": {
                    "action": "Akcie",
                    "assignment": "Priradenie",
                    "details": "Detaily",
                    "open": "Spárovať",
                    "edit": "Upraviť",
                    "dialog_title": "Ručné spárovanie platby",
                    "dialog_title_single": "Priradiť transakciu",
                    "dialog_title_split": "Rozdeliť platbu",
                    "eyebrow": "Ručné párovanie platby",
                    "single_option": "Priradiť jednotlivo..",
                    "split_option": "Rozdeliť",
    "bulk_actions_select": "Hromadné akcie ({count})",
                    "bulk_action": "Priradiť typ nákladu ({count})",
                    "bulk_dialog_title": "Hromadne priradiť typ nákladu",
                    "bulk_dialog_text": "Priraďte vybraný typ nákladu priamo k {count} vybraným transakciám. Existujúce ručné priradenia sa nahradia.",
                    "bulk_save": "Priradiť typ nákladu",
                    "incoming_revenue_bulk_action": "Priradiť typ príjmu",
                    "revenue_bulk_dialog_title": "Hromadne priradiť typ príjmu",
                    "revenue_bulk_dialog_text": "Priraďte vybraný typ príjmu priamo k {count} vybraným prichádzajúcim transakciám. Existujúce ručné priradenia sa nahradia.",
                    "revenue_bulk_save": "Priradiť typ príjmu",
                    "filtered_batch_action": "Hromadne priradiť filtrované ({count})",
                    "filtered_batch_incoming_action": "Hromadne priradiť filtrované príjmy ({count})",
                    "filtered_batch_outgoing_action": "Hromadne priradiť filtrované výdavky ({count})",
                    "filtered_batch_empty": "Pre hromadné priradenie nie sú k dispozícii žiadne filtrované transakcie.",
                    "filtered_batch_direction_warning": "Filtrované výsledky obsahujú príjmy aj výdavky. Pred hromadným priradením filtre viac spresnite.",
                    "filtered_batch_load_error": "Filtrované transakcie sa nepodarilo pripraviť na hromadné priradenie.",
                    "permission_required_title": "Vyžaduje sa oprávnenie",
                    "permission_required": "Na úpravu transakcií bankového výpisu potrebujete oprávnenia „Zobraziť transakcie z bankových výpisov“ a „Upraviť faktúru následne“.",
                    "permission_tooltip": "Deaktivované: chýba oprávnenie „Upraviť faktúru následne“.",
                    "transaction_total": "Suma transakcie",
                    "allocated_total": "Priradená suma",
                    "remaining_difference": "Zostávajúci rozdiel",
                    "ready_to_save": "Súčet sedí.",
                    "remaining_message": "Zostáva: {amount}",
                    "allocations_title": "Rozdelenie na faktúry",
                    "allocations_subtitle": "Vyberte jednu alebo viac faktúr a pri každom riadku zadajte sumu, ktorú táto transakcia pokrýva.",
                    "add_invoice": "Pridať faktúru",
                    "outgoing_invoice": "Odchádzajúca faktúra (platba zákazníka)",
                    "cost_type": "Typ nákladu",
                    "cost_type_bulk_action": "Priradiť typ nákladu",
                    "invoice_gross": "Hrubá suma faktúry",
                    "match_amount": "Priradená suma",
                    "use_transaction_total": "Použiť sumu transakcie",
                    "use_invoice_gross": "Použiť hrubú sumu",
                    "use_remaining": "Použiť zvyšok",
                    "clear_matches": "Odstrániť párovanie",
                    "save": "Uložiť párovanie",
                    "alerts": {
                        "invoice_conflict_title": "Faktúra je už prepojená s inou transakciou",
                        "invoice_conflict_message": "Aspoň jedna vybraná faktúra je už priradená k inej bankovej transakcii.",
                        "invoice_conflict_hint": "Najprv otvorte existujúce priradenie a upravte tam rozdelenie alebo ho odstráňte, až potom uložte túto transakciu."
                    }
                }
            }
        }
    },
    "supplier": {
        "address": "Adresa",
        "alias": "Alias dodávateľa",
        "external_id": "DATEV ID",
        "supplier_number": "Číslo dodávateľa",
        "client_number": "Číslo zákazníka",
        "delivery_in_days": "Dodacia lehota v pracovných dňoch",
        "delivery_terms": "dodacie podmienky",
        "payment_terms": "Platobné podmienky",
        "vat_number": "ID č.",
        "city": "Mesto",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Krajina banky",
        "bank_account": "Číslo účtu",
        "bank_code": "Smerové číslo banky",
        "bank": "Banka",
        "discount_percentage": "Skonto 1 - percento",
        "discount_days": "Skonto 1 - dni",
        "discount_percentage2": "Skonto 2 - percento",
        "discount_days2": "Skonto 2 - dni",
        "invoice_recognition_prompt": "Vlastný prompt pre rozpoznanie faktúry",
        "form_sequence": "name,email,city,address,external_id,delivery_terms,payment_terms,iban,bic,vat_number",
        "payment_method": "Spôsob platby",
        "payment_method_info": "Faktúry od dodávateľských spoločností so spôsobom platby SEPA inkaso alebo kreditná karta sú označené ako priamo zaplatené",
        "page": {
            "new": "Novy dodávateľ",
            "department_tooltip_content": "Ktoré oddelenia môžu používať tohto dodávateľa.",
            "delivery_in_days_tooltip_content": "Dodacia lehota sa používa pre e-mail s úlohou prijatia tovaru.",
            "notes_tooltip_content": "Táto poznámka sa zobrazuje iba interne v liftbase a nevytlačí sa na PDF objednávky.",
            "external_id_tooltip_content": "ID doručovacej spoločnosti z vami pripojeného systému tretej strany.",
            "client_number_tooltip_content": "Číslo, ktoré vám tento dodávateľ priradil (voliteľné).",
            "supplier_number_tooltip_content": "Číslo, ktoré ste priradili tomuto dodávateľovi.",
            "delivery_terms_tooltip_content": "Platobné a dodacie podmienky dohodnuté s doručovateľskou spoločnosťou sú uvedené v objednávkovom PDF pri zadávaní objednávky.",
            "payment_terms_tooltip_content": "Platobné a dodacie podmienky dohodnuté s doručovateľskou spoločnosťou sú uvedené v objednávkovom PDF pri zadávaní objednávky.",
            "tab_general": "Všeobecné",
            "tab_delivery_info": "Informácie o dodávke",
            "tab_payment_info": "Informácie o platbe",
            "tab_permissions": "Skupiny oprávnení",
            "tab_departments": "Oddelenia",
            "tab_approvers": "Schváľovatelia",
            "tab_clients": "Firemné špecifické ID",
            "tab_invoice_recognition": "Predvolené hodnoty pre rozpoznávanie dokladov",
            "tab_invoice_recognition_prompt": "Vlastný prompt",
            "invoice_recognition_prompt_placeholder": "Napr. použite, prosím, „kód ticketu“ ako číslo faktúry.",
            "default_clients_ids": "Ak spoločnosť nie je uvedená v tejto tabuľke so špecifickými ID, <br>budú použité nasledujúce predvolené ID: <br>DATEV ID: {external_id} <br>Číslo klienta: {client_number}.",
            "no_default_id": "Nie je k dispozícii žiadne predvolené ID.",
            "validation": {
                "name_required": "Zadajte meno.",
                "name_length": "Môže obsahovať maximálne 50 znakov.",
                "email_invalid": "Prosím zadajte platnú emailovú adresu.",
                "supplier_number_invalid": "Zadajte platné číslo.",
                "vat_number_invalid": "Môže obsahovať čísla, veľké a malé písmená, bodky, medzery a podčiarkovníky. Môže obsahovať maximálne 15 znakov.",
                "iban_invalid": "Môže obsahovať minimálne 15, maximálne 34 znakov a žiadne medzery. Začína dvoma veľkými písmenami, po ktorých nasledujú 2 čísla a 11 až 30 číslic/písmen.",
                "bic_invalid": "Môže obsahovať minimálne 8 a maximálne 11 znakov a iba veľké písmená a čísla. Prvých šesť znakov musí byť písmená.",
                "external_id_length": "ID DATEV musí obsahovať iba celé čísla a nesmie byť menšie ako 10000."
            },
            "tour": {
                "name": "Zadajte názov doručovacej spoločnosti.",
                "email": "E-mailová adresa doručovateľskej spoločnosti slúži napríklad na prípravu e-mailových správ na uskutočnenie objednávky.",
                "address": "Tu môžete zadať adresu doručovacej spoločnosti.",
                "external_id": "Externé ID je číslo spoločnosti, ako je uložené napríklad v externom softvéri. Toto číslo sa používa v rozhraní API.",
                "terms": "Platobné a dodacie podmienky dohodnuté s doručovateľskou spoločnosťou zaznamenajte tu. Tieto informácie sa potom zobrazia v objednávkovom PDF pri zadaní objednávky.",
                "btn_save": "Po zadaní všetkých údajov uložte doručovaciu spoločnosť sem."
            }
        }
    },
    "business_partner": {
        "address": "Adresa",
        "business_partner_number": "Číslo",
        "delivery_in_days": "Dodacia lehota v pracovných dňoch",
        "delivery_terms": "Dodacie podmienky",
        "payment_terms": "Platobné podmienky",
        "vat_number": "IČ DPH",
        "city": "Mesto",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Krajina banky",
        "bank_account": "Číslo účtu",
        "bank_code": "Smerové číslo banky",
        "bank": "Banka",
        "discount_percentage": "Skonto 1 - percento",
        "discount_days": "Skonto 1 - dni",
        "discount_percentage2": "Skonto 2 - percento",
        "discount_days2": "Skonto 2 - dni",
        "payment_method": "Spôsob platby",
        "payment_method_info": "Doklady so spôsobom platby SEPA inkaso alebo kreditná karta môžu byť označené priamo ako zaplatené.",
        "page": {
            "new": "Pridať obchodného partnera",
            "delivery_in_days_tooltip_content": "Dodacia lehota sa ukladá ako kmeňový údaj tohto obchodného partnera.",
            "notes_tooltip_content": "Táto poznámka sa zobrazuje iba interne v liftbase.",
            "business_partner_number_tooltip_content": "Číslo, ktoré ste priradili tomuto obchodnému partnerovi.",
            "delivery_terms_tooltip_content": "Tu môžete uložiť dodacie podmienky dohodnuté s obchodným partnerom.",
            "payment_terms_tooltip_content": "Tu môžete uložiť platobné podmienky dohodnuté s obchodným partnerom.",
            "vat_number_tooltip_content": "IČ DPH pomáha priradiť doklady k tomuto obchodnému partnerovi.",
            "name_tooltip_content": "Zadajte názov obchodného partnera presne tak, ako sa má zobrazovať na dokladoch.",
            "tab_general": "Všeobecné",
            "tab_delivery_info": "Dodacie údaje",
            "tab_payment_info": "Platobné údaje",
            "tab_permissions": "Skupiny oprávnení",
            "tab_clients": "Spoločnosti",
            "import_legacy_suppliers_button": "Importovať dodávateľov ako partnerov",
            "import_legacy_suppliers_title": "Importovať dodávateľov ako obchodných partnerov?",
            "import_legacy_suppliers_confirm": "Pre každého dodávateľa vo vašom tenantovi, ktorý ešte nemá obchodného partnera, vytvorí záznam (s odkazom na pôvodného dodávateľa), skopíruje bankové účty, väzby na klientov a skupiny oprávnení a aktualizuje odchádzajúce faktúry. Už importovaní dodávatelia sa preskočia. Akciu môžete bezpečne spustiť znova.",
            "import_legacy_suppliers_run": "Spustiť import",
            "import_legacy_suppliers_loading": "Prebieha import dodávateľov…",
            "import_legacy_suppliers_success": "Import dokončený. Noví partneri: {inserted}. Preskočené (už prepojené): {skipped}. Bankové účty: {bankAccounts}. Odchádzajúce faktury (hlavné / rozpoznané): {invoicesBp} / {invoicesRec}. Väzby klientov: {clients}. Oprávnenia: {permissions}.",
            "tab_invoice_recognition": "Predvolené hodnoty pre rozpoznanie dokladov",
            "validation": {
                "name_required": "Zadajte názov.",
                "name_length": "Môže obsahovať maximálne 50 znakov.",
                "email_invalid": "Prosím zadajte platnú emailovú adresu.",
                "vat_number_invalid": "Môže obsahovať čísla, veľké a malé písmená, bodky, medzery a podčiarkovníky. Môže obsahovať maximálne 15 znakov.",
                "iban_invalid": "Môže obsahovať minimálne 15, maximálne 34 znakov a žiadne medzery. Začína dvoma veľkými písmenami, po ktorých nasledujú 2 čísla a 11 až 30 číslic/písmen.",
                "bic_invalid": "Môže obsahovať minimálne 8 a maximálne 11 znakov a iba veľké písmená a čísla. Prvých šesť znakov musí byť písmená."
            },
            "tour": {
                "name": "Zadajte názov obchodného partnera.",
                "email": "E-mailová adresa obchodného partnera môže byť použitá na komunikáciu a prácu s dokladmi.",
                "address": "Tu môžete uložiť adresu obchodného partnera.",
                "terms": "Zadajte tu platobné a dodacie podmienky dohodnuté s obchodným partnerom.",
                "btn_save": "Po zadaní všetkých informácií tu obchodného partnera uložte."
            }
        }
    },
    "user": {
        "name": "Meno",
        "client_id": "hlavná spoločnosť",
        "approval_limit": "Limit uvoľnenia",
        "priority_approval_limit": "Úroveň priority schvaľovacieho limitu",
        "show_tour": "Zobraziť všetky prehliadky od Liftbase",
        "tooltip_edit_master_data_permission": "S týmto oprávnením je možné upravovať kmeňové údaje aj mimo administrátorskej oblasti pomocou nasledujúcich funkcií:<br>" +
            "- Pridať dodávateľov priamo pri vytváraní produktu<br>" +
            "- Upraviť/doplniť bankové údaje, spôsob platby a IČ DPH počas spracovania faktúry",
        "roles": {
            "user-admin": "Administrátor",
            "user-price": "Zobraziť ceny",
            "user-dashboard": "Zobraziť všetky dashboardy",
            "user-procurement-dashboard": "Zobraziť dashboard obstarávania",
            "user-invoice-dashboard": "Zobraziť dashboard prijatých faktúr",
            "user-outgoing-invoice-dashboard": "Zobraziť dashboard odoslaných faktúr",
            "user-einvoice-dashboard": "Zobraziť dashboard elektronických faktúr",
            "user-change-order": "Upraviť objednávku následne",
            "user-see-orders": "Zobraziť objednávky:",
            "user-see-all-orders": "Všetky spoločnosti",
            "user-see-all-orders-belonging-to-accessible-companies": "Všetky prístupné spoločnosti",
            "user-see-all-orders-belonging-to-own-company": "Vlastná spoločnosť",
            "user-see-all-orders-belonging-to-own-department": "Vlastné oddelenie",
            "user-see-orders-from-involved-invoices": "Zobraziť objednávky zo zapojených faktúr",
            "user-see-own-orders-and-involved": "Vlastné a zapojené",
            "user-see-all-invoices": "Všetky spoločnosti",
            "user-see-all-invoices-belonging-to-accessible-companies": "Všetky prístupné spoločnosti",
            "user-see-invoices": "Zobraziť faktúry:",
            "user-see-all-invoices-belonging-to-own-company": "Vlastná spoločnosť",
            "user-see-invoices-from-own-orders": "Zobraziť faktúry z vlastných objednávok",
            "user-see-own-invoices-and-involved": "Vlastné a zapojené",
            "user-can-change-invoices": "Upraviť faktúru následne",
            "user-see-outgoing-invoices": "Zobraziť výstupné faktúry:",
            "user-see-all-outgoing-invoices": "Všetky spoločnosti",
            "user-see-all-outgoing-invoices-belonging-to-accessible-companies": "Všetky prístupné spoločnosti",
            "user-see-all-outgoing-invoices-belonging-to-own-company": "Vlastná spoločnosť",
            "user-see-own-outgoing-invoices-and-involved": "Vlastné a zapojené",
            "user-can-change-outgoing-invoices": "Upraviť výstupnú faktúru následne",
            "user-bank-statement-transactions": "Zobraziť transakcie z bankových výpisov",
            "user-liquidity-planning": "Otvoriť plánovanie likvidity",
            "user-supplier-dashboard": "Zobraziť dodávateľský dashboard",
            "user-ai-dashboard": "AI-Stats (iba operátori)",
            "user-see-client-addresses": "Zobraziť všetky adresy spoločností",
            "user-export-invoice": "Odoslať faktúry do {export_name}",
            "user-can-delete-document-directly": "Stornovať/vyradiť dokumenty bez objasnenia",
            "user-can-insert-product": "Uložiť do katalógu produktov",
            "user-can-insert-supplier": "Nepriamo upraviť hlavné údaje",
            "masterdata-edit-business-partners": "Upravovať obchodných partnerov",
            "user-see-contracts": "Zobraziť zmluvy:",
            "user-see-all-contracts": "Všetky spoločnosti",
            "user-see-all-contracts-belonging-to-accessible-companies": "Všetky prístupné spoločnosti",
            "user-see-all-contracts-belonging-to-own-company": "Vlastná spoločnosť",
            "user-see-all-contracts-belonging-to-own-department": "Vlastné oddelenie",
            "user-see-own-contracts-and-involved": "Vlastné a zapojené"
        },
        "blocked": "Kontrolný blok",
        "token_issued_at": "Token API vydaný o",
        "form_sequence": "name,email,client_id,department_id,cost_center_id,location_id,approval_limit,roles,blocked",
        "page": {
            "tab_general": "Všeobecné informácie",
            "tab_roles": "Povolenia",
            "tab_roles_general": "Všeobecné oprávnenia",
            "tab_roles_dashboards": "Dashboardy",
            "tab_roles_procurement": "Požiadavky na nákup",
            "tab_roles_invoice": "Faktúry",
            "tab_roles_outgoing_invoice": "Výstupné faktúry",
            "tab_roles_bank_statements": "Bankové výpisy",
            "bank_statement_permission_dependency_warning": "Úprava transakcií bankového výpisu vyžaduje aj oprávnenie „Upraviť faktúru následne“. Túto voľbu je možné napriek tomu uložiť.",
            "tab_roles_block": "Blokácie",
            "tab_permissions": "Autorizačné skupiny",
            "tab_addresses": "Doručovacie adresy",
            "tab_task_groups": "Skupiny úloh",
            "tab_communication_contacts": "Kontakty",
            "tab_passkeys": "Prístupové kľúče",
            "tab_oauth_permissions": "Prístupy aplikácií",
            "oauth_permissions": "Udelené prístupy aplikácií",
            "oauth_permissions_description": "Aplikácie uvedené tu boli výslovne autorizované na prístup do Liftbase v mene tejto osoby.",
            "oauth_permissions_empty": "Nebol udelený žiadny prístup aplikácii.",
            "oauth_application": "Aplikácia",
            "oauth_redirect_uri": "URL presmerovania",
            "oauth_unverified": "Neoverená",
            "oauth_permission": "Oprávnenie",
            "oauth_scope_mcp": "Čítanie povolených údajov Liftbase",
            "oauth_granted_at": "Udelené",
            "oauth_expires_at": "Vyprší",
            "oauth_status": "Stav",
            "oauth_status_active": "Aktívne",
            "oauth_status_expired": "Vypršalo",
            "oauth_revoke": "Odvolať",
            "oauth_revoke_title": "Odvolať prístup aplikácie",
            "oauth_revoke_confirm": "Odvolať prístup pre {application}? Obnovovanie prístupu sa okamžite zastaví; už vydaný prístupový token môže zostať platný až 15 minút.",
            "oauth_revoked": "Prístup aplikácie bol odvolaný.",
            "communication_contacts_description": "Tu spravujete e-mailové kontakty navrhované iba vám pre komunikáciu s dodávateľmi. Uložené kontakty môžete premenovať alebo odstrániť, aby sa už viac nenavrhovali.",
            "communication_contacts_empty": "Zatiaľ nie sú uložené žiadne kontakty.",
            "communication_contact_name": "Meno",
            "communication_contact_name_placeholder": "Voliteľný zobrazovaný názov",
            "communication_contact_email": "E-mail",
            "communication_contact_last_used": "Naposledy použité",
            "communication_contact_saved": "Kontakt bol aktualizovaný.",
            "communication_contact_deleted": "Kontakt bol odstránený.",
            "communication_contact_delete_confirm": "Naozaj chcete odstrániť uložený kontakt \"{email}\"?",
            "accessible_companies_title": "Prístupné spoločnosti pre tohto používateľa",
            "accessible_companies_empty": "Z aktuálnych oprávnení neboli odvodené žiadne spoločnosti.",
            "new": "Nový človek",
            "block_btn": "Zablokovať osobu",
            "unblock_btn": "Odblokovať osobu",
            "login_as_btn": "Prihláste sa ako",
            "roles": "Povolenia",
            "no_permission": "Nie sú vybraté žiadne skupiny povolení.",
            "task_group_permissions": "Oprávnenia z mojich skupín úloh:",
            "approval_limit_tooltip_content": "Tu definujte, ktoré sumy môže táto osoba nakoniec uvoľniť. <br> Vyššie sumy môžu byť uvoľnené, ale musia byť nakoniec uvoľnené aj inou osobou s vyšším limitom uvoľnenia.",
            "approval_limit_placeholder": "Neobmedzené",
            "upload_signature_label": "Podpis (obrázok)",
            "upload_signature_btn": "Vyberte podpis",
            "upload_signature_tooltip_content": "Pridajte podpis, ktorý bude vytlačený na dokumente uvedenia do prevádzky vašich uvoľnených objednávok. <br/> Najlepšie je nasnímať súbor obrázka s priehľadným pozadím.",
            "email_signature_html": "E-mailový podpis",
            "email_signature_html_hint": "Tento podpis sa predvyplní v komunikácii s dodávateľom pri prvej správe dokumentu.",
            "api_token_btn": "Generovať tokeny API",
            "api_token_dialog_title": "Generovať tokeny API",
            "api_token_dialog_content": "Tokeny API sú potrebné na integráciu aplikácií tretích strán a umožňujú prístup k údajom v mene príslušnej osoby.",
            "api_token_dialog_date_placeholder": "Dátum vypršania platnosti tokenu",
            "api_token_dialog_generate_btn": "Generovať",
            "api_token_dialog_copy_btn": "Kopírovať",
            "api_token_dialog_copy_info": "Skopírujte a prilepte nasledujúci token rozhrania API do aplikácie tretej strany:",
            "api_token_dialog_copied": "Skopírované!",
            "language": "Jazyk",
            "role_dashboard_tooltip": "Umožňuje prístup ku všetkým dashboardom.",
            "role_ai_dashboard_tooltip": "AI-Stats je dostupný iba operátorom.",
            "role_supplier_dashboard_tooltip": "Umožňuje iba prístup k dodávateľskému dashboardu. Toto povolenie je nezávislé od povolenia \"Zobraziť dashboard\".",
            "passkey": "Prístupový kľúč",
            "passkeys": "Prístupové kľúče",
            "passkey_name": "názov",
            "passkey_last_login": "posledné prihlásenie",
            "passkey_dialog": {
                "title": "Pridať prístupový kľúč",
                "info1": "<b>Čo sú prístupové kľúče?</b><ul><li>Prihláste sa bez čakania na e-mail </li><li>Pomocou odtlačku prsta, vašej tváre alebo kódu PIN </li><li>Bezpečné a pohodlné< /li ></ul>",
                "info2": "<b>Nastavte teraz v 3 krokoch:</b><ol><li>Zadajte názov, napr. „Počítač domácej kancelárie“ alebo „Poznámkový blok“</li><li>Kliknite na „Ďalej“</li><li >Postupujte podľa pokynov vášho prehliadača/operačného systému</li></ol>",
                "info3": "Pokyny krok za krokom nájdete v príručke</a>",
                "name_input_label": "Passkey-Name",
                "name_input_placeholder": "napr. „Počítač pre domácu kanceláriu“ alebo „Notebook“",
                "added_msg": "Bol pridaný prístupový kľúč.",
                "deleted_msg": "Prístupový kľúč bol odstránený.",
                "exist_msg": "V tomto zariadení už máte prístupový kľúč, skúste iné zariadenie."
            },
            "validation": {
                "name_required": "Zadajte meno.",
                "name_exists": "Názov už existuje.",
                "email_required": "Prosím zadajte emailovú adresu.",
                "email_invalid": "Prosím zadajte platnú emailovú adresu.",
                "email_exists": "E-mailová adresa už existuje.",
                "approval_limit_length": "Limit uvoľnenia musí byť buď väčší ako 0, alebo prázdny."
            },
            "tour": {
                "name": "Zadajte meno osoby, najlepšie meno a priezvisko.",
                "email": "Zadajte e-mailovú adresu, ktorú môže osoba použiť na prihlásenie.",
                "organization": "Priraďte osobu k spoločnosti, oddeleniu a nákladovému stredisku. Tieto informácie sa potom vopred vyplnia do formulára, keď sa vytvorí požiadavka na nákup.",
                "approval_limit": "Tu môžete definovať limit uvoľnenia pre osobu. Ak má požiadavka na nákup vyššiu celkovú sumu, musí ju schváliť aj niekto s vyšším limitom schválenia. Ak nie je definovaný žiadny limit, osoba môže konečne uvoľniť všetky sumy.",
                "signature": "Tu je možné pridať podpis osoby. Ak osoba uvoľní požiadavku na objednávku, podpis sa pridá do PDF objednávky.",
                "roles": "Tu je možné nastaviť oprávnenia pre osobu, napríklad či a ktoré procesy alebo informácie môžu byť zobrazené alebo upravené. Existuje tiež možnosť zablokovať osobu, ak napríklad opustila spoločnosť.",
                "roles_price": "Tu nastavte, či osoba vidí ceny produktov.",
                "role_change_order": "Dôveryhodnej osobe môžete udeliť povolenie na spracovanie požiadaviek na nákup po ich uvoľnení bez toho, aby ste ich museli posielať na objasnenie, a tak sa vyhnúť tomu, aby ste museli byť znova uvoľnení. To môže byť užitočné napríklad pri následnej úprave doručovacích adries alebo cien produktov.",
                "admin": "Vyberte, či má mať osoba prístup do oblasti správy, napríklad na ukladanie ďalších osôb, kmeňových údajov alebo konfigurácií.",
                "block": "Túto možnosť vyberte, ak chcete zabrániť osobe v prihlásení do výťahovej základne, napríklad ak dočasne opustila spoločnosť.",
                "api_token": "Tokeny API sú potrebné na integráciu aplikácií tretích strán a umožňujú prístup k údajom v mene príslušnej osoby.",
                "addresses": "Môžete si uložiť svoje vlastné doručovacie adresy pre danú osobu, napríklad ak osoba pracuje z domu a produkty by mali byť doručené tam.",
                "btn_save": "Uložte osobu a súvisiace informácie.",
                "profile_signature": "Tu môžete nahrať svoj podpis. Potom, keď uvoľníte požiadavky na nákup, váš podpis bude vytlačený na PDF s objednávkou.",
                "profile_addresses": "Môžete zadať svoje vlastné doručovacie adresy, napríklad ak pracujete z domu a produkty by vám tam mali byť doručené.",
                "profile_btn_save": "Uložte súvisiace informácie."
            }
        }
    },
    "lb_user": {
        "description": "Osoba"
    },
    "posting_key": {
        "name": "Označenie",
        "tax": "Sadzba dane v %",
        "number": "kľúč",
        "form_sequence": "name,number,tax",
        "page": {
            "new": "Nový daňový kód",
            "validation": {
                "name_required": "Zadajte meno.",
                "number_required": "Zadajte platné číslo.",
                "number_length": "Môže obsahovať až 9-miestne čísla začínajúce od 1."
            },
            "tour": {
                "name": "Zadajte kľúč a príslušnú sadzbu dane."
            }
        }
    },
    "ledger_account": {
        "name": "Označenie",
        "description": "Popis",
        "form_sequence": "name,number,description",
        "page": {
            "new": "Nový účtovný účet",
            "validation": {
                "name_required": "Zadajte názov.",
                "number_required": "Zadajte platné číslo.",
                "number_length": "Môže obsahovať iba čísla a nemôže začínať 0, ak obsahuje niekoľko číslic.",
                "tax_required": "Zadajte platnú sadzbu dane.",
                "tax_length": "Percentá môžu obsahovať iba dvojciferné čísla s desatinnou čiarkou a najviac na dve desatinné miesta."
            },
            "tour": {
                "name": "Zadajte číslo a názov účtu hlavnej knihy."
            }
        }
    },
    "profit_center": {
        "name": "Názov",
        "form_sequence": "name,number",
        "page": {
            "new": "Nové Ziskové stredisko",
            "validation": {
                "name_required": "Zadajte názov.",
                "number_required": "Zadajte platné číslo.",
                "number_length": "Môže obsahovať iba čísla a pri viacero číslach nesmie začínať nulou.",
            },
            "tour": {
                "name": "Uveďte číslo a názov ziskového centra."
            }
        }
    },
    "tax_group": {
        "code": "ID",
        "name": "Názov",
        "form_sequence": "name,code,client_id",
        "page": {
            "new": "Nová skupina dane z predaja",
            "validation": {
                "name_required": "Zadajte názov.",
                "code_required": "Zadajte ID.",
                "client_required": "Vyberte prosím klienta.",
            },
            "tour": {
                "name": "Uveďte ID a názov skupiny dane z predaja."
            }
        }
    },
    "financial_dimension": {
        "code": "ID",
        "name": "Názov",
        "form_sequence": "name,code",
        "page": {
            "new": "Nový zamestnanec",
            "validation": {
                "name_required": "Prosím, zadajte meno.",
                "code_required": "Prosím, zadajte ID.",
                "client_required": "Prosím, vyberte firmu."
            },
            "tour": {
                "name": "Zadajte ID a meno zamestnanca."
            }
        }
    },
    "tax_item_group": {
        "code": "ID",
        "tax_code": "Daňové ID",
        "name": "Názov",
        "form_sequence": "name,code,tax_code,client_id",
        "page": {
            "new": "Nová skupina položiek daní",
            "validation": {
                "name_required": "Prosím, zadajte názov.",
                "code_required": "Prosím, zadajte ID.",
                "tax_code_required": "Prosím, zadajte Daňové ID.",
                "client_required": "Prosím, vyberte firmu.",
            },
            "tour": {
                "name": "Zadajte ID a názov skupiny dane na pridané hodnoty."
            }
        }
    },
    "approver": {
        "description": "Schválenie",
        "label_log": "lb_user_name",
        "table_log": "lb_user",
        "approver_required": "Vyberte vydanie.",
        "is_required": "Povinný",
        "is_required_info": "Musí tiež schváliť, aj keď predchádzajúci schvaľovatelia už mali potrebný limit schválenia.",
        "conversion_info": "Suma schválenia bola prepočítaná na menu dokumentu podľa aktuálneho výmenného kurzu ECB.",
        "max_approvers": "Max. počet schvaľovateľov",
        "max_approvers_placeholder": "voliteľné",
        "max_approvers_info": "Voliteľné. Ak je nastavené, musia schváliť len N najvyšších schvaľovateľov (podľa limitu schválenia). Povinní schvaľovatelia sa započítavajú do maxima a môžu ho prekročiť. Predvolený tvorca alebo záložný používateľ sa do maxima nezapočítava. Prázdne = doterajšie pravidlo (všetci zodpovedajúci schvaľovatelia).",
        "add_creator_or_fallback": "Tvorca schvaľuje ako prvý",
        "add_creator_or_fallback_info": "Požiadavka na nákup: tvorca sa pridá ako prvý schvaľovateľ. Ak jeho schvaľovací limit nestačí alebo nie je k dispozícii, použije sa záložný používateľ. Faktúra prepojená s objednávkou: tvorca objednávky sa pridá ako prvý schvaľovateľ. Záložný používateľ sa použije iba vtedy, keď tento tvorca nie je k dispozícii. Faktúra bez prepojenej objednávky: záložný používateľ sa pridá ako prvý schvaľovateľ.",
        "procurement": "Požiadavka na nákup",
        "invoice": "Faktúra/Požiadavka na nákup",
        "or": "alebo",
        "creator_placeholder": "Tvorca (automaticky)",
        "fallback_label": "Záložný používateľ, keď tvorca nie je k dispozícii",
        "fallback_info": "Pri požiadavkách na nákup sa použije, keď tvorca nie je k dispozícii alebo jeho schvaľovací limit nestačí. Pri faktúrach sa použije, keď nie je prepojená objednávka alebo tvorca objednávky nie je k dispozícii.",
        "fallback_placeholder": "Záložný používateľ",
        "creator_or_fallback_preview": "Tvorca alebo záložný používateľ",
        "creator_or_fallback_preview_info": "Prvá pozícia je rezervovaná. O tom, či obsahuje tvorcu alebo záložného používateľa, sa rozhodne pre konkrétny doklad.",
        "test_order_value": "Testovacia hodnota objednávky",
        "test_order_value_placeholder": "napr. 5000",
        "test_order_value_info": "Zadajte fiktívnu hodnotu objednávky a zobrazte, ktorí schvaľovatelia by boli s aktuálnym nastavením vyžadovaní.",
        "test_preview_section_title": "Test schvaľovania",
        "test_preview_title": "Požadovaní schvaľovatelia",
        "test_preview_empty": "Pre túto hodnotu nie sú žiadni schvaľovatelia.",
        "test_preview_required_overflow_short": "{requiredCount} povinných > max. {max}"
    },
    "invoice": {
        "description": "Faktúra",
        "name": "Označenie",
        "creator_id": "nahrané používateľom",
        "created_at": "Nahrané dňa",
        "number": "Číslo faktúry",
        "invoice_prefix": "Prefix faktúry",
        "is_final_invoice": "Označiť prepojenú objednávku ako dokončenú",
        "is_final_invoice_short": "Uzavrieť PO",
        "is_final_invoice_info": "Ak je táto možnosť aktivovaná, prepojená objednávka sa automaticky označí ako dokončená. Potom už k tejto objednávke nie je možné priradiť žiadne ďalšie faktúry.",
        "invoice_prefix_options": {
            "RE": "bežná faktúra",
            "AZ": "žiadosť o zálohovú platbu / pro forma faktúra",
            "VK": "zálohová faktúra",
            "SR": "záverečná faktúra",
            "GS": "dobropis"
        },
        "invoice_number_formatted": "Interné RE číslo",
        "due_date": "Dátum splatnosti",
        "delivery_date": "Dátum dodania",
        "invoice_date": "Dátum faktúry",
        "vat_due_date": "Dátum zdaniteľného plnenia",
        "tax": "Sadzba dane %",
        "total_brutto": "Celkom s DPH",
        "total_netto": "Celková netto",
        "total_netto_abbr": "Celkom bez DPH",
        "document_discount_amount": "Čiastka zľavy dokladu",
        "document_discount_base_amount": "Základ zľavy dokladu",
        "document_discount_percentage": "Zľava dokladu %",
        "document_discount_tax_percentage": "DPH zľavy dokladu %",
        "document_discount_percentage_tooltip": "Percento zľavy na úrovni dokladu uplatnené na základ (EN 16931 BT-94).",
        "document_discount_amount_tooltip": "Absolútna suma zľavy na úrovni dokladu (EN 16931 BT-92).",
        "document_discount_base_amount_tooltip": "Čistá suma, z ktorej sa zľava dokladu vypočítava (EN 16931 BT-93).",
        "document_discount_tax_percentage_tooltip": "Sadzba DPH použitá na daňové priradenie zľavy dokladu.",
        "supplier_vat_number": "DIČ",
        "supplier_payment_method": "Spôsob platby",
        "supplier_iban": "IBAN",
        "supplier_bic": "BIC",
        "supplier_bank_country": "Krajina banky",
        "supplier_bank_account": "Číslo účtu",
        "supplier_bank_code": "Smerové číslo banky",
        "payment_reference": "Platobná referencia",
        "fix_recognition": "Nie som spokojný s detekciou",
        "fix_recognition_checkbox": "Nie som spokojný s uznaním faktúry.",
        "paid": "Už zaplatené.",
        "paid_auto_by_bank_statement_hint": "Automaticky označené ako zaplatené na základe analýzy bankového výpisu dňa {date}.",
        "paid_manual_by_bank_statement_hint": "Označené ako zaplatené ručným párovaním bankového výpisu dňa {date}.",
        "review_status": "Výsledok kontroly",
        "selected_review_status": "Vybraný dôvod",
        "review_status_options": {
            "content_rejection": "Faktúra zamietnutá z vecných dôvodov",
            "insolvency_rejection": "Faktúra zamietnutá z dôvodu insolvenčného práva",
            "further_review_required": "Faktúra vyžaduje ďalšiu kontrolu",
            "other_reason_rejection": "Stornované z iného dôvodu",
            "approved": "Faktúra schválená"
        },
        "currency": "mena",
        "notes": "poznámky",
        "order_notes": "Poznámky k objednávke",
        "discount_percentage": "Zľava 1 percento",
        "discount_amount": "Hotovostná zľava 1 - suma",
        "discount_days": "Hotovostná zľava 1 - Vezmite",
        "discount_payment_date": "Skonto 1 - Dátum",
        "discount_percentage2": "Zľava 2 percentá",
        "discount_amount2": "Hotovostná zľava 2 - suma",
        "discount_days2": "Zľava 2 - Vezmite",
        "discount_payment_date2": "Skonto 2 - Dátum",
        "type_discount_amount": "currency",
        "type_discount_amount2": "currency",
        "payment_in_advance": "Platba vopred",
        "einvoice_status": {
            "is_einvoice": "E‑faktúra",
            "not_einvoice": "Žiadna e‑faktúra",
            "not_relevant_hint": "Žiadna e‑faktúra, nie je relevantná pre odpočet DPH",
            "tax_not_refundable_hint": "DPH vo výške {amount} nebude možné od 1. januára 2027 vrátiť.",
            "zugferd10_hint": "ZUGFeRD 1.0 nie je platná e-faktúra v zmysle povinnosti e-fakturácie (EN 16931)."
        },
        "electronic_validation": {
            "blocked_title": "Faktúra nespĺňa zákonné požiadavky",
            "blocked_message": "Keďže faktúra nespĺňa zákonné požiadavky, ďalšie spracovanie sa neodporúča. Manuálne spracovanie je napriek tomu možné.",
            "blocked_status": "Vyžaduje kontrolu",
            "manual_export_warning_title": "Technické chyby elektronickej faktúry",
            "manual_export_warning_message": "Technická validácia tejto elektronickej faktúry obsahuje chyby. Manuálne spracovanie môže pokračovať, ale neodporúča sa. Chcete export vedome napriek tomu pokračovať?",
            "manual_export_bulk_warning_message": "Aspoň jedna z vybraných elektronických faktúr obsahuje technické chyby. Manuálne spracovanie môže pokračovať, ale neodporúča sa. Chcete export vedome napriek tomu pokračovať?",
            "manual_export_warning_confirm": "Pokračovať v exporte",
            "manual_export_warning_cancel": "Zrušiť",
            "show_details": "Zobraziť detaily",
            "hide_details": "Skryť detaily",
            "rule_set": "Balík pravidiel",
            "external_reference_uris": "Externé odkazy",
            "notify_supplier": "Upozorniť dodávateľa",
            "admin_report_hint": "Úplnú technickú správu môžu stiahnuť iba správcovia.",
            "issue": {
                "malformed_xml": "Súbor XML nie je správne vytvorený alebo obsahuje nepovolené konštrukcie XML.",
                "external_reference_not_resolved": "Elektronická faktúra odkazuje na externý zdroj. Z bezpečnostných dôvodov a z dôvodov ochrany súkromia Liftbase externé zdroje automaticky nenačítava ani nerozpoznáva.",
                "unknown_format": "Formát faktúry XML nie je podporovaný.",
                "unsupported_version": "Pre zistenú rodinu verzií nie je k dispozícii aktívny balík pravidiel.",
                "outdated_version": "Faktúra používa staršiu verziu XRechnung {version}. Zobrazuje sa ako upozornenie a sama osebe nebráni zákonom povolenému spracovaniu.",
                "unsupported_profile": "Zistený formát a profil nespĺňajú zákonné požiadavky normy EN 16931, a preto ich nemožno prijať ako elektronickú faktúru v súlade s právnymi predpismi. Použite formát alebo profil faktúry vyhovujúci norme EN 16931, napríklad ZUGFeRD s profilom EN 16931 alebo XRechnung v právne platnej verzii.",
                "zugferd_10_unsupported": "Bol zistený zastaraný formát ZUGFeRD 1.0 (profil: {profile}). Táto verzia nie je podporovaná. Dodávateľ musí faktúru znova vystaviť ako aktuálny Factur-X/ZUGFeRD alebo XRechnung.",
                "electronic_invoice_extraction_failed": "Z technicky platnej elektronickej faktúry sa nepodarilo prevziať údaje.",
                "kosit_execution_failed": "Technickú validáciu elektronickej faktúry nebolo možné spustiť.",
                "kosit_processing_failed": "Pri technickej validácii elektronickej faktúry nastala chyba spracovania.",
                "processing_error": "Technickú validáciu elektronickej faktúry nebolo možné dokončiť.",
                "multiple_bodies": "Našli sa viaceré tele faktúry. Podľa miestnych pravidiel FatturaPA sú spracovateľné len dokumenty s jedným telom.",
                "format_mismatch": "Prenosový formát FatturaPA (versione / FormatoTrasmissione) nezodpovedá miestnym pravidlám FatturaPA.",
                "fatturapa_total_mismatch": "Súčty dokladu nesúhlasia podľa miestnych pravidiel FatturaPA.",
                "unsupported_document_type": "Tento typ dokumentu FatturaPA nie je podľa miestnych pravidiel FatturaPA podporovaný.",
                "fatturapa_schema_violation": "Dokument neprešiel miestnou XSD validáciou FatturaPA.",
                "fatturapa_line_total_mismatch": "Súčet riadku nezodpovedá množstvu × jednotkovej cene po zľavách (miestne pravidlá FatturaPA).",
                "fatturapa_riepilogo_mismatch": "Súčty riadkov nezodpovedajú daňovému súhrnu (miestne pravidlá FatturaPA).",
                "fatturapa_destinatario_missing": "Kód príjemcu (CodiceDestinatario / PEC) chýba alebo je neúplný (miestne pravidlá FatturaPA).",
                "fatturapa_tax_mismatch": "Sumy DPH nezodpovedajú základu × sadzbe (miestne pravidlá FatturaPA).",
                "fatturapa_business_rule_failed": "Miestne obchodné pravidlá FatturaPA sa nepodarilo vyhodnotiť.",
                "fatturapa_iban_format": "IBAN na faktúre neprešiel kontrolou formátu (miestne pravidlá FatturaPA).",
                "fatturapa_vat_id_sanity": "Identifikátor DPH (IdFiscaleIVA) neprešiel základnou kontrolou dĺžky/znakov (miestne pravidlá FatturaPA).",
                "fatturapa_destinatario_length": "Dĺžka CodiceDestinatario nezodpovedá očakávanému formátu prenosu (miestne pravidlá FatturaPA)."
            },
            "local_scope_hint": "Iba miestna validácia FatturaPA — nejde o prijatie SDI ani o právnu istotu odpočtu DPH na vstupe.",
            "local_accepted_title": "Platné podľa miestnych pravidiel FatturaPA",
            "warning_title": "Upozornenia technickej validácie",
            "status": {
                "acceptable": "Prijatá",
                "rejected": "Odmietnutá",
                "undefined": "Neurčené",
                "technical_error": "Technická chyba"
            },
            "supplier_template": {
                "subject": "Vaša faktúra {number} z {invoiceDate}",
                "unknown_value": "neuvedené",
                "rule_set_unavailable": "žiadny zodpovedajúci balík pravidiel",
                "no_specific_reason": "Validátor nevrátil konkrétne chybové hlásenie. Skontrolujte úplnú technickú validačnú správu.",
                "reasons_heading": "Čo je potrebné opraviť?",
                "body": "<p>Dobrý deň,</p><p>Faktúru v jej súčasnej podobe nie je možné akceptovať ako elektronickú faktúru v súlade so zákonom, pretože zistený formát alebo profil nespĺňa zákonné požiadavky.</p><p style=\"margin-bottom:-4px\"><strong>Dotknutá faktúra:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Číslo faktúry:</strong> {number}</li><li><strong>Dátum faktúry:</strong> {invoiceDate}</li><li><strong>Zistený formát:</strong> {standard}</li><li><strong>Zistená verzia:</strong> {version}</li><li><strong>Zistený profil:</strong> {profile}</li></ul>{reasonsSection}<br><p>Použite prosím formát alebo profil faktúry podľa EN 16931, napr. ZUGFeRD s profilom EN 16931 alebo XRechnung v podporovanej verzii.</p><p>Vystavte prosím opravenú elektronickú faktúru a znova nám ju zašlite.</p><p>Ďakujeme za spoluprácu.</p>",
                "body_fatturapa": "<p>Dobrý deň,</p><p>Faktúru v jej súčasnej podobe nie je možné akceptovať ako elektronickú faktúru v súlade so zákonom, pretože zistený formát alebo profil nespĺňa zákonné požiadavky.</p><p style=\"margin-bottom:-4px\"><strong>Dotknutá faktúra:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Číslo faktúry:</strong> {number}</li><li><strong>Dátum faktúry:</strong> {invoiceDate}</li><li><strong>Zistený formát:</strong> {standard}</li><li><strong>Zistená verzia:</strong> {version}</li><li><strong>Zistený profil:</strong> {profile}</li></ul>{reasonsSection}<br><p>Použite prosím formát alebo profil faktúry podľa EN 16931, napr. ZUGFeRD s profilom EN 16931 alebo XRechnung v podporovanej verzii.</p><p>Vystavte prosím opravenú elektronickú faktúru a znova nám ju zašlite.</p><p>Ďakujeme za spoluprácu.</p>"
            }
        },
        "einvoice": {
            "title": "Dashboard e‑faktúr",
            "analysis_period": "Obdobie analýzy",
            "filters": {
                "date_range": "Časové rozmedzie",
                "client": "Spoločnosť",
                "supplier": "Dodávateľ",
                "select_period": "Vyberte obdobie"
            },
            "placeholders": {
                "all": "Všetko"
            },
            "kpis": {
                "percent_einvoices": "Podiel e‑faktúr",
                "total_tax_eur": "Celková daň na vstupe",
                "potential_loss": "Riziko dane na vstupe",
                "total_invoices": "Celkom faktúr",
                "non_einvoice_quote": "Podiel iných ako e‑faktúr",
                "top_10_risk_share": "Podiel Top-10 dodávateľov na riziku dane",
                "total_suppliers": "Celkom dodávateľov",
                "suppliers_with_einvoice": "Dodávatelia s e‑faktúrou",
                "suppliers_without_einvoice": "Dodávatelia bez e‑faktúry",
                "avg_einvoice_quote": "Priemerná e-kvóta (aktívni dodávatelia)",
                "evaluated_months": "Vyhodnotené mesiace",
                "data_coverage": "Dátové krytie",
                "risk_concentration": "Koncentrácia rizika",
                "only_suppliers_with_min_1": "iba dodávatelia s aspoň 1 e‑faktúrou"
            },
            "charts": {
                "format_distribution": "Distribúcia formátu",
                "format_distribution_subtitle": "Podiel XML, PDF+XML a neštruktúrovaných faktúr",
                "monthly_trend": "Mesačný trend podľa formátu faktúry",
                "monthly_trend_subtitle": "Skladané množstvá za mesiac",
                "top_suppliers_risk": "Top dodávatelia podľa rizika dane",
                "top_suppliers_risk_subtitle": "Vysoká koncentrácia rizika na jednotlivých dodávateľov"
            },
            "table": {
                "monthly_evolution": "Mesačný vývoj",
                "all_suppliers": "Všetci dodávatelia podľa e-kvóty (zostupne)",
                "month": "MESIAC",
                "xml": "XML",
                "pdf_xml": "PDF+XML",
                "non_einvoice": "NIE JE E‑FAKTÚRA",
                "risk": "RIZIKO DANE",
                "supplier": "DODÁVATEĽ",
                "quote": "E-KVÓTA",
                "total_tax": "CELKOM DAŇ"
            },
            "banner": {
                "title": "Odhadovaná výška DPH, ktorú od 01.01.2027 finančný úrad nevráti:",
                "subtitle": "{percent}% odhadovanej dane z obratu (Model formálneho rizika)",
                "description": "Obdobie: {start} až {end}. Povinnosť prijatia od 01.01.2025. Regulačný tlak sa zvyšuje od 01.01.2027. Zvýšené riziko formálnej platnosti pre neštruktúrované tuzemské B2B faktúry od 01.01.2028. Model posudzuje iba zhodu formátu."
            },
            "hint": "Upozornenie: Štát čoskoro prestane vracať dane pri neelektronických faktúrach. Kontaktujte svojich dodávateľov čo najskôr, aby ste zabezpečili, že svoje e‑faktúry budete dostávať správne a neprídete o peniaze.",
            "alert": {
                "title": "Pozor: Vyššie daňové a formálne riziko pri neelektronických faktúrach",
                "item_1": "Od 01.01.2027 výrazne rastie riziko pri neštruktúrovaných faktúrach.",
                "item_2": "Pri takýchto faktúrach môže finančný úrad odmietnuť vrátenie DPH.",
                "item_3": "Od 01.01.2028 to platí pre všetkých dodávateľov, aj pod obratom 800.000 € (prechodné pravidlo iba pre rok 2027).",
                "item_4": "Odporúčanie: Preveďte všetkých svojich dodávateľov včas na e‑faktúry a vyžiadajte si upravené vystavovanie faktúr."
            },
            "action_button": "Informovať dodávateľov",
            "email_dialog": {
                "title": "Informovať dodávateľov",
                "to": "E-mail príjemcu",
                "subject": "Predmet",
                "message": "Správa",
                "download_eml": "Stiahnuť .eml",
                "select_supplier_warning": "Najprv vyberte dodávateľa.",
                "default_subject": "Dôležité: Prechod na elektronické faktúry – {supplier}",
                "default_message": "Vážený tím {supplier},\n\nv súčasnosti preverujeme naše procesy vrátenia daní. V období od {startDate} do {endDate} sme vo vašich faktúrach identifikovali celkom {amount} na daniach, ktoré neboli zaslané ako e‑faktúry (ZUGFeRD oder XRechnung).\n\nVezmite prosím na vedomie, že štát čoskoro prestane vracať dane pri neelektronických faktúrach. Aby sme zabezpečili našu ďalšiu spoluprácu a predišli finančným stratám, láskavo vás žiadame, aby ste čo najskôr prešli na zasielanie elektronických faktúr.\n\nĎakujeme za spoluprácu.\n\nS pozdravom,\n{userName}\n{tenantName}\nVaša účtovňa"
            }
        },
        "export_individual_items": "Exportovať jednotlivé položky",
        "export_individual_items_tooltip": "Ak je toto políčko začiarknuté, namiesto údajov hlavičky sa prenášajú pozície.",
        "status": "Postavenie",
        "statuses": {
            "open": "Rozpoznávanie faktúr",
            "export": "Pripravené na export",
            "declined": "Kontrolované",
            "declined-exported": "Stornované-Exportované",
            "completed": "Dokončené",
            "approval": "Manuálna kontrola",
            "financial-approval": "Schválenie",
            "clearing": "Objasnenie účtovníctva",
            "accounting": "Účtovníctvo"
        },
        "page": {
            "ai_validation_result": {
                "title": "Výsledok validácie KI",
                "result": "Výsledok",
                "green_flags": "Pozitívne signály (Green Flags)",
                "red_flags": "Rizikové signály (Red Flags)",
                "score": "Skóre",
                "check_method": "Metóda kontroly",
                "signals_considered": "Zohľadnené signály",
                "signals_missing": "Chýbajúce signály",
                "system_prompt": "Systémový prompt",
                "user_prompt": "Užívateľský prompt",
                "context": "Kontext",
                "no_data": "Pre túto faktúru nie sú k dispozícii žiadne údaje validácie KI.",
                "response": "Odpoveď (JSON)",
                "trust_level": "Dôveryhodné",
                "not_trust_level": "Nedôveryhodné",
                "btn_tooltip": "Zobraziť podrobnosti validácie KI",
                                "decision_summary": "Odôvodnenie",
                "what_decided": "Čo rozhodlo?",
                "positive_contributions": "Pozitívne príspevky",
                "risk_contributions": "Rizikové príspevky",
                "scoring_method": "Metóda",
                "scoring_method_linear": "Lineárna",
                "scoring_method_multiplicative": "Multiplikatívna",
                "scoring_method_confidence": "Konfidencia",
                "score_kind_risk": "Rizikové skóre",
                "score_kind_confidence": "Skóre konfidencie",
                "score_kind_green_sum": "Súčet pozitívnych signálov",
                "score_explanation_title": "Ako KI dospela k rozhodnutiu",
                "score_scale_hint_risk": "Orientácia: 0 = žiadne rozpoznateľné zvyšné riziko, 1 = maximálne riziko. Čím nižšia hodnota, tým pravdepodobnejšie môže byť faktúra automaticky schválená.",
                "score_scale_hint_confidence": "Orientácia: 0 = veľmi neisté, 1 = veľmi isté. Čím vyššia hodnota, tým pravdepodobnejšie môže byť faktúra automaticky schválená.",
                "score_scale_hint_green_sum": "Orientácia: 0 = žiadne významné pozitívne signály, 1 = veľmi silné pozitívne signály. Čím vyššia hodnota, tým pravdepodobnejšie môže byť faktúra automaticky schválená.",
                "decision_reasons_trusted": "Rozhodujúce boli navyše: {ai_validation_reason_value}.",
                "decision_reasons_not_trusted": "Rozhodujúce boli: {ai_validation_reason_value}.",
                "decision_reasons_insufficient_positive": "Pozitívne signály nestačili: {ai_validation_reason_value}.",
                "show_calculation": "Zobraziť výpočet",
                "formula_linear": "Riziko = RedSum − GreenSum = {red_sum} − {green_sum} = {final_score}",
                "formula_multiplicative_risk": "Riziko = (RedSum × Boost) × (1 − GreenSum) = ({red_sum} × {boost}) × (1 − {green_sum}) = {final_score}",
                "formula_multiplicative_green": "GreenSum = {green_sum}",
                "formula_confidence": "Konfidencia = GreenSum − RedPenalty = {green_sum} − {red_sum} = {final_score}",
                "decision_passed": "{score_label} {final_score} {comparison} {threshold} → dôveryhodné",
                "decision_failed": "{score_label} {final_score} {comparison} {threshold} → nedôveryhodné",
                "finding": "Výsledok",
                "detected": "Zistené / Áno",
                "not_detected": "Nezistené / Nie",
                "certainty_label": "Istota",
                "tokens_used": "Použité KI tokeny (Vstup: {tokens_in}, Výstup: {tokens_out})",
                "tokens_not_used": "Neboli použité žiadne KI tokeny",
                "ai_checked_flags": "Skontrolované KI",
                "local_checked_flags": "Lokálne overené pred KI",
                "parse_error": "Odpoveď KI sa nepodarilo spracovať ako JSON.",
                "flag_descriptions": {
                    "GREEN_01": "Povinné polia sú kompletné (číslo faktúry, dátum, dodávateľ, sumy, daňové údaje).",
                    "GREEN_02": "Historická plausibilita pri dodávateľovi (podobné sumy, štruktúra, popisy a intervaly).",
                    "GREEN_03": "E‑mail odosielateľa je známy (zodpovedá kmeňovým údajom alebo historickým e‑mailom dodávateľa).",
                    "GREEN_04": "Sumy pôsobia vzhľadom na plnenie vierohodne (odhadovaná cenová úroveň sedí na sumu).",
                    "GREEN_05": "Faktúra sa viaže na jasné obdobie plnenia (obdobie je uvedené a neprekrýva sa).",
                    "GREEN_06": "Bankové údaje zodpovedajú kmeňovým údajom (IBAN/príjemca sa presne zhoduje).",
                    "RED_01": "E‑mail odosielateľa sa líši (nová alebo mierne zmenená doména).",
                    "RED_02": "Obdobie sa prekrýva s existujúcimi faktúrami (obdobie je už pokryté).",
                    "RED_03": "Vysoká suma alebo vysoké inherentné riziko (suma nad limitom alebo riziková kategória).",
                    "RED_04": "Náhly nárast sumy pri rovnakom dodávateľovi (výrazný nárast bez jasného dôvodu).",
                    "RED_05": "Objednávka/zmluva chýba alebo sa odchyľuje (historicky očakávaná, ale chýba, alebo výrazný nesúlad s prepojenou objednávkou).",
                    "RED_06": "Odlišné bankové údaje oproti kmeňovým údajom (nový/zmenený IBAN)."
                }
            },
            "upload": {
                "title": "Nahrajte nové faktúry",
                "info": "Presuňte myšou alebo kliknite sem a nahrajte jednu alebo viacero faktúr (*.pdf do 30 MB).",
                "info_attachments": "Presuňte súbory myšou alebo kliknite sem na nahranie jednej alebo viacerých príloh (do 30 MB na súbor).",
                "create_btn": "Spustite rozpoznávanie faktúr",
                "file_invalid": "Odovzdávajte iba súbory PDF or XML do veľkosti 30 MB.",
                "no_preview_available": "Pre tento typ súboru nie je k dispozícii žiadny náhľad. <br>Stiahnite si súbor a otvorte ho na svojom počítači.",
                "settings": "Nastavenia",
                "group_by_tax": "Zoskupiť podľa sadzby dane pri rozpoznávaní",
                "group_by_tax_hint": "Ak je zapnuté, rozpoznané riadky budú pri nahraní zoskupené podľa sadzby dane (napr.: Súčet 19 % dane).",
                "ai_validation": "Aktivovať validáciu KI",
                "ai_validation_hint": "Ak je aktivované, faktúra sa po rozpoznaní KI presunie priamo do stavu „Pripravené na export“, pokiaľ nie sú vyžadované žiadne kroky schvaľovania.",
                "ai_validation_mode": "Validácia KI",
                "ai_validation_mode_none": "Bez validácie KI",
                "ai_validation_auto_forward": "Aktivovať a presunúť do stavu „Pripravené na export“",
                "ai_validation_auto_forward_hint": "Ak je aktivované, faktúra sa po rozpoznaní KI presunie priamo do stavu „Pripravené na export“, pokiaľ nie sú vyžadované žiadne kroky schvaľovania.",
                "ai_validation_advisory": "Aktivovať a ponechať stav bez zmeny",
                "ai_validation_advisory_forced": "Už aktívne, stav zostáva bez zmeny",
                "ai_validation_advisory_hint": "Ak je aktivované, KI overí faktúru, zapíše výsledok do časovej osi a zobrazí detaily skóre bez preskočenia bežného workflow.",
                "tour": {
                    "before_attach": "Tu môžete nahrať jednu alebo viac faktúr presunutím myšou alebo kliknutím do oblasti.",
                    "after_attach_title": "Spustite rozpoznávanie faktúr",
                    "after_attach": "Tu môžete spustiť automatické rozpoznávanie všetkých nahraných faktúr. Následne budete presmerovaný na prehľad prvej faktúry. Ostatné faktúry potom nájdete v zozname úloh."
                }
            },
            "tabs": {
                "lines": "Položky",
                "discount": "Zľava",
                "payment": "Platobné údaje",
                "transactions": "Transakcie",
                "notes": "Poznámky",
                "recognition": "Surové údaje rozpoznania dokladu"
            },
            "linked_transactions": {
                "title": "Priradené transakcie",
                "empty": "Nenašli sa žiadne priradené transakcie.",
                "load_error": "Priradené transakcie sa nepodarilo načítať.",
                "statement": "Výpis",
                "match_type": "Typ priradenia",
                "allocated_amount": "Priradená suma",
                "match_type_direct": "Priame",
                "match_type_manual": "Rozdelené"
            },
            "new": "Nový účet",
            "select_contract_or_procurement": "Zmluva / Požiadavka na objednávku",
            "payment_conditions": "Platobné podmienky",
            "discount1": "Zľava 1",
            "discount2": "Zľava 2",
            "discount_percentage": "percent",
            "discount_amount": "Suma",
            "discount_days": "vziať",
            "discount_payment_date": "Dátum",
            "invoice_discount_data": "Údaje o skonte na doklade",
            "supplier_discount_data": "Údaje o skonte v kmeňových údajoch",
            "business_partner_discount_data": "Údaje o skonte v kmeňových údajoch obchodného partnera",
            "copy_discount_data_to_supplier": "Preniesť z dokladu do kmeňových údajov",
            "copy_discount_data_to_supplier_tooltip": "Po kliknutí sa údaje o skonte zadané vo formulári skopírujú do kmeňových údajov dodávateľa.",
            "copy_discount_data_to_business_partner_tooltip": "Po kliknutí sa údaje o skonte zadané vo formulári skopírujú do kmeňových údajov obchodného partnera.",
            "magic_suggestions_btn_tooltip": "Návrhy na vyplnenie na základe predchádzajúcich faktúr od toho istého dodávateľa",
            "magic_suggestions_btn_tooltip_business_partner": "Návrhy na vyplnenie na základe predchádzajúcich faktúr od toho istého obchodného partnera",
            "magic_suggestions_dialog": {
                "title": "Návrhy pre túto faktúru",
                "message": "Vyberte polia, ktoré chcete vyplniť na základe iných faktúr tohto dodávateľa.",
                "info_based_on_invoices": "Návrhy sú založené na nasledujúcich RE číslach:",
                "select_supplier_msg": "Vyberte vo formulári dodávateľa, aby bolo možné vyhľadať návrhy.",
                "no_data": "Pre tohto dodávateľa sa nenašli žiadne návrhy.",
                "error_load": "Pri načítavaní návrhov došlo k chybe.",
                "applied_success": "Návrhy boli použité."
            },
            "magic_suggestions_dialog_business_partner": {
                "message": "Vyberte polia, ktoré chcete vyplniť na základe iných faktúr tohto obchodného partnera.",
                "select_supplier_msg": "Ak chcete načítať návrhy, vyberte vo formulári obchodného partnera.",
                "no_data": "Pre tohto obchodného partnera sa nenašli žiadne návrhy."
            },
            "procurement_summary": {
                "dialog_title": "Obsah nákupnej požiadavky",
                "open_dialog": "Zobraziť detaily",
                "line_count": "{count} položiek v prehľade",
                "empty": "Pre túto nákupnú požiadavku nie sú k dispozícii žiadne položky.",
                "empty_filtered": "V nákupnej požiadavke sa pre vybraného dodávateľa \"{supplier_name}\" nenašli žiadne položky.",
                "filtered_by_supplier": "Zobrazujú sa iba položky dodávateľa \"{supplier_name}\".",
                "item": "Položka"
            },
            "download_pdf": "Stiahnuť PDF",
            "download_pdf_info": "Ak sa PDF nezobrazuje, skontrolujte nastavenia prehliadača a uistite sa, že možnosť \"Vždy sťahovať súbory PDF\" je vypnutá.",
            "download_xml": "Stiahnuť XML",
            "download_xml_info": "Stiahne pôvodný XML súbor FatturaPA.",
            "visualization_generated_hint": "Toto PDF bolo vygenerované z XML e-faktúry. Právne záväzný ostáva XML.",
            "visualization_compare_hint": "PDF z XML ukazuje obsah XML; pôvodné PDF sa môže líšiť. Právne záväzný ostáva XML.",
            "visualization_version_hint": "Verzia vizualizácie: {version}.",
            "visualization_history": "Verzie PDF",
            "visualization_history_title": "Verzie PDF",
            "visualization_version_label": "Verzia PDF {version}",
            "visualization_current_version": "Aktuálna",
            "visualization_version_created_at": "Vytvorené: {date}",
            "visualization_version_renderer": "Verzia vykresľovania: {renderer}",
            "visualization_version_view": "Zobraziť",
            "visualization_version_download": "Stiahnuť",
            "visualization_version_loading": "Načítava sa PDF ...",
            "visualization_version_load_error": "Verziu PDF sa nepodarilo načítať.",
            "regenerate_visualization": "Znova vygenerovať PDF",
            "regenerate_visualization_title": "Znova vygenerovať PDF",
            "regenerate_visualization_confirm": "PDF sa znova vygeneruje pomocou aktuálnej verzie vykresľovania. Predchádzajúca verzia zostane zachovaná. Chcete pokračovať?",
            "regenerate_visualization_confirm_button": "Znova vygenerovať",
            "regenerate_visualization_success": "Verzia PDF {version} bola úspešne vygenerovaná.",
            "regenerate_visualization_error": "PDF sa nepodarilo znova vygenerovať.",
            "document_tabs": {
                "xml": "XML",
                "preview": "Náhľad",
                "pdf": "PDF",
                "original_pdf": "Pôvodné PDF",
                "visualization": "KoSIT-PDF",
                "fatturapa": "FatturaPA",
                "fatturapa_pdf": "FatturaPA-PDF"
            },
            "fatturapa_preview": {
                "eyebrow": "FatturaPA",
                "invoice": "Faktúra",
                "credit_note": "Dobropis",
                "debit_note": "Ťarchopis",
                "number": "Číslo",
                "date": "Dátum",
                "profile": "Formát",
                "order_data": "Údaje objednávky",
                "order_number": "Číslo",
                "purchase_order_number": "Číslo objednávky",
                "line_reference": "Odkaz na riadok",
                "order_reference": "Odkaz na objednávku",
                "item_number": "Číslo položky",
                "convention_code": "Kód dohody",
                "cup": "CUP",
                "cig": "CIG",
                "supplier": "Dodávateľ",
                "customer": "Odberateľ",
                "vat_id": "IČ DPH",
                "fiscal_code": "Daňový kód",
                "lines": "Položky",
                "description": "Popis",
                "qty": "Množstvo",
                "unit_price": "Jedn. cena",
                "discount": "Zľava",
                "document_discount": "Zľava dokladu",
                "line_total": "Spolu položka",
                "vat": "DPH",
                "taxable": "Základ dane",
                "tax": "Daň",
                "total": "Spolu",
                "payment": "Platba",
                "payment_method": "Spôsob",
                "show_xml": "Zobraziť XML",
                "hide_xml": "Skryť XML",
                "footnote": "Lokálny náhľad FatturaPA — právne záväzný ostáva XML. Nie je to výsledok SDI."
            },
                "notes_datev_hint": "Táto poznámka bude prostredníctvom DATEV Unternehmen Online odoslaná daňovému poradcovi.",
            "recognition_data_title": "Nespracované údaje rozpoznávania dokumentov",
            "no_recognition_data": "Nezistili sa žiadne údaje.",
            "repeat_recognition_btn": "Zopakovať rozpoznanie dokladu",
            "repeat_recognition_confirm_btn": "Potvrdiť",
            "repeat_recognition_confirm_msg": "Existujúce údaje vo formulári budú prepísané. Naozaj chcete pokračovať?",
            "repeat_recognition_confirm_title": "Zopakovať rozpoznanie dokladu",
            "repeat_recognition_feedback_msg": "Rozpoznávanie dokumentov prebieha na pozadí a môže to trvať niekoľko sekúnd.",
            "select_columns_btn": "Vybrať stĺpce",
            "export_to_datev_btn": "Odoslať na DATEV",
            "export_to_datev_csv_btn": "Exportovať DATEV CSV",
            "export_to_ms365_btn": "Odoslať na D365",
            "export_btn_incomplete_form_tooltip": "Prosím, vyplňte údaje faktúry.",
            "export_btn_send_to_clearing_tooltip": "Ak chcete znova preniesť do D365, odošlite prosím znova na účtovníctvo cez krok 'Riešenie'.",
            "export_error": "<b>Faktúru sa nepodarilo odoslať</b>.<br>",
            "no_export_config_datev_tooltip": "Nebolo nastavené žiadne pripojenie k <b>{export_name}</b>. <br>V konfigurácii nebol pridelený žiadny klient DATEV pre vybranú spoločnosť <b>{client_name}</b>. <br>Ak je to potrebné, kontaktujte osobu s administrátorskými právami <br>na nastavenie pripojenia v administračnej oblasti.",
            "no_export_config_tooltip": "Nebolo vytvorené žiadne pripojenie k {export_name}.<br>V prípade potreby kontaktujte osobu s oprávneniami správcu, aby nastavila pripojenie v oblasti správy.",
            "confirm_before_leave_msg": "Vaša faktúra nebola uložená. Naozaj chcete opustiť stránku?",
            "can_not_edit": "Nemáte povolenie na úpravu údajov. Ak chcete vykonať zmeny v údajoch, odošlite faktúru prostredníctvom akcií na objasnenie.",
            "recognized_client_id": "Spoločnosť bola úspešne identifikovaná na základe <b>DIČ</b> a <b>názvu</b>.<br> <b>Spoločnosť:</b> {client_name}",
            "user_client_id": "Spoločnosť bola priradená na základe <b>užívateľského profilu</b> nahrávateľa.<br><b>Spoločnosť:</b> {client_name}",
            "field_origin": {
                "title": "Pôvod predvýberu",
                "source_label": "Zdroj",
                "history_title": "História rozpoznania",
                "run_title": "{date} · {count} polí{status}{model}",
                "unknown_run": "Neznáme rozpoznanie",
                "field_column": "Pole",
                "before_column": "Predtým",
                "after_column": "Potom",
                "reason_column": "Dôvod",
                "empty_value": "Prázdne",
                "ai_history_title": "História spracovania AI",
                "ai_request_label": "Prompt požiadavky",
                "ai_response_label": "Odpoveď AI",
                "ai_system_prompt_label": "Systémový prompt",
                "ai_user_prompt_label": "Používateľský prompt",
                "ai_sources_label": "Zdroje vlastných promptov",
                "ai_tenant_prompt_label": "Prompt tenanta",
                "ai_client_prompt_label": "Prompt klienta",
                "ai_supplier_prompt_label": "Prompt dodávateľa",
                "ai_recognition": "Rozpoznanie faktúry",
                "ai_custom_prompt": "Následné spracovanie vlastným promptom",
                "ai_supplier_identification": "Identifikácia dodávateľa",
                "ai_validation": "Overenie faktúry",
                "ai_succeeded": "Úspešné",
                "ai_failed": "Neúspešné",
                "source_types": {
                    "recognition": "Rozpoznanie dokladu",
                    "procurement": "Objednávka",
                    "supplier_master_data": "Kmeňové údaje dodávateľa",
                    "business_partner_master_data": "Kmeňové údaje obchodného partnera",
                    "creator_default": "Profil nahrávateľa"
                },
                "reasons": {
                    "invoice_number_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "total_netto_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "total_brutto_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "invoice_date_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "due_date_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "delivery_date_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "document_discount_amount_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "document_discount_base_amount_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "document_discount_percentage_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "document_discount_tax_percentage_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "client_matched_by_receiver_name_or_vat": "Vybraté, pretože rozpoznaný príjemca faktúry zodpovedal spoločnosti podľa názvu alebo DIČ.",
                    "client_matched_by_supplier_name_or_vat": "Vybraté, pretože rozpoznaný vystaviteľ faktúry zodpovedal spoločnosti podľa názvu alebo DIČ.",
                    "client_from_creator_profile": "Prevzaté zo spoločnosti priradenej nahrávateľovi.",
                    "client_from_procurement": "Skopírované z priradenej objednávky.",
                    "supplier_matched_by_name_vat_or_iban": "Vybraté, pretože rozpoznané údaje dodávateľa zodpovedali dodávateľovi podľa názvu, DIČ alebo IBAN.",
                    "business_partner_matched_by_name_vat_or_iban": "Vybraté, pretože rozpoznané údaje protistrany zodpovedali obchodnému partnerovi podľa názvu, DIČ alebo IBAN.",
                    "business_partner_matched_by_receiver_name_or_vat": "Vybraté, pretože rozpoznaný príjemca faktúry zodpovedal obchodnému partnerovi podľa názvu alebo DIČ.",
                    "supplier_from_single_procurement_supplier": "Vybraté, pretože priradená objednávka má presne jedného dodávateľa.",
                    "procurement_matched_by_recognized_reference": "Vybraté, pretože rozpoznaná referencia objednávky zodpovedá tejto objednávke.",
                    "procurement_matched_by_invoice_similarity": "Vybraté, pretože suma, dátum a položky zodpovedajú faktúre.",
                    "procurement_matched_by_invoice_similarity_without_supplier": "Vybraté, pretože suma, dátum a položky zodpovedali faktúre ešte pred výberom dodávateľa.",
                    "ledger_account_from_procurement": "Skopírované z priradenej objednávky.",
                    "cost_center_from_procurement": "Skopírované z priradenej objednávky.",
                    "cost_type_from_procurement": "Skopírované z priradenej objednávky.",
                    "profit_center_from_supplier_master_data": "Skopírované z kmeňových údajov dodávateľa.",
                    "profit_center_from_business_partner_master_data": "Skopírované z kmeňových údajov obchodného partnera.",
                    "department_from_procurement": "Skopírované z priradenej objednávky.",
                    "branch_from_procurement": "Skopírované z priradenej objednávky.",
                    "employee_from_procurement": "Skopírované z priradenej objednávky.",
                    "financial_dimension_from_procurement": "Skopírované z priradenej objednávky.",
                    "ledger_account_from_supplier_master_data": "Skopírované z kmeňových údajov dodávateľa.",
                    "cost_center_from_supplier_master_data": "Skopírované z kmeňových údajov dodávateľa.",
                    "ledger_account_from_business_partner_master_data": "Skopírované z kmeňových údajov obchodného partnera.",
                    "cost_center_from_business_partner_master_data": "Skopírované z kmeňových údajov obchodného partnera.",
                    "posting_key_from_recognized_tax": "Odvodené z rozpoznanej sadzby dane.",
                    "supplier_iban_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "supplier_bic_extracted_from_document": "Priamo extrahované z rozpoznaného dokladu faktúry.",
                    "payment_bank_data_extracted_from_document": "Zdroj bankových údajov bol nastavený podľa rozpoznaných údajov z dokladu."
                }
            },
            "client_address_check": {
                "match": "Bola vykonaná kontrola podľa § 14 ods. 4 UStG a neboli zistené žiadne odchýlky.",
                "unrecognized": "Adresu nebolo možné overiť, pretože nebola na faktúre rozpoznaná.",
                "mismatch_intro": "Bola vykonaná kontrola podľa § 14 ods. 4 UStG a bola zistená odchýlka:",
                "invoice_label": "Údaje na faktúre",
                "master_data_label": "Údaje v kmeňových údajoch",
                "supplier_message_button": "Požiadať o opravu",
                "supplier_message_greeting": "Vážené dámy a páni,",
                "supplier_message_intro": "ďakujeme za zaslanie faktúry.",
                "supplier_message_invoice_number_label": "Číslo faktúry",
                "supplier_message_body": "Žiaľ, adresa/názov našej spoločnosti uvedená na faktúre nie je správna. Podľa § 14 ods. 4 UStG musí faktúra obsahovať správnu adresu a názov príjemcu plnenia, aby spĺňala zákonné požiadavky.",
                "supplier_message_outro": "Preto faktúru v jej súčasnej podobe nemôžeme akceptovať a žiadame vás o zaslanie primerane opravenej faktúry so správnou adresou.",
                "supplier_message_questions": "V prípade otázok sme vám radi k dispozícii.",
                "address_normalization": {
                    "street_aliases": ["ulica", "ul.", "ul", "trieda", "tr.", "námestie", "namestie", "nám.", "nam.", "cesta", "c."],
                    "number_aliases": ["číslo", "cislo", "č.", "c.", "č", "c", "súpisné", "supisne", "orientačné", "orientacne", "or.", "or"]
                }
            },
            "no_client_recognized": "Nebola identifikovaná žiadna spoločnosť na základe <b>DIČ</b> alebo <b>názvu</b>.<br> Skontrolujte, či údaje spoločnosti v liftbase zodpovedajú údajom na faktúre.",
            "recognized_supplier_id": "Na základe <b>IBAN</b>, <b>DIČ</b> a <b>Mena</b> bol dodávateľ úspešne identifikovaný.<br> <b>Dodávateľ:</b> {supplier_name} <br> <b>DIČ:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_custom_prompt_title": "Vlastný prompt dodávateľa",
            "supplier_custom_prompt_applied": "Počas rozpoznania faktúry bol použitý dodávateľský vlastný prompt.",
            "supplier_custom_prompt_supplier_label": "Dodávateľ",
            "supplier_custom_prompt_source_label": "Zdroj",
            "supplier_custom_prompt_confidence_label": "Istota",
            "supplier_custom_prompt_text_label": "Prompt",
            "supplier_custom_prompt_text_empty": "Pre tohto dodávateľa nie je aktuálne uložený žiadny vlastný prompt.",
            "supplier_custom_prompt_source": {
                "sender_domain": "Doména odosielateľa",
                "recognized_supplier_vat_iban": "DIČ/IBAN",
                "recognized_supplier_name": "Názov dodávateľa",
                "first_page_ai": "AI (1. stránka PDF, text)",
                "first_page_ai_file": "AI (1. stránka PDF, sken)"
            },
            "recognized_business_partner_id": "Na základe <b>IBAN</b>, <b>DIČ</b> a <b>Názvu</b> bol obchodný partner úspešne identifikovaný.<br> <b>Obchodný partner:</b> {supplier_name} <br> <b>DIČ:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "no_supplier_recognized": "Nebola identifikovaná žiadna dodávateľská spoločnosť na základe <b>DIČ</b> alebo <b>názvu</b>.<br> Skontrolujte, či údaje dodávateľa v liftbase zodpovedajú údajom na faktúre.",
            "payment_details_not_equal": "Platobné údaje dodávateľa sa nezhodujú s rozpoznanými údajmi alebo údajmi z formulára.<br> <b>Dodávateľ:</b> {supplier_name} <br> <b>DIČ:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "payment_details_not_equal_business_partner": "Platobné údaje obchodného partnera sa nezhodujú s rozpoznanými údajmi alebo údajmi z formulára.<br> <b>Obchodný partner:</b> {supplier_name} <br> <b>DIČ:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_dialog_info": "\n<div style=\"text-align: justify\">\n    <style>\n        .modal-header {\n            margin-bottom: 0;\n        }\n\n        .modal-p {\n            margin-bottom: 10px !important;\n        }\n    </style>\n\n    <p class=\"modal-p\">\n        Zistili sme, že priradený dodávateľ sa zmenil.\n    </p>\n\n    <p class=\"modal-p\">\n        <strong>Možný dôvod:</strong><br>\n        Rozpoznávanie dokladov nedokázalo priradiť žiadneho alebo priradilo nesprávneho dodávateľa.\n    </p>\n\n    <b class=\"modal-header\">Optimalizujte automatické priraďovanie</b>\n    <p class=\"modal-p\">\n        Vedeli ste, že v <strong>liftbase</strong> môžete jednoducho zlepšiť automatické priraďovanie pre budúce doklady?\n        Stačí uložiť bankové spojenie (IBAN, BIC) alebo IČ DPH v kmeňových údajoch dodávateľa.\n        <strong>liftbase</strong> tieto údaje použije na automatické priradenie správneho dodávateľa nabudúce.\n    </p>\n    <p class=\"modal-p\">\n        V časti <strong>„Platobné údaje“</strong> môžete použiť údaje rozpoznané systémom alebo zadať vlastné.\n    </p>\n\n    <img src=\"images/example-payment-data.png\" alt=\"Ukážkový pohľad\"\n         style=\"border: 1px solid #9c9c9c; border-radius: 5px; max-width: 100%; margin-bottom: 10px;text-align: center\"><br>\n\n    <b class=\"modal-header\">Automatická kontrola bankového spojenia</b>\n    <p class=\"modal-p\">\n        Bankové spojenie uložené v <strong>liftbase</strong> sa automaticky kontroluje pri každom doklade.\n        Ak doklad obsahuje odlišné bankové spojenie, budete na to upozornení.\n    </p>\n\n    <p class=\"modal-p\"><strong>Vaše výhody:</strong></p>\n    <ul>\n        <li>Spoľahlivé odhalenie podvodných faktúr s falošnými bankovými údajmi</li>\n        <li>Rýchle zistenie, keď dodávateľ zmenil banku</li>\n    </ul>\n</div>",
            "supplier_dialog_title": "Automatické rozpoznanie dodávateľa",
            "total_brutto_missing": "Zadajte celkovú hrubú sumu.",
            "total_brutto_zero": "Nesmie obsahovať sumu 0 {currency}.",
            "total_brutto_does_not_match_with_positions": "Celkové sumy sa musia rovnať súčtu položiek.",
            "total_brutto_difference": "Odchýlka celkovej sumy vs po\u00ADlož\u00ADky: {value}",
            "combination_invalid": "Kombinácia účtu, nákladového miesta a profitového centra nie je povolená v D365.",
            "possible_combinations": "Povolené kombinácie",
            "current_combination": "Aktuálna kombinácia",
            "combination": "Kombinácia",
            "total_invoiced": "Celková vyfakturovaná suma",
            "total_expected_procurement": "Celková hodnota objednávky",
            "total_expected_contract": "Celková hodnota zmluvy",
            "min_approval_one_person": "1 osoba",
            "min_approval_qty": "{qty} rôzne osoby",
            "min_approval_error_msg": "Schválenie tejto faktúry nie je dostatočné. Pridajte prosím ďalšiu osobu na schválenie. Táto faktúra musí byť schválená <b>minimálne {min_approval_msg}</b>.",
            "min_approval_error_title": "Nedostatočné schválenie",
            "no_approval_limit_msg": "Váš schvaľovací limit nie je pre túto faktúru dostatočný. Pridajte prosím ďalšiu osobu na schválenie, ktorá má potrebný schvaľovací limit.",
            "no_approval_limit_title": "Schvaľovací limit",
            "confirm_without_approval_limit_msg": "Žiadna z vybraných osôb nemá potrebný schvaľovací limit pre hodnotu tejto faktúry. Potrebné schválenia je možné pridať neskôr. Naozaj chcete pokračovať?",
            "confirm_without_approval_limit_title": "Schvaľovací limit",
            "supplier_payment_data": "Platobné údaje dodávateľa",
            "business_partner_payment_data": "Platobné údaje obchodného partnera v kmeňových údajoch",
            "invoice_vat_number": "Rozpoznané IČ DPH",
            "supplier_vat_number": "IČ DPH v kmeňových údajoch",
            "business_partner_vat_number": "IČ DPH v kmeňových údajoch obchodného partnera",
            "copy_vat_number_to_supplier": "Preniesť do kmeňových údajov",
            "invoice_payment_data": "Bankové spojenie na doklade",
            "copy_payment_data_to_supplier": "Skopírovať platobné údaje z faktúry",
            "copy_payment_data_to_supplier_tooltip": "Po kliknutí sa platobné údaje zadané vo formulári skopírujú do kmeňových údajov dodávateľa.",
            "copy_payment_data_to_business_partner_tooltip": "Po kliknutí sa platobné údaje zadané vo formulári skopírujú do kmeňových údajov obchodného partnera.",
            "lines": {
                "add_tooltip": "Pridať riadok faktúry",
                "get_from_recognition": "Prevziať z rozpoznávania dokladov",
                "show_mismatch_panel_button": "Zobraziť odchýlky",
                "hide_mismatch_panel_button": "Skryť odchýlky",
                "mismatch_warning_title": "Zistené rozdiely medzi vypočítaným a dokladovým hrubým",
                "match_suggestion": "Návrh",
                "match_confirmed": "Potvrdené",
                "match_automatic": "Automaticky",
                "match_automatic_suggestion": "Autom. návrh",
                "confirm_match": "Potvrdiť zhodu",
                "review_match": "Skontrolovať",
                "match_confirm_dialog": {
                    "title": "Potvrdiť priradenie položky",
                    "message": "Tieto položky sa môžu zhodovať. Skontrolujte prosím hodnoty a vyberte, ako sa má priradenie uložiť.",
                    "copied_fields_title": "Ďalšie údaje, ktoré sa prevezmú",
                    "copy_hint": "Iba priradenie potvrdí odkaz na objednávku. Prevzatie údajov skopíruje aj nákladové stredisko, účet a finančné dimenzie do položky faktúry.",
                    "link_only_btn": "Potvrdiť iba priradenie",
                    "copy_data_btn": "Potvrdiť a prevziať údaje"
                },
                "legend": {
                    "description": "Legenda",
                    "no_order": "Tovar sa neobjaví v objednávke.",
                    "variance": "Odchýlka v označených stĺpcoch.",
                    "not_invoiced": "Objednaný tovar sa na faktúre nenašiel.",
                    "matched": "Tovar na objednávke a faktúre je rovnaký."
                },
                "group_by_tax": "Zoskupiť podľa sadzby dane",
                "group_by_tax_hint": "Zoskupiť uložené riadky podľa sadzby dane (napr.: Súčet 19 % dane).",
                "form": {
                    "item": "Článok",
                    "new": "Nová položka faktúry",
                    "validation": {
                        "description_required": "Zadajte meno.",
                        "item_number_required": "Zadajte číslo článku.",
                        "tax_percentage_required": "Uveďte platnú daň.",
                        "unit_net_price_required": "Zadajte platné číslo.",
                        "quantity_required": "Zadajte platné číslo.",
                        "commercial_discount_invalid": "Zľava a jej základ musia mať rovnaké znamienko, percentá musia byť medzi 0 % a 100 % a zľava nesmie byť vyššia ako jej základ."
                    },
                    "tour": {
                        "name": "Zadajte zmysluplný názov produktu.",
                        "number": "Tu môžete zadať číslo položky produktu.",
                        "price": "Zadajte sadzbu dane a čistú cenu. Hrubá cena sa potom vypočíta pomocou sadzby dane."
                    }
                },
                "table": {
                    "source": "Tie",
                    "item_number": "Príroda. Nie",
                    "name": "názov",
                    "quantity": "Anz.",
                    "tax": "daň (%)",
                    "netto_price": "Jedna čistá",
                    "brutto_price": "Jednotka hrubá",
                    "line_discount_percentage": "Zľava (%)",
                    "show_discounts": "Zadať zľavu",
                    "show_discounts_tooltip": "Zobrazí polia pre zľavu z jednotkovej ceny a zľavu položky. Automaticky sa aktivuje, ak je zľava vyplnená.",
                    "unit_price_base_amount": "Jednotková cena pred zľavou z ceny",
                    "unit_price_base_amount_tooltip": "Pôvodná cena za jednotku pred odpočítaním zľavy z ceny.",
                    "unit_price_discount_amount": "Zľava z ceny za jednotku",
                    "unit_price_discount_amount_tooltip": "Suma zľavy za jednotku odpočítaná od pôvodnej jednotkovej ceny.",
                    "line_discount_amount": "Celková zľava položky",
                    "line_discount_amount_tooltip": "Suma zľavy za celú fakturačnú položku, nie za jednotku.",
                    "line_discount_base_amount": "Základ zľavy položky",
                    "line_discount_base_amount_tooltip": "Celková suma položky, na ktorú sa zľava uplatňuje.",
                    "line_discount_percentage_tooltip": "Percento uplatnené na celú fakturačnú položku.",
                    "calc_brutto_from_net": "Vypočítať hrubú zo čisté",
                    "calc_net_from_brutto": "Vypočítať čistú z hrubej",
                    "calc_brutto_from_net_tooltip": "Vypočíta iba jednotkovú hrubú cenu z jednotkovej čistej ceny a daňovej sadzby. Zľava položky sa nezmení.",
                    "calc_net_from_brutto_tooltip": "Vypočíta iba jednotkovú čistú cenu z jednotkovej hrubej ceny a daňovej sadzby. Zľava položky sa nezmení.",
                    "discount_validation_error": "Skontrolujte hodnoty označené červenou farbou.",
                    "total_netto_price": "Celková čistá",
                    "tax_amount": "Celková daň",
                    "total_brutto_price": "Celková hrubá suma",
                    "cost_center": "Nákladové stredisko",
                    "profit_center": "Profit center",
                    "ledger_account": "Hlavný účet",
                    "tax_group": "Daňová skupina",
                    "tax_item_group": "Daňová skupina položiek",
                    "open_bcase": "ukázať dokument",
                    "no_order_position": "Nenašli sa žiadne položky objednávky. K faktúre priraďte <b>BANF a doručovaciu spoločnosť</b>.",
                    "no_contract_position": "Nenašli sa žiadne zmluvné položky. Priraďte k faktúre <b>zmluvu a dodávateľa</b>.",
                    "copy_from_procurement": "Vložte všetky položky do objednávky",
                    "copy_from_contract": "Vložiť všetky položky zo zmluvy",
                    "no_order_tooltip": "Zatiaľ nie je prepojená žiadna požiadavka na nákup.",
                    "no_supplier_tooltip": "Zatiaľ nie je pripojeny žiadny dodávateľ.",
                    "validation_error": "Opravte chyby v tabuľke."
                }
            },
            "export_dialog": {
                "title": {
                    "D365": "Vytvoriť denník",
                    "DATEV": "Odoslať do DATEV",
                    "DATEV CSV": "Export DATEV CSV"
                },
                "description": "Nasledujúce dokumenty budú odoslané na {export_name}.",
                "description_csv": "Nasledujúce doklady budú exportované pre {export_name}.",
                "btn_confirm": "Odoslať",
                "btn_confirm_csv": "Exportovať",
                "btn_finish": "Zatvoriť",
                "export_feedback_csv": "Exportované",
                "export_feedback": "Odoslané",
                "exported_csv": "Exportované",
                "exported": "Odoslané",
                "continue_background": "Pokračovať na pozadí",
                "exported_at": "Naposledy exportované",
                "is_loading": "Prebieha odosielanie",
                "is_loading_csv": "Prebieha exportovanie",
                "include_exported": "Zahrnúť už exportované faktúry",
                "export_selected_invoices_btn": "Odoslať výber ({quantity}) do {export_name}",
                "export_cancelled_invoices_btn": "Odoslať vybrané zrušené ({quantity}) do {export_name}",
                "export_all_cancelled_invoices_btn": "Odoslať všetky zrušené ({quantity}) do {export_name}",
                "export_all_invoices_btn": "Odoslať všetky doklady ({quantity}) do {export_name}"
            },
            "export_menu": {
                "title": "Export",
                "group_ready": {
                    "title": "Export: Dokončené faktúry"
                },
                "group_cancelled": {
                    "title": "Export: Zrušené faktúry"
                }
            },
            "bulk_cancel_dialog": {
                "selected_btn": {
                    "invoice": "Zrušiť vybrané faktúry ({quantity})",
                    "outgoing-invoice": "Zrušiť vybrané odoslané faktúry ({quantity})",
                    "procurement": "Zrušiť vybrané objednávky ({quantity})",
                    "contract": "Zrušiť vybrané zmluvy ({quantity})",
                    "mixed": "Zrušiť vybrané doklady ({quantity})"
                },
                "confirm_title": {
                    "invoice": "Zrušiť faktúry",
                    "outgoing-invoice": "Zrušiť odoslané faktúry",
                    "procurement": "Zrušiť objednávky",
                    "contract": "Zrušiť zmluvy",
                    "mixed": "Zrušiť doklady"
                },
                "confirm_message": {
                    "invoice": "Naozaj chcete zrušiť všetky vybrané faktúry ({quantity})?",
                    "outgoing-invoice": "Naozaj chcete zrušiť všetky vybrané odoslané faktúry ({quantity})?",
                    "procurement": "Naozaj chcete zrušiť všetky vybrané objednávky ({quantity})?",
                    "contract": "Naozaj chcete zrušiť všetky vybrané zmluvy ({quantity})?",
                    "mixed": "Naozaj chcete zrušiť všetky vybrané doklady ({quantity})?"
                },
                "confirm_btn": {
                    "invoice": "Zrušiť faktúry",
                    "outgoing-invoice": "Zrušiť odoslané faktúry",
                    "procurement": "Zrušiť objednávky",
                    "contract": "Zrušiť zmluvy",
                    "mixed": "Zrušiť doklady"
                },
                "success": {
                    "invoice": "{quantity} faktúr bolo zrušených.",
                    "outgoing-invoice": "{quantity} odoslaných faktúr bolo zrušených.",
                    "procurement": "{quantity} objednávok bolo zrušených.",
                    "contract": "{quantity} zmlúv bolo zrušených.",
                    "mixed": "{quantity} dokladov bolo zrušených."
                },
                "partial_success": {
                    "invoice": "{successCount} z {quantity} faktúr bolo zrušených.",
                    "outgoing-invoice": "{successCount} z {quantity} odoslaných faktúr bolo zrušených.",
                    "procurement": "{successCount} z {quantity} objednávok bolo zrušených.",
                    "contract": "{successCount} z {quantity} zmlúv bolo zrušených.",
                    "mixed": "{successCount} z {quantity} dokladov bolo zrušených."
                },
                "error": {
                    "invoice": "Vybrané faktúry sa nepodarilo zrušiť.",
                    "outgoing-invoice": "Vybrané odoslané faktúry sa nepodarilo zrušiť.",
                    "procurement": "Vybrané objednávky sa nepodarilo zrušiť.",
                    "contract": "Vybrané zmluvy sa nepodarilo zrušiť.",
                    "mixed": "Vybrané doklady sa nepodarilo zrušiť."
                }
            },
            "bulk_repeat_recognition_dialog": {
                "bulk_repeat_recognition_selected_invoices_btn": "Zopakovať rozpoznanie dokladu ({quantity})",
                "confirm_title": "Zopakovať rozpoznanie dokladu",
                "confirm_message": "Existujúce údaje vo vybraných faktúrach ({quantity}) budú prepísané. Naozaj chcete pokračovať?",
                "intro_message": "Rozpoznanie dokladu sa znovu spustí pre vybrané faktúry ({quantity}). Existujúce údaje vo formulári môžu byť prepísané.",
                "background_notice": "Môžete to spustiť hneď a počkať na spätnú väzbu, alebo proces rovno spustiť na pozadí.",
                "run_now_btn": "Spustiť teraz",
                "run_background_btn": "Spustiť na pozadí",
                "background_started": "Rozpoznanie dokladu bolo spustené na pozadí pre {quantity} faktúr.",
                "success": "Rozpoznávanie dokladu bolo znovu spustené pre {quantity} faktúr.",
                "partial_success": "Rozpoznávanie dokladu bolo znovu spustené pre {successCount} z {quantity} faktúr.",
                "error": "Rozpoznávanie dokladu pre vybrané faktúry sa nepodarilo znovu spustiť."
            },
            "select_columns_dialog": {
                "title": "Vybrať stĺpce",
                "select_fields": "Nasledujúce stĺpce sa zobrazia pod <i>Moje úlohy</i> a <i>Všetky dokumenty</i>.",
                "btn_confirm": "Použiť",
                "btn_finish": "Zatvoriť"
            },
            "copy_procurement_dialog": {
                "title": "Skopírujte údaje z požiadavky na nákup",
                "message": "Chcete skopírovať niektoré údaje z objednávky do tejto faktúry?",
                "message_contract": "Chcete prevziať niektoré údaje zo zmluvy do tejto faktúry?",
                "overwrite_checkbox": "Prepíšte existujúce údaje vo formulári.",
                "select_supplier_msg": "Vyberte, od ktorej doručovacej spoločnosti chcete skopírovať údaje:",
                "select_supplier_placeholder": "Vyberte doručovaciu spoločnosť",
                "confirm_btn": "Potvrďte"
            },
            "copy_from_recognition_dialog": {
                "title": "Načítať údaje",
                "message": "Chcete preniesť niektoré údaje z rozpoznania faktúry alebo z formulára do tohto dodávateľa?",
                "add_payment_method": "Chcete tiež aktualizovať spôsob platby?",
                "select_iban": "Vyberte z nájdených IBANov.",
                "select_vat_number": "Vyberte z nájdených IČ DPH.",
                "select_bic": "Vyberte si z nájdených BIC.",
                "success_msg": "Dodávateľ bol aktualizovaný.",
                "confirm_btn": "Potvrdiť"
            },
            "validation": {
                "invoice_date_required": "Zadajte dátum faktúry.",
                "due_date_required": "Zadajte dátum splatnosti.",
                "due_date_invalid1": "Dátum splatnosti nemôže byť skorší ako dátum vystavenia faktúry.",
                "delivery_date_required": "Zadajte dátum servisu.",
                "ledger_account_required": "Vyberte účet hlavnej knihy.",
                "branch_required": "Vyberte pobočku.",
                "posting_key_required": "Vyberte daňový kód.",
                "document_discount_tax_required": "Vyberte sadzbu DPH zľavy dokladu, ktorá sa používa aspoň v jednej položke faktúry.",
                "supplier_required": "Vyberte doručovaciu spoločnosť.",
                "business_partner_required": "Vyberte obchodného partnera.",
                "cost_center_required": "Vyberte nákladové stredisko.",
                "profit_center_required": "Prosím, vyberte profitné centrum.",
                "employee_required": "Prosím, vyberte zamestnanca.",
                "d365_branch_id_required": "Vyberte pobočku.",
                "d365_employee_id_required": "Prosím, vyberte zamestnanca.",
                "d365_department_required": "Prosím, vyberte oddelenie D365.",
                "financial_dimension_required": "Vyberte prosím finančný rozmer.",
                "client_required": "Vyberte spoločnosť.",
                "number_required": "Zadajte číslo faktúry.",
                "prefix_required": "Zadajte predponu a číslo faktúry.",
                "number_invalid_d365": "Môže obsahovať najviac 20 znakov.",
                "number_invalid": "Môže obsahovať maximálne 36 číslic, veľké a malé písmená, žiadne prehlásky a znaky $ % & * + - /.",
                "notes_length": "Môže obsahovať maximálne 120 znakov.",
                "discount_percentage_invalid1": "Sadzba zľavy musí byť väčšia ako 0.",
                "discount_percentage_invalid2": "Zľava 1 musí byť väčšia ako zľava 2.",
                "discount_amount_invalid1": "Pre kladné fakturované sumy sú povolené len kladné zľavy.",
                "discount_amount_invalid2": "Pre záporné sumy faktúry sú povolené iba záporné zľavy.",
                "discount_amount_invalid3": "Zľava 1 musí byť väčšia ako zľava 2.",
                "discount_amount_invalid4": "Zľava musí byť nižšia ako celková suma.",
                "discount_amount_invalid5": "Súčet čiastok zľavy musí byť menší ako celková čiastka.",
                "discount_date_invalid1": "Zľavy 1 a 2 musia byť medzi dátumom splatnosti dokladu.",
                "discount_date_invalid2": "Zľava 1 – dátum musí byť skorší ako dátum zľavy 2.",
                "missing_discount_field": "Všetky zľavové polia musia byť vyplnené.",
                "procurement_required": "Vyberte prosím požiadavku na nákup.",
                "contract_required": "Vyberte prosím zmluvu.",
                "iban_required": "Zadajte IBAN.",
                "bank_country_required": "Zadajte krajinu banky.",
                "bank_country_invalid": "Zadajte dvojpísmenový ISO kód krajiny.",
                "bank_account_required": "Zadajte číslo účtu.",
                "bank_code_required": "Zadajte smerové číslo banky."
            }
        }
    },
    "outgoing_invoice": {
        "description": "Výstupná faktúra",
        "page": {
            "upload": {
                "title": "Nahrať nové výstupné faktúry"
            }
        }
    },
    "invoice_line": {
        "item_number": "Číslo položky",
        "quantity": "Dav",
        "unit_net_price": "Internetová cena",
        "tax_percentage": "daň",
        "has_discount": "Položka má zľavu",
        "unit_price_base_amount": "Jednotková cena pred zľavou (BT-148)",
        "unit_price_discount_amount": "Zľava z jednotkovej ceny (BT-147)",
        "line_discount_amount": "Zľava položky (BT-136)",
        "line_discount_base_amount": "Základ zľavy položky (BT-137)",
        "line_discount_percentage": "Zľava položky % (BT-138)"
    },
    "location": {
        "name": "názov",
        "number": "číslo",
        "address": "Adresa",
        "form_sequence": "name,number,address"
    },
    "spreadsheet": {
        "add_row": "Nový riadok",
        "download": "Stiahnite si tabuľku",
        "save": "Uložiť tabuľku"
    },
    "audit_log": {
        "description": "Úpravy",
        "history": "Úpravy",
        "table": "Tabuľka",
        "lb_user_id": "užívateľ",
        "data_before": "Predtým",
        "data_after": "Potom",
        "created_at": "Dátum",
        "type": {
            "insert": "Pridané",
            "update": "Spracované",
            "delete": "Odstránený"
        },
        "msg": {
            "deleted": "odstránený",
            "inserted": "pridané",
            "was_deleted": "Bol odstránený.",
            "was_inserted": "Bol pridaný."
        },
        "none": "nie)",
        "empty": "Nie sú k dispozícii žiadne úpravy."
    },
    "txt_before_leave_page": "Vaše zmeny sa nemusia uložiť. Ste si istý, že chcete pokračovať?",
    "easybill_invoice": {
        "from_tenant": "od nájomcu",
        "no_invoice": "Zatiaľ nebola vytvorená žiadna faktúra.",
        "number": "číslo",
        "service_date": "Obdobie",
        "from": "Z",
        "until": "bis",
        "total": "Spolu",
        "due_date": "Dátum splatnosti",
        "status": "Postavenie",
        "paid_at": "Zaplatené",
        "payment_missing": "Čaká na spracovanie",
        "sepa": "SEPA",
        "tour": {
            "invoice_table": "Tu si môžete pozrieť podrobný prehľad všetkých faktúr liftbase vrátane stavu. Faktúry je možné stiahnuť pomocou tlačidla."
        }
    },
    "configuration": {
        "description": "konfigurácia",
        "sepa_number": "Identifikačné číslo veriteľa",
        "sepa_mandate_reference": "Referencia mandátu",
        "remove_sepa_msg": "Naozaj chcete odvolať SEPA inkaso?', 'Zrušiť SEPA inkaso",
        "remove_sepa_btn": "Odstúpiť",
        "system-modules-procurement": "Modul - Nákupné požiadavky",
        "system-modules-invoice": "Modul - Faktúry",
        "system-modules-bank-statements": "Modul - Párovanie bankových výpisov",
        "system-modules-permissions": "Modul - Skupiny oprávnení",
        "system-modules-multilingualism": "Modul - Viacjazyčné hlavné údaje",
        "system-modules-invoice-export": "Modul - Export faktúr do",
        "purchaseorder-defaults-selectproduct": "Prednastavenia rolí - Osoba „Výber produktu“",
        "purchaseorder-defaults-sendorder": "Prednastavenia rolí - Osoba „Odoslanie objednávky“",
        "purchaseorder-defaults-clearing": "Prednastavenia rolí - Osoba „Vyrovnanie nákupu“",
        "purchaseorder-defaults-consignee": "Prednastavenia rolí - Osoba „Príjem tovaru“",
        "invoice-defaults-manual_check": "Prednastavenia rolí - Osoba „Manuálna kontrola (faktúra)“",
        "invoice-defaults-clearing": "Prednastavenia rolí - Osoba „Účtovné vyrovnanie“",
        "purchaseorder-defaults-init_seq": "Nákupné požiadavky - Číslovanie objednávok od",
        "purchaseorder-product-require_product_group": "Nákupné požiadavky - Všetky produkty musia byť priradené do produktovej skupiny.",
        "purchaseorder-product-require_product_selection": "Nákupné požiadavky - Proces nákupnej požiadavky",
        "email-send-order": "Objednávky - E-mailová objednávka",
        "purchaseorder-pdf-free-text": "Objednávky - PDF objednávky",
        "type_email-send-order": "html-i18n",
        "type_purchaseorder-pdf-free-text": "html-i18n",
        "invoice-recognition-lines": "Faktúry - Automatické vytváranie položiek faktúry na základe rozpoznávania dokumentov.",
        "invoice-recognition-timeout": "Faktúry - Časový limit rozpoznávania Azure",
        "invoice-form-procurement-required": "Faktúry - Vyžaduje sa odkaz na nákupnú požiadavku.",
        "notifications-mail-interval": "Oznámenia - Interval e-mailov v minútach",
        "punchout-amazon-identity": "Integrácie - Punch-out Amazon - Identita",
        "punchout-amazon-secret": "Integrácie - Punch-out Amazon - Tajomstvo",
        "punchout-amazon-url": "Integrácie - Punch-out Amazon - Punch-out URL",
        "punchout-amazon-order-url": "Integrácie - Punch-out Amazon - URL objednávky",
        "punchout-amazon-email": "Integrácie - Punch-out Amazon - E-Mail",
        "punchout-amazon-supplier": "Integrácie - Punch-out Amazon - Predvolený dodávateľ",
        "punchout-mercateo-identity": "Integrácie - Punch-out Mercateo - Identita",
        "punchout-mercateo-secret": "Integrácie - Punch-out Mercateo - Tajomstvo",
        "punchout-mercateo-url": "Integrácie - Punch-out Mercateo - Punch-out URL",
        "punchout-mercateo-order-url": "Integrácie - Punch-out Mercateo - URL objednávky",
        "punchout-mercateo-email": "Integrácie - Punch-out Mercateo - E-Mail",
        "punchout-mercateo-supplier": "Integrácie - Punch-out Mercateo - Predvolený dodávateľ",
        "punchout-rajapack-identity": "Integrácie - Punch-out RAJA - Identita",
        "punchout-rajapack-secret": "Integrácie - Punch-out RAJA - Tajomstvo",
        "punchout-rajapack-url": "Integrácie - Punch-out RAJA - Punch-out URL",
        "punchout-rajapack-order-url": "Integrácie - Punch-out RAJA - URL objednávky",
        "punchout-rajapack-email": "Integrácie - Punch-out RAJA - E-Mail",
        "punchout-rajapack-supplier": "Integrácie - Punch-out RAJA - Predvolený dodávateľ",
        "punchout-conrad-identity": "Integrácie - Punch-out Conrad - Identita",
        "punchout-conrad-secret": "Integrácie - Punch-out Conrad - Tajomstvo",
        "punchout-conrad-url": "Integrácie - Punch-out Conrad - Punch-out URL",
        "punchout-conrad-order-url": "Integrácie - Punch-out Conrad - URL objednávky",
        "punchout-conrad-email": "Integrácie - Punch-out Conrad - E-Mail",
        "punchout-conrad-supplier": "Integrácie - Punch-out Conrad - Predvolený dodávateľ",
        "punchout-thgeyer-identity": "Integrácie - Punch-out TH-GEYER - Identita",
        "punchout-thgeyer-secret": "Integrácie - Punch-out TH-GEYER - Tajomstvo",
        "punchout-thgeyer-url": "Integrácie - Punch-out TH-GEYER - Punch-out URL",
        "punchout-thgeyer-supplier": "Integrácie - Punch-out TH-GEYER - Predvolený dodávateľ",
        "punchout-reichelt-identity": "Integrácie - Punch-out Reichelt - Identita",
        "punchout-reichelt-secret": "Integrácie - Punch-out Reichelt - Tajomstvo",
        "punchout-reichelt-url": "Integrácie - Punch-out Reichelt - Punch-out URL",
        "punchout-reichelt-supplier": "Integrácie - Punch-out Reichelt - Predvolený dodávateľ",
        "validation": {
            "bic_invalid": "Zadajte platný kód BIC.",
            "iban_invalid": "Zadajte platné číslo IBAN.",
            "default_decimal_places_invalid": "Zadajte 2 až 4 desatinné miesta."
        },
        "datev": {
            "description": "DATEV",
            "connection": "Spojenie s DATEV",
            "status_active": "aktívny",
            "status_inactive": "neaktívne",
            "from": "od",
            "until": "bis",
            "load_clients": "Načítať klientov DATEV",
            "remove_connection": "Odstráňte pripojenie",
            "deactivate_connection": "Deaktivovať pripojenie",
            "add_connection": "Nastaviť pripojenie",
            "connected_by": "Spojenie nadviazal {name}.",
            "apps_manager": "Tu môžete spravovať <a href=\"https://apps.datev.de/tokrevui\" target=\"_blank\">aplikácie pripojené k DATEV</a>.",
            "msg_no_clients": "Nenašli sa žiadne záznamy alebo nemáte potrebné povolenia alebo je potrebné znova nastaviť pripojenie.",
            "fiscal_year_start": "fiškálny rok",
            "account_length": "Dĺžka účtu",
            "is_accounts_payable_ledger_available": "Príjem faktúry",
            "is_accounts_receivable_ledger_available": "Odchádzajúca faktúra",
            "client_number": "Číslo klienta",
            "consultant_number": "Číslo konzultanta",
            "client_name": "zákazník",
            "liftbase_client": "liftbase spoločnosť",
            "save_client": "Zachráňte spoločnosť",
            "change_client": "Zmeňte spoločnosti"
        },
        "ms365": {
            "description": "D365",
            "connection": "Pripojenie k D365",
            "status_active": "aktívne",
            "status_inactive": "neaktívne",
            "auth_type": "Autentifikácia",
            "oauth": "OAuth (Súhlas používateľa)",
            "client_secret_auth": "Client Credentials (App Client ID + Secret)",
            "app_client_id": "App Client ID (Azure aplikácia)",
            "app_tenant_id": "Azure Tenant ID",
            "client_secret": "Client Secret",
            "client_credentials_note": "Ak sú zadané App Client ID a Client Secret, pre export faktúr sa použije tok Client Credentials. Import e‑mailov zostáva nezmenený (OAuth).",
            "connect_and_load_data": "Nastavte spojenie a načítajte údaje",
            "connect": "Nastavte spojenie",
            "load_data": "Načítavajte všetky dáta",
            "remove_connection": "Odstrániť pripojenie",
            "add_connection": "Nastaviť pripojenie",
            "no_client_found": "Neboli nájdené žiadne klienty D365.",
            "msg_no_clients": "Neboli nájdené žiadne záznamy alebo nemáte potrebné oprávnenia alebo je potrebné pripojenie nastaviť znovu.",
            "client_number": "Číslo firmy D365",
            "client_name": "Firma D365",
            "liftbase_client": "Firma liftbase",
            "save_client": "Uložiť firmu",
            "change_client": "Zmeniť firmu",
            "sync_running": "Dáta sa načítavajú. To môže trvať niekoľko minút.",
            "last_sync_at": "Naposledy načítané dňa {last_sync_at}",
            "journal_name": "Názov denníka",
            "org_url": "URL organizácie",
            "http_read_timeout": {
                "label": "HTTP read timeout for D365",
                "hint": "Defines how long liftbase waits for a D365 response. Leave empty to use the global backend configuration. Examples: <b>420s</b>, <b>5m</b>, <b>1h</b>.",
                "error": "Please enter a positive timeout, e.g. 420s, 5m, or 1h."
            },
        },
        "datev-csv": {
            "description": "DATEV CSV",
        },
        "template": {
            "module-procurement": {
                "group": "Modul",
                "label": "Požiadavky na nákup",
                "tour": [
                    {
                        "target": ".krokové moduly",
                        "content": "<p>Vyberte moduly výťahovej základne, ktoré chcete aktivovať. Informácie o nákladoch nájdete na <a href=\"liftbase.de/preise\" target=\"_blank\">liftbase.de/preise</a>.</p>"
                    }
                ]
            },
            "module-invoice": {
                "group": "Modul",
                "label": "účty"
            },
            "module-outgoing-invoice": {
                "group": "Modul",
                "label": "Výstupné faktúry"
            },
            "module-bank-statements": {
                "group": "Modul",
                "label": "Párovanie bankových výpisov"
            },
            "module-contract": {
                "group": "Modul",
                "label": "Zmluvy"
            },
            "module-permissions": {
                "group": "Modul",
                "label": "Autorizačné skupiny"
            },
            "module-multilingualism": {
                "group": "Modul",
                "label": "Viacjazyčné základné údaje"
            },
            "module-supplier-communication": {
                "group": "Modul",
                "label": "Komunikácia s dodávateľom"
            },
            "module-liquidity-planning": {
                "group": "Modul",
                "label": "Plánovanie likvidity"
            },
            "insolvency-law-fields": {
                "group": "Modul",
                "label": "Zobraziť polia insolvenčného práva"
            },
            "approval-limit-priority": {
                "group": "Modul",
                "label": "Úroveň priority schvaľovacieho limitu"
            },
            "custom-fields": {
                "group": "Modul",
                "label": "Vlastné polia"
            },
            "module-invoice-export": {
                "group": "Modul",
                "label": "Export faktúry na",
                "options": [
                    {
                        "value": "datev",
                        "content": "DATEV"
                    },
                    {
                        "value": "ms365",
                        "content": "D365"
                    },
                    {
                        "value": "datev-csv",
                        "content": "DATEV CSV"
                    }
                ]
            },
            "procurement-select-product": {
                "group": "Predvolené hodnoty roly",
                "label": "Osoba „výber produktu“.",
                "tour": [
                    {
                        "target": ".krok-priradenie",
                        "content": "<p>Tu možno uložiť predvolené globálne hodnoty rolí. Ak na úrovni spoločnosti alebo oddelenia nie sú definované žiadne predvolené hodnoty rolí, tu zadaní ľudia prevezmú príslušné kroky v procese vyžiadania objednávky a fakturácie.</p>"
                    }
                ]
            },
            "procurement-send-order": {
                "group": "Predvolené hodnoty roly",
                "label": "Osoba „úloha“"
            },
            "procurement-clearing": {
                "group": "Predvolené hodnoty roly",
                "label": "Osoba „objasňujúca nákup“",
                "hint": "Pre upresnenie v procese objednávania."
            },
            "procurement-consignee": {
                "group": "Predvolené hodnoty roly",
                "label": "Osoba „Príjem tovaru“."
            },
            "invoice-manual-check": {
                "group": "Predvolené hodnoty roly",
                "label": "Osoba „Manuálna kontrola (faktúra)“"
            },
            "invoice-clearing": {
                "group": "Predvolené hodnoty roly",
                "label": "Osoba „objasnenie účtovníctva“",
                "hint": "Pre upresnenie pri vystavovaní faktúry."
            },
            "contract-clearing": {
                "group": "Predvolené hodnoty roly",
                "label": "Osoba „objasnenie zmluvy“",
                "hint": "Pre objasnenie v zmluvných procesoch."
            },
            "procurement-init-seq": {
                "group": "Požiadavky na nákup",
                "label": "Objednávacie čísla",
                "hint": "Tu zadajte číslo, od ktorého majú začínať čísla objednávok.",
                "validation": {
                    "interval": "Musí byť medzi 0 a 999999999.",
                    "type": "Môže obsahovať iba celé čísla."
                },
                "tour": [
                    {
                        "target": ".krokové obstarávanie",
                        "content": "Tu nájdete nastavenia požiadaviek objednávky. Nastavte napríklad číslo, ktorým sa má začať požiadavka na objednávku a či všetky produkty v požiadavke na objednávku musia byť priradené k skupine produktov."
                    }
                ]
            },
            "procurement-require-product-group": {
                "group": "Požiadavky na nákup",
                "label": "Všetky produkty musia byť zaradené do skupiny produktov."
            },
            "procurement-skip-place-order": {
                "group": "Požiadavky na nákup",
                "label": "Automatické odoslanie objednávky do online obchodu",
                "hint": "Po PunchOut čaká online obchod na schválenie v objednávkovom systéme. Bez tejto možnosti je potrebné prenos spustiť manuálne cez tlačidlo „Elektronicky odoslať“. S touto možnosťou sa objednávka po schválení automaticky elektronicky odošle. Funguje iba pre objednávky s jedným dodávateľom."
            },
            "procurement-require-product-selection": {
                "group": "Požiadavky na nákup",
                "label": "Proces vyžiadania nákupu",
                "options": [
                    {
                        "value": "pravda",
                        "content": "s výberom produktu<br><ul><li>Zadajte BANF</li><li>Výber produktu</li><li>Uvoľnenie</li><li>Objednávka </li><li>Potvrdenie o tovare</ li>< /ul>"
                    },
                    {
                        "value": "falošný",
                        "content": "bez výberu produktu<br><ul><li>Zadajte BANF </li><li>Uvoľnenie </li><li>Objednávka </li><li>Príjem tovaru </li></ul>"
                    }
                ]
            },
            "email-send-order": {
                "group": "objednávky",
                "label": "E-mailová objednávka",
                "hint": "E-mailový sprievodný list, ktorý je možné vygenerovať v kroku objednávky vrátane objednávkového PDF a odoslať ho doručovacej spoločnosti.",
                "default_value": "Vážený pán alebo pani, posielam Vám našu objednávku ako PDF. Zašlite nám prosím potvrdenie objednávky.",
                "tour": [
                    {
                        "target": ".step-email-order-free-text",
                        "content": "Sem napíšte text, ktorý bude súčasťou e-mailového sprievodného listu, ktorý je možné vygenerovať v kroku objednávky vrátane objednávkového PDF a zaslať doručovacej spoločnosti."
                    },
                    {
                        "target": ".step-pdf-free-text",
                        "content": "Sem napíšte text, ktorý sa zobrazí na vygenerovanom objednávkovom PDF v kroku objednávky, ktorý je možné následne odoslať doručovacej spoločnosti."
                    }
                ]
            },
            "procurement-pdf-free-text": {
                "group": "objednávky",
                "label": "Objednávka PDF",
                "hint": "Sprievodný list, ktorý sa zobrazí na vygenerovanom objednávkovom PDF v kroku objednávky, ktorý je možné následne zaslať doručovacej spoločnosti.",
                "default_value": "",
            },
            "procurement-pdf-show-department": {
                "group": "objednávky",
                "label": "Zobraziť oddelenie v objednávkovom PDF"
            },
            "procurement-pdf-show-cost-center": {
                "group": "objednávky",
                "label": "Zobraziť nákladové stredisko v objednávkovom PDF"
            },
            "procurement-pdf-show-created-by": {
                "group": "objednávky",
                "label": "Zobraziť 'Vytvoril(a)' v objednávkovom PDF"
            },
            "procurement-pdf-show-approver": {
                "group": "objednávky",
                "label": "Zobraziť schvaľovateľa v objednávkovom PDF"
            },
            "procurement-pdf-show-offer": {
                "group": "objednávky",
                "label": "Zobraziť ponuku v zozname položiek"
            },
            "procurement-pdf-show-vat-number": {
                "group": "objednávky",
                "label": "Zobraziť IČ DPH v objednávkovom PDF"
            },
            "invoice-recognition-lines": {
                "group": "Faktúry",
                "label": "Automaticky prevziať položky, ktoré rozpoznávanie dokladov identifikovalo."
            },
            "invoice-recognition-group-by-tax": {
                "group": "Faktúry",
                "label": "Zoskupiť rozpoznané položky faktúry podľa sadzby dane",
                "hint": "Ak je zapnuté, rozpoznané položky sa zoskupia podľa sadzby dane (napr.: Súčet 19 % dane)."
            },
            "invoice-recognition-ai-validation-mode": {
                "group": "Faktúry",
                "label": "Predvolený režim overenia AI pri nahrávaní faktúr",
                "hint": "Tento režim je pri nahrávaní predvolený a pred vytvorením faktúry ho možno zmeniť.",
                "options": [
                    {
                        "value": "none",
                        "content": "Bez overenia AI"
                    },
                    {
                        "value": "advisory",
                        "content": "Aktivovať a ponechať stav bez zmeny"
                    },
                    {
                        "value": "ready-for-export",
                        "content": "Aktivovať a presunúť do stavu Pripravené na export"
                    }
                ]
            },
            "invoice-recognition-custom-fields": {
                "group": "Faktúry",
                "label": "Extrahovať vlastné polia počas rozpoznávania Azure",
                "hint": "Ak je povolené, posielame do Azure Document Intelligence parametre queryFields (na základe vašich vlastných polí) na extrakciu hodnôt. To môže zvýšiť náklady na spracovanie."
            },
            "invoice-recognition-custom-prompt": {
                "group": "Faktúry",
                "label": "Globálny vlastný prompt pre rozpoznávanie faktúr",
                "hint": "Tieto pokyny sa použijú pri rozpoznávaní faktúr tenanta a skombinujú sa s prípadnými promptmi pre spoločnosť alebo dodávateľa."
            },
            "invoice_recognition_custom_field_unit_price": "Cena za doklad s vlastnými poľami",
            "invoice-recognition-model": {
                "group": "Faktúry",
                "label": "Rozpoznávanie dokladov Azure – Model",
                "options": [
                    {
                        "value": "document-intelligence",
                        "content": "Azure Document Intelligence (klasický)"
                    },
                    {
                        "value": "content-understanding",
                        "content": "Azure Content Understanding (GenAI)"
                    },
                    {
                        "value": "azure-open-ai",
                        "content": "Azure OpenAI Responses API"
                    }
                ]
            },
            "invoice-recognition-timeout": {
                "group": "Faktúry",
                "label": "Časový limit rozpoznávania Azure pre každý región",
                "hint": "Určuje, ako dlho má liftbase dotazovať jeden región Azure, kým prepne na ďalší nakonfigurovaný región. Predvolená hodnota: <b>150s</b>. Príklady: <b>150s</b>, <b>5m</b>, <b>1h</b>.",
                "validation": {
                    "format": "Zadajte trvanie ako 150s, 5m alebo 1h."
                }
            },
            "invoice-procurement-required": {
                "group": "Faktúry",
                "label": "Je potrebné prepojiť požiadavku na nákup alebo zmluvu."
            },
            "invoice-approval": {
                "group": "Faktúry",
                "label": "Kedy by mala byť faktúra schválená?",
                "options": [
                    {
                        "value": "always",
                        "content": "<b>Vždy</b><br>Faktúry musia byť vždy schválené."
                    },
                    {
                        "value": "if-no-order",
                        "content": "<b>Iba ak nie je priradená PO ani CT</b><br>Schválenie je potrebné iba vtedy, ak nie je prítomná Požiadavka na nákup (PO) ani Zmluva (CT)."
                    },
                    {
                        "value": "never",
                        "content": "<b>Nikdy</b><br>Faktúry nevyžadujú samostatné schválenie."
                    }
                ]
            },
            "notifications-mail-interval": {
                "group": "Upozornenia",
                "label": "Interval e-mailu v minútach",
                "tour": [
                    {
                        "target": ".krok-oznámenie",
                        "content": "Tu môžete nastaviť maximálny počet, koľkokrát majú byť ľudia informovaní o nových úlohách e-mailom. E-mailové upozornenia sa odosielajú iba vtedy, keď osoba dostane novú úlohu."
                    }
                ]
            },
            "product-default-tax": {
                "group": "Produkt",
                "label": "Štandardná daňová sadzba (%)"
            },
            "product-default-currency": {
                "group": "Produkt",
                "label": "Predvolená mena"
            },
            "product-default-unit": {
                "group": "Produkt",
                "label": "Predvolená jednotka"
            },
            "punchout-amazon-identity": {
                "group": "Integrácia",
                "subgroup": "Punch-out Amazon",
                "label": "Přihlašovací jméno",
                "tour": [
                    {
                        "target": ".step-punchout-amazon",
                        "content": "Tu si môžete nastaviť prístup k integrovaným trhoviskám, ako sú Amazon a Mercateo. Pokyny nájdete <a href=\"https://liftbase.de/handbook/einrichtung/punch-out\" target=\"_blank\">v našej príručke</a>."
                    }
                ]
            },
            "punchout-amazon-secret": {
                "group": "Integrácia",
                "subgroup": "Punch-out Amazon",
                "label": "Tajomstvo"
            },
            "punchout-amazon-url": {
                "group": "Integrácia",
                "subgroup": "Punch-out Amazon",
                "label": "Punch-out-URL"
            },
            "punchout-amazon-order-url": {
                "group": "Integrácia",
                "subgroup": "Punch-out Amazon",
                "label": "Adresa URL objednávky"
            },
            "punchout-amazon-email": {
                "group": "Integrácia",
                "subgroup": "Punch-out Amazon",
                "label": "E-mail",
                "hint": "E-mailová adresa hlavného účtu Amazon. <br>Ak chcete odoslať e-mailovú adresu prihlásenej osoby, ponechajte pole prázdne. <br>Môže vyžadovať účet Amazon na osobu."
            },
            "punchout-amazon-supplier": {
                "group": "Integrácia",
                "subgroup": "Punch-out Amazon",
                "label": "Štandardná doručovacia spoločnosť",
                "hint": "Ku ktorej doručovacej spoločnosti by mali byť priradené objednávky od tohto poskytovateľa punch-out (napr. pri hodnotení)?"
            },
            "punchout-mercateo-identity": {
                "group": "Integrácia",
                "subgroup": "Punch-out Mercateo",
                "label": "Přihlašovací jméno"
            },
            "punchout-mercateo-secret": {
                "group": "Integrácia",
                "subgroup": "Punch-out Mercateo",
                "label": "Tajomstvo"
            },
            "punchout-mercateo-url": {
                "group": "Integrácia",
                "subgroup": "Punch-out Mercateo",
                "label": "Punch-out-URL"
            },
            "punchout-mercateo-order-url": {
                "group": "Integrácia",
                "subgroup": "Punch-out Mercateo",
                "label": "Adresa URL objednávky"
            },
            "punchout-mercateo-email": {
                "group": "Integrácia",
                "subgroup": "Punch-out Mercateo",
                "label": "E-mail",
                "hint": "E-mailová adresa hlavného účtu Mercateo. <br>Ak chcete odoslať e-mailovú adresu prihlásenej osoby, ponechajte pole prázdne. <br>Môže vyžadovať účet Mercateo na osobu."
            },
            "punchout-mercateo-supplier": {
                "group": "Integrácia",
                "subgroup": "Punch-out Mercateo",
                "label": "Štandardná doručovacia spoločnosť",
                "hint": "Ku ktorej doručovacej spoločnosti by mali byť priradené objednávky od tohto poskytovateľa punch-out (napr. pri hodnotení)?"
            },
            "punchout-rajapack-identity": {
                "group": "Integrácia",
                "subgroup": "Punch-out RAJA",
                "label": "Přihlašovací jméno"
            },
            "punchout-rajapack-secret": {
                "group": "Integrácia",
                "subgroup": "Punch-out RAJA",
                "label": "Tajomstvo"
            },
            "punchout-rajapack-url": {
                "group": "Integrácia",
                "subgroup": "Punch-out RAJA",
                "label": "Punch-out-URL"
            },
            "punchout-rajapack-order-url": {
                "group": "Integrácia",
                "subgroup": "Punch-out RAJA",
                "label": "Adresa URL objednávky"
            },
            "punchout-rajapack-email": {
                "group": "Integrácia",
                "subgroup": "Punch-out RAJA",
                "label": "E-mail"
            },
            "punchout-rajapack-supplier": {
                "group": "Integrácia",
                "subgroup": "Punch-out RAJA",
                "label": "Štandardná doručovacia spoločnosť",
                "hint": "Ku ktorej doručovacej spoločnosti by mali byť priradené objednávky od tohto poskytovateľa punch-out (napr. pri hodnotení)?"
            },
            "punchout-conrad-identity": {
                "group": "Integrácia",
                "subgroup": "Vyrazený Conrad",
                "label": "Přihlašovací jméno"
            },
            "punchout-conrad-secret": {
                "group": "Integrácia",
                "subgroup": "Vyrazený Conrad",
                "label": "Tajomstvo"
            },
            "punchout-conrad-url": {
                "group": "Integrácia",
                "subgroup": "Vyrazený Conrad",
                "label": "Punch-out-URL"
            },
            "punchout-conrad-order-url": {
                "group": "Integrácia",
                "subgroup": "Vyrazený Conrad",
                "label": "Adresa URL objednávky"
            },
            "punchout-conrad-email": {
                "group": "Integrácia",
                "subgroup": "Vyrazený Conrad",
                "label": "E-mail"
            },
            "punchout-conrad-supplier": {
                "group": "Integrácia",
                "subgroup": "Vyrazený Conrad",
                "label": "Štandardná doručovacia spoločnosť",
                "hint": "Ku ktorej doručovacej spoločnosti by mali byť priradené objednávky od tohto poskytovateľa punch-out (napr. pri hodnotení)?"
            },
            "punchout-thgeyer-identity": {
                "group": "Integrácia",
                "subgroup": "Vybíjačka TH.GEYER",
                "label": "Přihlašovací jméno"
            },
            "punchout-thgeyer-secret": {
                "group": "Integrácia",
                "subgroup": "Vybíjačka TH.GEYER",
                "label": "Tajomstvo"
            },
            "punchout-thgeyer-url": {
                "group": "Integrácia",
                "subgroup": "Vybíjačka TH.GEYER",
                "label": "Punch-out-URL"
            },
            "punchout-thgeyer-supplier": {
                "group": "Integrácia",
                "subgroup": "Vybíjačka TH.GEYER",
                "label": "Štandardná doručovacia spoločnosť",
                "hint": "Ku ktorej doručovacej spoločnosti by mali byť priradené objednávky od tohto poskytovateľa punch-out (napr. pri hodnotení)?"
            },

            "punchout-reichelt-identity": {
                "group": "Integrácia",
                "subgroup": "Vybíjačka Reichelt",
                "label": "Přihlašovací jméno"
            },
            "punchout-reichelt-secret": {
                "group": "Integrácia",
                "subgroup": "Vybíjačka Reichelt",
                "label": "Tajomstvo"
            },
            "punchout-reichelt-url": {
                "group": "Integrácia",
                "subgroup": "Vybíjačka Reichelt",
                "label": "Punch-out-URL"
            },
            "punchout-reichelt-supplier": {
                "group": "Integrácia",
                "subgroup": "Vybíjačka Reichelt",
                "label": "Štandardná doručovacia spoločnosť",
                "hint": "Ku ktorej doručovacej spoločnosti by mali byť priradené objednávky od tohto poskytovateľa punch-out (napr. pri hodnotení)?"
            },
            "tour": [
                {
                    "target": "",
                    "content": ""
                }
            ]
        },
        "tour": {
            "tab_general": "Tu môžete zadať názov vašej spoločnosti pre prostredie výťahovej základne.",
            "tab_contact": "Tu zadajte kontaktné údaje vašej spoločnosti. Údaje sú potrebné napríklad na vystavenie a doručenie faktúr za použitie liftbase.",
            "tab_bank": "Tu môžete zadať SEPA inkaso pre fakturáciu z liftbase a v prípade potreby ho odvolať.",
            "tab_datev": "Tu môžete nastaviť integráciu s DATEV. Najprv sa musíte prihlásiť do DATEV, aby ste načítali všetkých dostupných klientov. Týchto klientov potom môžete prepojiť so spoločnosťami zaregistrovanými tu v liftbase. Potom musíte pripojiť každého klienta jednotlivo k DATEV, aby bolo možné preniesť export pre týchto klientov. Toto spojenie má platnosť 2 roky a obnovuje sa pri každom použití na export.",
            "tab_marketplaces": "Tu môžete nastaviť prístup k integrovaným trhom, ako sú Amazon a Mercateo. Príručku nájdete <a href=\"https://liftbase.de/handbuch/einrichtung/punch-out\" target=\"_blank\">v našom návode</a>."
        }
    },
    "error_title": "Omyl",
    "request_error": "Chyba pri vykonávaní požiadavky. Skontrolujte svoje internetové pripojenie alebo to skúste znova neskôr.",
    "saved_success": "Dokument bol uložený.",
    "duplicate_exists_check_records": "Identický záznam už existuje. Položka nebola vytvorená. Skontrolujte prosím svoje záznamy.",
    "save_error": "Pri ukladaní sa vyskytla chyba.",
    "help_page": {
        "title": "Pomoc",
        "popup_feedback_msg": "Váš prehliadač je nastavený správne. Teraz môžete toto okno zavrieť.",
        "punchout_error_msg": "Došlo k chybe. Skontrolujte konfigurácie vytlačenia alebo kontaktujte niekoho s oprávneniami správcu.",
        "popup_did_not_open": "Ak sa práve neotvorilo žiadne nové okno, vyskakovacie okná sú vo vašom prehliadači zablokované. Preto môžu existovať obmedzenia pri používaní.",
        "test_email_msg": "Mal by sa otvoriť e-mailový program alebo zoznam na výber programov. V prípade potreby nastavte e-mailový program, ktorý si môžete vybrať zo zoznamu.",
        "tour_restart": "Prehliadka bola reštartovaná.",
        "manual_title": "Manuálny",
        "manual_msg": "<p>V príručke nájdete rôzne články a pokyny na používanie a nastavenie základne výťahu.</p>",
        "manual_open_btn": "Otvorte manuál",
        "function_title": "Testovacie funkcie",
        "popup_msg": "<p>Tu môžete otestovať, či váš prehliadač povoľuje vyskakovacie okná, ktoré sú potrebné na výber vášho produktu na externých trhoch Amazon a Mercateo.</p>",
        "popup_test_btn": "Otestujte blokovanie automaticky otváraných okien",
        "email_msg": "<p>Tu môžete vyskúšať, či môžete otvárať e-maily pomocou e-mailového programu. Funkciou emailu je napr. Používa sa napríklad na odosielanie objednávok doručovacím spoločnostiam.</p>",
        "email_test_btn": "Otestujte funkciu e-mailu",
        "tour_title": "Prehliadka",
        "tour_msg": "<p>Pre opätovné uvedenie do výťahovej základne môžete prehliadku znova spustiť tu.</p>",
        "tour_btn": "Začať odznova"
    },
    "dashboard_page": {
        "title": "Dashboard",
        "no_option": "Žiadne",
        "date_picker": {
            "start_placeholder": "Dátum začiatku",
            "end_placeholder": "Dátum začiatku",
            "separator": "bis"
        },
        "ai": {
            "title": "AI štatistiky",
            "menu_title": "AI štatistiky",
            "add_widget": "[+] Pridať nový widget",
            "prompt_placeholder": "Popíšte graf, ktorý chcete (napr. Ukáž mi celkové objednávky za deň)",
            "empty_state": "Zatiaľ žiadne widgety. Pridajte jeden pomocou promptu.",
            "remove": "Odstrániť",
            "limits_info": "Môžete žiadať iba súčty bcase (procurement, invoice, contract) buď ako POČET alebo ako HODNOTU, agregované podľa časovej jednotky (deň, mesiac atď.). AI vráti generické polia (time a value) a metadáta, aby sa graf mohol genericky vykresliť.",
            "edit_label_title": "Upraviť popisok widgetu",
            "edit_label_message": "Týmto sa upraví iba popisok/názov zobrazený na karte. Nezmení sa dotaz ani graf.",
            "chart_type": {
                "bar": "stĺpcový",
                "line": "línia",
                "pie": "koláč"
            },
            "date_picker": {
                "required": "Vyžaduje sa časové obdobie"
            },
            "loading": {
                "adding_widget": "Pridáva sa widget…",
                "refresh_widget": "Obnovuje sa…",
                "refresh_all": "Obnovujú sa všetky widgety…"
            },
            "errors": {
                "create_failed": "Widget sa nepodarilo vytvoriť.",
                "render_failed": "Graf sa nepodarilo vykresliť."
            }
        },
        "hub": {
            "title": "All dashboards in one place",
            "subtitle": "Use this overview as the central entry point for procurement, incoming invoices, outgoing invoices, e-invoice and AI.",
            "procurement_title": "Procurement Dashboard",
            "procurement_description": "Current purchasing charts, budgets and spending analysis.",
            "einvoice_title": "E-invoice Dashboard",
            "einvoice_description": "Supplier adoption, risk and e-invoice format analysis.",
            "invoice_title": "Incoming Invoice Dashboard",
            "invoice_description": "Analytics for real incoming invoice data based on your current filters.",
            "outgoing_invoice_title": "Outgoing Invoice Dashboard",
            "outgoing_invoice_description": "Analytics for real outgoing invoice data based on your current filters.",
            "supplier_title": "Supplier Dashboard",
            "supplier_description": "Bird's-eye view of suppliers, spending, orders, invoices and communication.",
            "ai_description": "Dynamic AI-generated charts based on prompt-driven widgets.",
            "demo_badge": "Test version"
        },
        "supplier": {
            "menu_title": "Dashboard dodávateľov",
            "eyebrow": "Nákupný asistent",
            "title": "Dashboard dodávateľov",
            "subtitle": "Vyberte dodávateľa a zobrazte výdavky, objednávky, faktúry, e-maily zo SupplierConnect aj importované e-maily a automatické zhrnutie AI.",
            "selected_supplier": "Vybraný dodávateľ",
            "change_supplier": "Zmeniť dodávateľa",
            "top_suppliers_title": "Top 10 dodávateľov",
            "top_suppliers_subtitle": "Najpoužívanejší dodávatelia vo zvolenom období a viditeľnom rozsahu oprávnení.",
            "top_supplier_spend": "{amount} netto",
            "empty_top_suppliers": "Vo zvolenom období neboli nájdení žiadni dodávatelia.",
            "orders": "objednávky",
            "invoices": "Faktúry",
            "total_spend": "Výdavky",
            "total_spend_hint": "Súčet viditeľných prichádzajúcich faktúr vo zvolenom období",
            "procurement_value": "Hodnota objednávok",
            "procurement_value_hint": "Súčet viditeľných objednávok vo zvolenom období",
            "order_count": "Objednávky",
            "order_count_hint": "Viditeľné objednávky vo zvolenom období",
            "invoice_count": "Faktúry",
            "invoice_count_hint": "Viditeľné prichádzajúce faktúry vo zvolenom období",
            "email_count": "E-maily",
            "email_count_hint": "Komunikácia SupplierConnect a importované e-maily z viditeľných dokladov",
            "ai_summary_title": "Zhrnutie AI",
            "ai_summary_subtitle": "Automaticky vytvorené z viditeľných objednávok, faktúr a e-mailov.",
            "ai_summary_loading": "AI analyzuje",
            "ai_summary_empty": "Nie je k dispozícii spoľahlivé zhrnutie AI.",
            "ai_section_titles": {
                "highlights": "Hlavné body",
                "disputes": "Spory a riziká",
                "agreements": "Špeciálne dohody",
                "next_steps": "Ďalšie kroky",
                "general": "Zhrnutie"
            },
            "ai_summary_disabled": "AI je pre vášho tenanta deaktivovaná. Aktivujte AI v nastaveniach tenanta pre automatické zhrnutia.",
            "refresh_ai_summary": "Obnoviť zhrnutie",
            "charts_title": "Výdavky a doklady",
            "charts_subtitle": "Mesačný vývoj výdavkov, objednávok a faktúr vo zvolenom období.",
            "spend_chart_title": "Výdavky za mesiac",
            "document_chart_title": "Objednávky a faktúry za mesiac",
            "spend_mix_chart_title": "Výdavky podľa typu dokladu",
            "status_chart_title": "Doklady podľa stavu",
            "invoice_spend_chart_title": "Výdavky z faktúr za mesiac",
            "procurement_spend_chart_title": "Hodnota objednávok za mesiac",
            "invoice_count_chart_title": "Faktúry za mesiac",
            "procurement_count_chart_title": "Objednávky za mesiac",
            "invoice_status_chart_title": "Faktúry podľa stavu",
            "procurement_status_chart_title": "Objednávky podľa stavu",
            "procurements_title": "Objednávky",
            "procurements_subtitle": "Viditeľné objednávky tohto dodávateľa.",
            "invoices_title": "Faktúry",
            "invoices_subtitle": "Viditeľné prichádzajúce faktúry tohto dodávateľa.",
            "contracts_title": "Zmluvy",
            "contracts_subtitle": "Viditeľné zmluvy a informatívne upozornenia tohto dodávateľa.",
            "contract_term": "Doba trvania",
            "contract_renewal": "Obnovenie",
            "contract_notice": "Výpovedná lehota",
            "contract_findings": "Upozornenia zmluvy",
            "empty_contracts": "Nenašli sa žiadne zmluvy.",
            "contracts_disclaimer": "Zobrazené zmluvné informácie a upozornenia sú iba informatívne a nepredstavujú právne poradenstvo.",
            "contract_finding_severity": {
                "high": "Vysoká",
                "medium": "Stredná",
                "low": "Nízka",
                "info": "Informácia"
            },
            "unknown": "Neznáme",
            "emails_title": "E-maily",
            "emails_subtitle": "Komunikácia SupplierConnect a importované fakturačné e-maily z viditeľných dokladov.",
            "email_type_filter": "Typ e-mailu",
            "email_type_all": "Všetky",
            "email_type_communication": "Komunikácia",
            "email_type_imported_invoice": "Importovaná faktúra",
            "expand_email": "Rozbaliť e-mail",
            "collapse_email": "Zbaliť e-mail",
            "email_source_supplier_connect": "SupplierConnect",
            "email_source_imported": "Importovaný e-mail",
            "email_direction_outgoing": "Odchádzajúce",
            "email_direction_incoming": "Prichádzajúce",
            "imported_email_hint": "Prichádzajúca faktúra z importovaného e-mailu.",
            "loading_original_email": "Načítava sa pôvodný e-mail…",
            "open_document": "Otvoriť doklad",
            "show_more": "Zobraziť viac",
            "show_less": "Zobraziť menej",
            "empty_procurements": "Nenašli sa žiadne objednávky.",
            "empty_invoices": "Nenašli sa žiadne faktúry.",
            "empty_emails": "Nenašli sa žiadne e-maily.",
            "empty_filtered_emails": "Pre tento filter sa nenašli žiadne e-maily.",
            "net_value": "Netto",
            "no_subject": "Bez predmetu",
            "last_three_months": "Posledné 3 mesiace",
            "last_six_months": "Posledných 6 mesiacov",
            "nav": {
                "summary": "Prehľad",
                "charts": "Grafy",
                "emails": "E-maily",
                "procurements": "Objednávky",
                "invoices": "Faktúry",
                "contracts": "Zmluvy"
            }
        },
        "invoice": {
            "title": "Incoming Invoice Dashboard",
            "incoming_subtitle": "This dashboard uses real incoming invoice data and shows status and distributions based on your current filters.",
            "outgoing_subtitle": "This dashboard uses real outgoing invoice data and shows status and distributions based on your current filters.",
            "sample_data": "Sample data",
            "accordions": {
                "summary": "Summary",
                "status": "Status"
            },
            "hero": {
                "data_label": "Data source",
                "live_value": "Real invoice data",
                "period_label": "Period",
                "documents_label": "Documents in view",
                "filters_label": "Active filters"
            },
            "filters": {
                "title": "Filter context",
                "subtitle": "Choose period, organization and supplier details to sharpen every section of the dashboard at once.",
                "active_filters_label": "Active filters",
                "active_filters_suffix": "active filters",
                "period_label": "Period"
            },
            "summary": {
                "incoming_count_label": "Invoices",
                "outgoing_count_label": "Outgoing invoices",
                "gross_total_label": "Gross volume",
                "gross_total_hint": "Gross total in the selected period",
                "suppliers_label": "Suppliers in filter",
                "suppliers_kicker": "Suppliers",
                "business_partners_label": "Business partners in filter",
                "business_partners_kicker": "Partners",
                "value_kicker": "Value",
                "departments_kicker": "Departments",
                "departments_label": "Departments in filter",
                "clients_kicker": "Clients",
                "clients_label": "Clients in filter",
                "incoming_count_hint": "Document count in the selected period",
                "outgoing_count_hint": "Document count in the selected period",
                "incoming_suppliers_hint": "Unique suppliers in the filtered invoice set",
                "outgoing_business_partners_hint": "Unique business partners in the filtered outgoing invoice set",
                "outgoing_suppliers_hint": "Unique suppliers in the filtered outgoing invoice set",
                "incoming_departments_hint": "Unique departments in the filtered invoice set",
                "outgoing_clients_hint": "Unique clients in the filtered outgoing invoice set"
            },
            "status_sections": {
                "incoming_title": "Invoices by status",
                "incoming_subtitle": "Status cards based on the same filters as the procurement dashboard.",
                "outgoing_title": "Outgoing invoices by status",
                "outgoing_subtitle": "Status cards for outgoing invoices in the same compact overview."
            },
            "datasets": {
                "incoming": "Invoices",
                "outgoing": "Outgoing invoices"
            },
            "sections": {
                "incoming_subtitle": "Charts for incoming invoices using the same core filters as the procurement dashboard.",
                "outgoing_subtitle": "Charts for outgoing invoices with focus on clients, suppliers, status and organization data."
            },
            "empty_state": "No invoice data found for the current filter combination.",
            "presets": {
                "this_month": "This month",
                "last_3_months": "Last 3 months",
                "year_to_date": "Year to date"
            },
            "status": {
                "approved": "Approved",
                "pending": "Pending review",
                "blocked": "Blocked"
            },
            "kpis": {
                "total_invoices": "Total invoices",
                "approved_rate": "Approved rate",
                "pending_review": "Pending review",
                "avg_gross": "Average gross value"
            },
            "charts": {
                "status_distribution": "Invoice status distribution",
                "status_distribution_subtitle": "Quick overview of how invoices are currently moving through the process.",
                "volume_trend": "Invoice volume trend",
                "volume_trend_subtitle": "Approved versus pending documents across the selected test period.",
                "count_by_status_subtitle": "Document count by status.",
                "value_by_status_subtitle": "Gross total by status.",
                "department_count_subtitle": "Distribution by department.",
                "department_value_subtitle": "Gross total by department.",
                "cost_center_count_subtitle": "Document count by cost center.",
                "cost_center_value_subtitle": "Gross total by cost center.",
                "ledger_count_subtitle": "Top ledger accounts by document count.",
                "incoming_status_count_title": "Invoices by status",
                "incoming_status_value_title": "Invoice value by status",
                "incoming_supplier_count_title": "Invoices by supplier",
                "incoming_supplier_count_subtitle": "Top suppliers by document count.",
                "incoming_supplier_value_title": "Invoice value by supplier",
                "incoming_supplier_value_subtitle": "Top suppliers by gross total.",
                "incoming_department_count_title": "Invoices by department",
                "incoming_department_value_title": "Invoice value by department",
                "incoming_cost_center_count_title": "Invoices by cost center",
                "incoming_cost_center_value_title": "Invoice value by cost center",
                "incoming_ledger_count_title": "Invoices by ledger account",
                "incoming_monthly_title": "Invoice trend by month",
                "incoming_monthly_subtitle": "Time series for incoming invoices.",
                "outgoing_status_count_title": "Outgoing invoices by status",
                "outgoing_status_value_title": "Outgoing invoice value by status",
                "outgoing_client_count_title": "Outgoing invoices by client",
                "outgoing_client_count_subtitle": "Top clients by document count.",
                "outgoing_client_value_title": "Outgoing invoice value by client",
                "outgoing_client_value_subtitle": "Top clients by gross total.",
                "outgoing_business_partner_count_title": "Outgoing invoices by business partner",
                "outgoing_business_partner_count_subtitle": "Top business partners by document count.",
                "outgoing_business_partner_value_title": "Outgoing invoice value by business partner",
                "outgoing_business_partner_value_subtitle": "Gross total by business partner.",
                "outgoing_department_count_title": "Outgoing invoices by department",
                "outgoing_cost_center_value_title": "Outgoing invoice value by cost center",
                "outgoing_ledger_count_title": "Outgoing invoices by ledger account",
                "outgoing_monthly_title": "Outgoing invoice trend by month",
                "outgoing_monthly_subtitle": "Time series for outgoing invoices."
            },
            "table": {
                "title": "Period breakdown",
                "subtitle": "Supporting sample table for the charts above.",
                "period": "Period",
                "total": "Total",
                "approved": "Approved",
                "pending": "Pending",
                "gross_value": "Gross value"
            }
        },
        "ordered_by": "Objednané z",
        "count_by_status": "Číslo podľa stavu",
        "diagrams": {
            "title": "Diagram",
            "count_by_status": "Počet podľa stavu",
            "value_by_status": "Čiastky podľa stavu (netto v EUR)",
            "count_by_department": "Počet na oddelenie",
            "value_by_department": "Čiastky na oddelenie (netto v EUR)",
            "count_by_cost_center": "Počet na nákladové stredisko",
            "value_by_cost_center": "Čiastky na nákladové stredisko (netto v EUR)",
            "count_by_ledger_account": "Počet za hlavný účet",
            "value_by_ledger_account": "Súm podľa hlavného účtu (netto v EUR)"
        },
        "budgets": {
            "title": "Rozpočty a výdavky",
            "approved_status": "Schválené",
            "in_approval_status": "Vo vydaní",
            "open_status": "OTVORENÉ",
            "no_budget": "Bez rozpočtu",
            "from": "Ab",
            "no_name": "Bez mena"
        },
        "products": {
            "title": "Produkty",
            "approved_status": "Schválené",
            "in_approval_status": "Vo vydaní"
        },
        "no_data": "Nenašli sa žiadne požiadavky na nákup.",
        "no_permission": "Nemáte povolenie pre dashboard.",
        "from_budget": "z rozpočtu",
        "data": "výdavky",
        "shortcuts": {
            "this_week": "Tento týždeň",
            "last_week": "Minulý týždeň",
            "this_month": "Tento mesiac",
            "last_month": "Minulý mesiac",
            "last_30_days": "Last 30 days",
            "last_3_months": "Posledné 3 mesiace",
            "last_6_months": "Posledných 6 mesiacov",
            "this_year": "Tento rok",
            "last_year": "Minulý rok"
        },
        "tour": {
            "title": "Dashboard vám ponúka štatistiky a možnosti hodnotenia vašich požiadaviek na objednávku.",
            "filters_title": "Filter",
            "filters": "Najprv vyberte požadované obdobie a vyfiltrujte požiadavky na nákup, ktoré sa majú vyhodnotiť podľa spoločnosti, objednávateľa, nákladového strediska alebo oddelenia.",
            "count_by_status_title": "Číslo podľa stavu",
            "count_by_status": "Tu môžete vidieť, koľko z predfiltrovaných nákupných požiadaviek je v rôznych stavoch.",
            "graphic_title": "Diagram",
            "graphic": "Tu môžete vidieť grafické znázornenie počtu alebo čiastok nákupných požiadaviek, zoskupených podľa stavu, oddelenia alebo nákladového strediska.",
            "budget_title": "Rozpočty a výdavky",
            "budget": "Táto oblasť vám poskytuje prehľad o rozpočtoch a výdavkoch vašich nákladových stredísk. Farebné pruhy zobrazujú, ako sa využívajú rozpočty a koľko výdavkov sa ešte uvoľňuje.",
            "progress_bar_cost_center_title": "Tyče podľa nákladového strediska",
            "progress_bar_cost_center": "Tu si môžete otvoriť podrobnejší prehľad rôznych rozpočtov nákladového strediska. Zadané objednávky môžu byť uvedené aj pre jednotlivé rozpočty. Výdavky bez rozpočtu sú uvedené pod samostatnou lištou."
        },
        "einvoice": {
            "title": "E‑Invoice Dashboard",
            "filters": {
                "date_range": "Časový rozsah",
                "client": "Spoločnosť",
                "supplier": "Dodávateľ"
            },
            "placeholders": {
                "all": "Všetky"
            },
            "kpis": {
                "percent_einvoices": "% e‑faktúr",
                "total_tax_eur": "Celková daň (vrátiteľná)",
                "potential_loss": "Riziko nevrátenia"
            },
            "hint": "Pozor: Štát čoskoro ukončí vrátenie dane za neelektronické faktúry. Kontaktujte svojich dodávateľov čo najskôr, aby ste správne dostávali e‑faktúry a neprišli o peniaze.",
            "action_button": "Kontaktovať príjemcu",
            "email_dialog": {
                "title": "Kontaktovať príjemcu",
                "to": "E-mail príjemcu",
                "to_placeholder": "email1@firma.sk; email2@firma.sk",
                "subject": "Predmet",
                "message": "Správa",
                "download_eml": "Stiahnuť .eml",
                "send_email": "Odoslať e-mail",
                "recipient_type": "Typ príjemcu",
                "recipient_type_supplier": "Dodávateľ",
                "recipient_type_client": "Spoločnosť",
                "invalid_recipients": "Zadajte aspoň jednu platnú e-mailovú adresu.",
                "send_success": "E-mail bol úspešne odoslaný ({count}).",
                "send_error": "E-mail sa nepodarilo odoslať.",
                "select_supplier_warning": "Najskôr vyberte dodávateľa.",
                "default_subject": "Dôležité: Prechod na elektronické faktúry - {supplier}",
                "default_message": "Vážený tím {supplier},\n\nv súčasnosti preverujeme naše procesy vrátenia daní. V období od {startDate} do {endDate} sme vo vašich faktúrach identifikovali celkom {amount} na daniach, ktoré neboli zaslané ako e-faktúry (ZUGFeRD alebo XRechnung).\n\nVezmite prosím na vedomie, že štát čoskoro ukončí vrátenie daní za neelektronické faktúry. Aby sme zaistili našu ďalšiu spoluprácu a predišli finančným stratám, zdvorilo vás žiadame, aby ste čo najskôr prešli na zasielanie elektronických faktúr.\n\nĎakujeme za spoluprácu.\n\nS pozdravom,\n{userName}\n{tenantName}\nVaše účtovné oddelenie",
                "client_default_subject": "Stav e-faktúr a potrebné kroky - {client}",
                "client_default_message": "Vážený tím {client},\n\nv období od {startDate} do {endDate} bolo vo vašich dokladoch identifikované potenciálne formálne riziko vo výške {amount}.\nOdporúčame prejsť na štruktúrované formáty e-faktúr, aby sa znížili compliance riziká.\n\nS pozdravom,\n{userName}\n{tenantName}"
            }
        }
    },
    "exceptions_center": {
        "menu_title": "Pending items",
        "title": "Pending items & exceptions",
        "subtitle": "This view brings together the most urgent invoices, procurements and contracts that need human action now.",
        "total_items": "Open items",
        "total_items_hint": "Filtered items currently visible in the central queue.",
        "filters_title": "Filter queue",
        "filters_subtitle": "Focus the list by document type, severity or a free-text search.",
        "clear_filters": "Clear filters",
        "search_placeholder": "Search by reference, client, supplier or reason",
        "type_filter": "Document types",
        "severity_filter": "Severity",
        "quick_filters_title": "Quick filters",
        "focus_areas_title": "Focus areas",
        "analysis_title": "Analysis",
        "document_mix_title": "Document mix",
        "amount_at_risk": "Amount at risk",
        "active_filters_title": "Active filters",
        "filtered_total_hint": "{filtered} of {total} items visible",
        "total_reference": "of {count} total",
        "active_state": "Filter active",
        "list_title": "Operational queue",
        "list_subtitle": "{count} items currently match the selected filters.",
        "empty_state": "No pending items were found for the current filter combination.",
        "open_case": "Open case",
        "updated_label": "Last update",
        "reasons_count": "{count} flags",
        "filter_groups": {
            "severity": "Severity",
            "type": "Type",
            "focus": "Focus",
            "search": "Search"
        },
        "summary": {
            "severity_kicker": "Severity",
            "document_kicker": "Document type",
            "severity_title": "By severity",
            "document_title": "By document type"
        },
        "signals": {
            "critical": "Critical now",
            "unassigned": "Without owner",
            "stale": "Stale items"
        },
        "focus_areas": {
            "payments": "Payments",
            "approvals": "Approvals",
            "master-data": "Master data",
            "ownership": "Ownership",
            "export": "Export",
            "deadlines": "Deadlines"
        },
        "severity": {
            "critical": "Critical",
            "high": "High",
            "medium": "Medium"
        },
        "document_types": {
            "invoice": "Invoice",
            "outgoing_invoice": "Outgoing invoice",
            "procurement": "Procurement",
            "contract": "Contract",
            "bank_statement": "Bank statement"
        },
        "reasons": {
            "invoice_duplicate": "Possible duplicate invoice detected.",
            "invoice_ai_validation_failed": "AI validation did not trust this invoice and routed it to manual review.",
            "invoice_overdue": "Invoice due date is overdue by {days} day(s).",
            "invoice_missing_due_date": "Invoice has no due date.",
            "invoice_waiting_approval": "Invoice is waiting in an approval step.",
            "invoice_missing_link": "Invoice has no linked procurement or contract.",
            "invoice_missing_supplier": "Invoice has no supplier assigned.",
            "invoice_missing_accounting_data": "Invoice is missing accounting dimensions such as cost center or ledger account.",
            "invoice_ready_for_export": "Invoice is ready for export but has not been exported yet.",
            "outgoing_invoice_duplicate": "Possible duplicate outgoing invoice detected.",
            "outgoing_invoice_overdue": "Outgoing invoice due date is overdue by {days} day(s).",
            "outgoing_invoice_missing_due_date": "Outgoing invoice has no due date.",
            "outgoing_invoice_waiting_processing": "Outgoing invoice is waiting in approval or accounting.",
            "outgoing_invoice_missing_client": "Outgoing invoice has no client assigned.",
            "outgoing_invoice_missing_accounting_data": "Outgoing invoice is missing accounting dimensions such as cost center or ledger account.",
            "outgoing_invoice_not_exported": "Outgoing invoice is completed but has not been exported yet.",
            "procurement_waiting_approval": "Procurement is waiting for approval.",
            "procurement_ordered_without_invoice": "Ordered procurement has no invoice after its delivery date.",
            "procurement_approved_without_invoice": "Approved procurement still has no invoice after one week.",
            "procurement_missing_delivery_date": "Procurement has no delivery date planned.",
            "procurement_not_allocated": "Procurement is not fully allocated.",
            "procurement_open_value_remaining": "Procurement still has open value after invoicing started.",
            "procurement_missing_supplier": "Procurement has no supplier assigned.",
            "procurement_missing_accounting_data": "Procurement is missing accounting dimensions such as cost center or ledger account.",
            "contract_termination_deadline_passed": "Termination deadline has already passed.",
            "contract_termination_deadline_soon": "Termination deadline is within the next {days} day(s).",
            "contract_termination_deadline_near": "Termination deadline is within the next 30 days.",
            "contract_end_date_passed": "Contract end date has already passed.",
            "contract_end_date_soon": "Contract end date is within the next {days} day(s).",
            "contract_end_date_near": "Contract end date is within the next 30 days.",
            "contract_missing_owner": "Contract has no responsible owner assigned.",
            "contract_missing_supplier": "Contract has no supplier assigned.",
            "bank_statement_failed": "Bank statement processing failed.",
            "bank_statement_partial": "Bank statement processing completed only partially.",
            "bank_statement_unmatched_entries": "Bank statement still has {count} unmatched entrie(s).",
            "bank_statement_processing_too_long": "Bank statement has been processing for more than one day.",
            "bank_statement_empty": "Bank statement was processed without entries.",
            "bank_statement_missing_owner": "Bank statement has no account owner filled in.",
            "item_unassigned": "Current workflow step has no responsible user assigned.",
            "item_stale": "Item has had no relevant update for {days} day(s)."
        }
    },
    "overview_page": {
        "title": "Prehľad",
        "procurement_abbr": "PO",
        "invoice_abbr": "IN",
        "outgoing_invoice_abbr": "VF",
        "draft_abbr": "DR",
        "contract_abbr": "ZM",
        "delivery_note_abbr": "DN",
        "all_docs": "Všetky dokumenty",
        "all_docs_tree": "Všetky dokumenty (strom)",
        "all_docs_list": "Všetky dokumenty (zoznam)",
        "search_all_documents": "Hľadať vo všetkých dokumentoch",
        "export_ready_docs": "Pripravené na export",
        "my_tasks": "Moje úlohy",
        "my_orders": "Moje objednávky",
        "my_bank_statements": "Moje bankové výpisy",
        "previous_document": "Predchádzajúci dokument",
        "next_document": "Nasledujúci dokument",
        "collapse_sidebar": "Zbaliť bočný panel",
        "expand_sidebar": "Rozbaliť bočný panel",
        "collapse_properties_sidebar": "Zbaliť panel akcií",
        "expand_properties_sidebar": "Rozbaliť panel akcií",
        "properties_sidebar": {
            "no_step": "Žiadny aktívny krok",
            "completed": "Dokončené"
        },
        "saved_searches": "Uložené vyhľadávania",
        "my_orders_no_invoices": "K tejto objednávke zatiaľ nie je priradená žiadna faktúra.",
        "my_orders_goods_receipt": "Príjem tovaru",
        "procurements": "Požiadavky na nákup",
        "invoices": "Účty",
        "outgoing_invoices": "Výstupné faktúry",
        "list_column_incoming_invoice": "Prichádzajúce",
        "list_column_outgoing_invoice": "Odchádzajúce",
        "drafts": "Koncepty",
        "contracts": "Zmluvy",
        "no_selection": "Nie je vybratý žiadny dokument.",
        "common_fields": "Spoločné polia",
        "comment_box_placeholder": "Tvoj komentár...",
        "comment_box_btn": "Zanechať komentár",
        "comment_box_mentions_loading": "Načítavajú sa používatelia...",
        "comment_box_mentions_empty": "Nenašli sa žiadni používatelia.",
        "communication": {
            "tooltip": "Kontaktovať dodávateľa",
            "tooltip_business_partner": "Kontaktovať obchodného partnera",
            "disabled_hint": "Prosím nastavte v konfigurácii aktívnu schránku so zapnutou komunikáciou s dodávateľom pre tento typ dokumentu.",
            "dialog_title": "Kontaktovať dodávateľa",
            "dialog_title_business_partner": "Kontaktovať obchodného partnera",
            "send_order_dialog_title": "Odoslať objednávku cez SupplierConnect",
            "from_mailbox": "Odosielacia schránka",
            "from_mailbox_placeholder": "Vyberte schránku",
            "supplier": "Dodávateľ",
            "to": "Komu",
            "visibility": "Viditeľnosť",
            "internal_note": "Interná správa",
            "internal_tag": "Interné",
            "external_tag": "Externé",
            "external_hint": "Externé: dodávateľ a všetci vybraní príjemcovia dostanú túto správu.",
            "internal_hint": "Interné: oznámenie dostanú iba označení používatelia liftbase. Dodávateľ nebude kontaktovaný.",
            "cc_mentions": "Kópia používateľom (@mention)",
            "cc_mentions_placeholder": "Použite @ na označenie používateľov zo systému",
            "internal_recipients": "Interní príjemcovia",
            "cc_emails": "Kópia e-maily",
            "cc_emails_placeholder": "Pridajte e-mail a stlačte Enter",
            "subject": "Predmet",
            "body": "Správa",
            "body_placeholder": "Napíšte správu...",
            "attach_order_pdf": "Priložiť PDF objednávky",
            "attach_invoice_document": "Priložiť dokument faktúry",
            "attach_order_pdf_mode_plain": "Bez ponuky",
            "attach_order_pdf_mode_with_line_attachments": "S ponukou",
            "reply_info": "Odpovede budú doručené iba do nakonfigurovanej komunikačnej schránky. Používateľ, ktorý komunikáciu začal, bude následne upozornený.",
            "internal_reply_info": "Interné správy sa odosielajú iba označeným používateľom liftbase.",
            "send": "Odoslať e-mail",
            "dialog_options_action": "Ďalšie možnosti e-mailu",
            "validation": "Vyplňte všetky povinné polia.",
            "sent_success": "Komunikácia bola úspešne odoslaná.",
            "sent_error": "Komunikáciu sa nepodarilo odoslať.",
            "sent_error_mailbox_reconnect": "Komunikáciu sa nepodarilo odoslať, pretože Microsoft mailbox {mailbox} už nie je pripojený.\nZnova ho pripojte v nastaveniach a skúste to ešte raz.",
            "sent_error_mailbox_incomplete": "Komunikáciu sa nepodarilo odoslať, pretože pri mailboxe {mailbox} chýba SMTP host, používateľské meno alebo heslo.\nDoplňte konfiguráciu mailboxu v nastaveniach.",
            "history_title": "Komunikácia s dodávateľom",
            "history_title_business_partner": "Komunikácia s obchodným partnerom",
            "history_empty": "Pre tento dokument ešte nebola začatá žiadna komunikácia.",
            "recipients": "Príjemcovia",
            "cc": "Cc",
            "attachments": "Prílohy",
            "attachments_available": "Obsahuje prílohy",
            "statuses": {
                "pending": "Čaká",
                "sent": "Odoslané",
                "failed": "Neúspešné",
                "received": "Prijaté"
            },
            "reply_action": "Odpovedať",
            "forward_action": "Preposlať",
            "forward_dialog_title": "Preposlať e-mail",
            "forward_subject_prefix": "Fwd:",
            "forwarded_message_title": "Preposlaná správa",
            "forward_attachments_hint": "Tieto prílohy budú odoslané spolu s preposlaným e-mailom.",
            "history_quote_title": "História komunikácie",
            "history_date_label": "Dátum",
            "history_from_label": "Od",
            "history_to_label": "Komu",
            "history_subject_label": "Predmet",
            "show_less": "Zobraziť menej",
            "involved_button": "Zapojení",
            "involved_title": "Zapojení používatelia a e-maily",
            "involved_search_placeholder": "Hľadať podľa mena alebo e-mailu",
            "involved_copy_email": "Kopírovať e-mail",
            "involved_copied": "E-mail skopírovaný",
            "involved_empty": "Nenašli sa žiadni účastníci",
            "involved_sections": {
                "suppliers": "Dodávatelia",
                "users": "Interní používatelia",
                "manual": "Manuálne e-maily",
                "mailbox": "Mailbox"
            },
            "address_book_source_supplier": "Adresa dodavatela",
            "address_book_source_saved": "Uz pouzite",
            "address_book_delete": "Odstranit ulozenu sugestiu",
            "address_book_delete_success": "Ulozena sugestia bola odstranena.",
            "address_book_delete_error": "Ulozenu sugestiu sa nepodarilo odstranit."
        },
        "edit_filename_title": "Upraviť názov súboru",
        "edit_filename_msg": "Zadajte nový názov súboru. <br> Starý názov: {filename}",
        "duplicate_invoice": {
            "message": "Duplicita - Bola nájdená aspoň jedna faktúra s rovnakým číslom faktúry:",
            "invoice_number": "Číslo faktúry",
            "invoice_date": "Dátum"
        },
        "task_list": {
            "name": "Označenie",
            "status": "Postavenie",
            "date": "Dátum",
            "draft": "Návrh"
        },
        "searchbar": {
            "search": "Vyhľadávanie",
            "filter_by": "Triediť podľa",
            "created_at": "Dátum vytvorenia",
            "timeline": "Timeline",
            "last_used": "Naposledy použité",
            "no_search": "Nie",
            "save_search": "Uložiť vyhľadávanie",
            "save_search_prompt": "Chcete uložiť toto vyhľadávanie? Zadajte názov.",
            "label_placeholder": "Názov",
            "label_required": "Zadajte názov.",
            "label_exists": "Tento nazov uz existuje.",
            "saved_success": "Vyhľadávanie bolo uložené.",
            "edit_saved_search": "Premenovat ulozene vyhladavanie",
            "edit_saved_search_title": "Premenovat ulozene vyhladavanie",
            "edit_saved_search_prompt": "Ako sa ma volat toto ulozene vyhladavanie?",
            "edited_success": "Ulozene vyhladavanie bolo premenovane.",
            "delete_saved_search": "Odstrániť uložené vyhľadávanie",
            "delete_saved_search_title": "Odstrániť uložené vyhľadávanie",
            "delete_saved_search_prompt": "Naozaj chcete odstrániť uložené vyhľadávanie \"{label}\"?",
            "deleted_success": "Uložené vyhľadávanie bolo odstránené.",
            "timeline_props": {
                "editor_name": "Editor",
                "entry_type": "Krok časovej osi",
                "current_editor_name": "Aktuálny editor",
                "current_entry_type": "Aktuálny krok"
            },
            "common_props": {
                "client_name": "Názov spoločnosti",
                "client_number": "Číslo spoločnosti",
                "department_name": "Názov oddelenia",
                "department_number": "Číslo oddelenia",
                "cost_center_name": "Názov strediska",
                "cost_center_number": "Číslo strediska",
                "ledger_account_name": "Názov účtu",
                "ledger_account_number": "Číslo účtu",
                "cost_type_name": "Typ nákladu",
                "product_names": "Produkt",
                "product_numbers": "Kód produktu",
                "status": "Stav",
                "supplier_display_name": "Dodávateľ",
                "payment_in_advance": "Platba vopred",
            },
            "procurement_props": {
                "order_number_formatted": "Číslo objednávky",
                "name": "Popis",
                "creator_name": "Vytvoril",
                "consignee_name": "Príjem tovaru",
                "supplier_names": "Dodávateľ",
                "delivery_date_overdue": "Dátum dodania po termíne"
            },
            "invoice_props": {
                "invoice_number": "Číslo faktúry",
                "invoice_number_formatted": "Interné číslo faktúry",
                "invoice_prefix": "Prefix faktúry",
                "procurement_number": "Číslo objednávky",
                "creator_name": "Nahrané od",
                "supplier_name": "Názov dodávateľa",
                "supplier_number": "Číslo dodávateľa",
                "invoice_date": "Dátum faktúry",
                "due_date": "Dátum splatnosti"
            },
            "time_ranges": {
                "today": "dnes",
                "yesterday": "včera",
                "past_7_days": "posledných 7 dní",
                "past_30_days": "posledných 30 dní",
                "this_week": "tento týždeň",
                "last_week": "minulý týždeň",
                "this_month": "tento mesiac",
                "last_month": "minulý mesiac",
                "this_year": "tento rok",
                "last_year": "minulý rok"
            }
        },
        "export": {
            "all_information": "Všetky informácie",
            "export_procurement": "Exportujte požiadavky na nákup",
            "export_documents": "Exportovať dokumenty",
            "registers": "Príspevky",
            "export": "Export",
            "to_export": "Export",
            "export_with_products": "Export s produktmi",
            "custom_export": "Nastavený export",
            "select_fields": "Vyberte polia, ktoré sa majú exportovať.",
            "select_all": "vybrať všetko",
            "deselect_all": "Odobrať všetky",
            "general": "Všeobecné informácie",
            "products": "Produkty",
            "include_product": "Vrátane produktov",
            "filter": "Filter",
            "no_filter": "žiadny filter",
            "format": "Formát súboru",
            "csv": "CSV",
            "xlsx": "XLSX",
            "loading": "načítava sa",
            "error": "Export zlyhal. Skúste to znova.",
            "labels": {
                "procurement": {
                    "order_number_formatted": "číslo LB",
                    "name": "Označenie",
                    "status": "Postavenie",
                    "creator_name": "Vytvoril(a)",
                    "total_price_brutto": "Celkom s DPH",
                    "total_price_netto": "Celková netto",
                    "type_total_price_brutto": "currency",
                    "type_total_price_netto": "currency",
                    "created_at": "Dátum vytvorenia",
                    "client_number": "Číslo firmy",
                    "client_name": "Meno spoločnosti",
                    "department_name": "Názov oddelenia",
                    "department_number": "Číslo oddelenia",
                    "cost_center_number": "Číslo nákladového strediska",
                    "cost_center_name": "Názov nákladového strediska",
                    "consignee_name": "Príjem tovaru",
                    "shipping_date": "dátum doručenia",
                    "shipping_name": "Názov dodacej adresy",
                    "shipping_consignee": "Dodacia adresa Meno prijímajúcej osoby",
                    "shipping_dropoff_location": "Dodacia adresa Názov skladovacieho miesta",
                    "shipping_address": "Ulica a číslo dodacej adresy.",
                    "shipping_complement": "Ulica dodacej adresy 2",
                    "shipping_country": "Krajina dodacej adresy",
                    "shipping_zipcode": "PSČ dodacej adresy",
                    "shipping_city": "Mesto dodacej adresy",
                    "shipping_phone_country_code": "Dodacia adresa telefón krajina",
                    "shipping_phone_number": "Telefónna adresa dodania",
                    "billing_name": "Názov fakturačnej adresy",
                    "billing_consignee": "Fakturačná adresa Meno príjemcu",
                    "billing_dropoff_location": "Fakturačná adresa Názov miesta uloženia",
                    "billing_address": "Fakturačná adresa, ulica a číslo.",
                    "billing_complement": "Ulica fakturačnej adresy 2",
                    "billing_country": "Krajina fakturačnej adresy",
                    "billing_zipcode": "PSČ fakturačnej adresy",
                    "billing_city": "Mesto fakturačnej adresy",
                    "billing_phone_country_code": "Fakturačná adresa telefónna krajina",
                    "billing_phone_number": "Fakturačná adresa telefónne číslo"
                },
                "product": {
                    "product_name": "Meno Produktu",
                    "product_number": "Číslo položky",
                    "product_supplier_name": "Názov doručovacej spoločnosti",
                    "product_supplier_email": "Email doručovacej spoločnosti",
                    "product_cost_center_name": "Názov nákladového strediska (produkt)",
                    "product_cost_center_number": "Číslo nákladového strediska (produkt)",
                    "product_tax": "daň",
                    "product_quantity": "Množstvo (produkt)",
                    "product_total_netto": "Celková netto (produkt)",
                    "product_total_brutto": "Celková hrubá suma (produkt)",
                    "product_netto": "Jednotková cena netto",
                    "product_brutto": "Jednotková cena brutto",
                    "product_unit_price_base_amount": "Jednotková cena pred zľavou (produkt)",
                    "product_unit_price_discount_amount": "Zľava z jednotkovej ceny (produkt)",
                    "product_line_discount_amount": "Zľava položky (produkt)",
                    "product_line_discount_base_amount": "Základ zľavy položky (produkt)",
                    "product_line_discount_percentage": "Zľava položky % (produkt)",
                    "product_unit": "Jednotka",
                    "product_img_url": "Adresa URL obrázka",
                    "product_shop_url": "Adresa URL obchodu",
                    "product_shipping_name": "Názov dodacej adresy (produktu)",
                    "product_shipping_consignee": "Dodacia adresa Meno prijímajúcej osoby (produktu)",
                    "product_shipping_dropoff_location": "Dodacia adresa Názov miesta skladu (produktu)",
                    "product_shipping_address": "Ulica a číslo dodacej adresy (produkt)",
                    "product_shipping_complement": "Ulica doručenia 2 (produkt)",
                    "product_shipping_country": "Krajina dodacej adresy (produkt)",
                    "product_shipping_zipcode": "PSČ dodacej adresy (produkt)",
                    "product_shipping_city": "Mesto dodania (produkt)",
                    "product_shipping_phone_country_code": "Dodacia adresa Krajina telefónu (produkt)",
                    "product_shipping_phone_number": "Telefónne číslo dodacej adresy (produkt)",
                    "product_received_at": "Posledný príjem tovaru (dátum)",
                    "product_received_by": "Posledný príjem tovaru (osoba)"
                },
                "invoice": {
                    "invoice_number_formatted": "Číslo internej faktúry",
                    "number": "Číslo faktúry",
                    "invoice_prefix": "Prefix faktúry",
                    "creator_name": "nahrané používateľom",
                    "status": "Postavenie",
                    "procurement_name": "Nákupná objednávka",
                    "procurement_number": "Číslo objednávky",
                    "cost_center_name": "Názov nákladového strediska",
                    "cost_center_number": "Číslo nákladového strediska",
                    "total_price_netto": "Celková netto",
                    "total_price_brutto": "Celkom s DPH",
                    "document_discount_amount": "Čiastka zľavy dokladu",
                    "document_discount_base_amount": "Základ zľavy dokladu",
                    "document_discount_percentage": "Zľava dokladu %",
                    "document_discount_tax_percentage": "DPH zľavy dokladu %",
                    "type_total_price_brutto": "currency",
                    "type_total_price_netto": "currency",
                    "created_at": "Nahrané dňa",
                    "client_name": "Spoločnosť",
                    "client_number": "Číslo firmy",
                    "invoice_date": "Dátum faktúry",
                    "due_date": "Do dátumu",
                    "delivery_date": "Dátum dodania",
                    "currency": "mena",
                    "ledger_account_name": "Názov účtovného účtu",
                    "ledger_account_number": "Číslo účtu hlavnej knihy",
                    "posting_key_number": "Daňový kód",
                    "posting_key_tax": "Daňový kľúč Daň",
                    "supplier_name": "Dodávateľ",
                    "paid": "Zaplatené"
                },
                "contract": {
                    "name": "Názov",
                    "contract_date": "Dátum zmluvy",
                    "contract_number_formatted": "Číslo KT",
                    "contract_number": "Číslo zmluvy",
                    "category": "Kategória",
                    "status": "Stav",
                    "term_type": "Typ trvania",
                    "payment_method": "Platobná metóda",
                    "external_contract_number": "Externé číslo zmluvy",
                    "creator_name": "Vytvoril",
                    "created_at": "Dátum vytvorenia",
                    "client_number": "Číslo spoločnosti",
                    "client_name": "Názov spoločnosti",
                    "department_name": "Názov oddelenia",
                    "department_number": "Číslo oddelenia",
                    "cost_center_name": "Názov nákladového strediska",
                    "cost_center_number": "Číslo nákladového strediska",
                    "supplier_name": "Názov dodávateľa",
                    "supplier_number": "Číslo dodávateľa",
                    "responsible_name": "Zodpovedná osoba",
                    "notes": "Poznámka",
                    "payment_direction": "Vzťah",
                    "recurring_invoice": "Opakovaná faktúra",
                    "start_date": "Dátum začiatku",
                    "end_date": "Dátum konca",
                    "duration": "Trvanie zmluvy",
                    "duration_unit_type": "Jednotka trvania zmluvy",
                    "renewal_type": "Typ obnovenia",
                    "renewal_duration": "Trvanie obnovenia",
                    "renewal_duration_unit_type": "Jednotka trvania obnovenia",
                    "notice_period": "Výpovedná lehota",
                    "notice_period_unit_type": "Jednotka výpovednej lehoty",
                    "termination_special_right": "Špeciálne právo na ukončenie",
                    "termination_deadline": "Termín ukončenia",
                    "next_possible_contract_end": "Najbližší možný koniec zmluvy",
                    "terminated_on": "Ukončené dňa",
                    "termination_to": "Ukončenie k",
                    "payment_timing": "Typ platby",
                    "usage_type": "Frekvencia"
                }
            }
        },
        "actions": {
            "tour": {
                "procurement_reassignment_title": "Priradiť/objasniť požiadavku na nákup",
                "procurement_reassignment_msg": "Táto úloha momentálne leží na niekom inom. Pomocou tohto tlačidla môžete prideliť úlohu tretej osobe alebo sebe na objasnenie alebo ďalšie spracovanie. Žiadosti o nákup je možné zrušiť aj počas objasňovania.",
                "invoice_reassignment_title": "Priradiť/objasniť faktúru",
                "invoice_reassignment_msg": "Táto úloha momentálne leží na niekom inom. Pomocou tohto tlačidla môžete prideliť úlohu tretej osobe alebo sebe na objasnenie alebo ďalšie spracovanie. Faktúry je možné eliminovať aj pri objasňovaní."
            },
            "skip_confirm_dialog_title": "Zrušte rozpoznávanie dokumentov",
            "skip_confirm_dialog_msg": "Ak chcete skontrolovať, či už existuje výsledok rozpoznávania dokumentu, obnovte stránku vo svojom prehliadači. <br>Ste si istí, že chcete zrušiť rozpoznávanie údajov faktúry a zadať údaje ručne?",
            "button_hint": {
                "to_approval": "Na prepustenie",
                "to_send_order": "Do provízie",
                "to_accounting": "Do účtovníctva",
                "approve": "Schválenie",
                "self_assign": "Prijať",
                "finish_order": "Dokončite zadanie",
                "finish_delivery": "Dokončiť",
                "skip_recognition": "Zrušte rozpoznávanie dokumentov",
                "to_export": "Na export",
                "default": "ďalej",
                "cancel_or_assign_procurement": "Priradiť/Zrušiť",
                "cancel_or_assign_invoice": "Priradiť/ovládať",
                "clearing_or_assign": "Priradiť/objasniť"
            },
            "assignment_tooltip": "Objasnenie alebo zadanie",
            "restart_approval_tooltip": "Reštartovať časovú os",
            "restart_or_clearing_tooltip": "Reštartovať časovú os alebo priradiť na objasnenie",
            "restart_approval_error": "Schvaľovací proces sa nepodarilo reštartovať.",
            "assignment_dialog": {
                "title_procurement_assign_or_cancel": "Pridelenie alebo zrušenie",
                "title_invoice_assign_or_cancel": "Priradenie alebo kontrola",
                "title_assign": "pridelenie",
                "title_clearing_or_assign": "Objasnenie alebo zadanie",
                "assign_title": "Priraďte aktuálnu úlohu niekomu inému",
                "assign_msg": "Aktuálne pridelená osoba nie je k dispozícii alebo nie je zodpovedná za túto úlohu, takže túto úlohu by mal prevziať niekto iný.",
                "clearing_title": "Priraďte na objasnenie",
                "clearing_msg": "Aktuálne pridelená osoba je k dispozícii a zodpovedá za túto úlohu, ale proces nemôže pokračovať v spracovaní z iných dôvodov. Preto chcete začať proces objasňovania.",
                "cancel_procurement_title": "zrušenie",
                "cancel_procurement_msg": "Objednávka bude nenávratne zrušená a nie je možné ju ďalej spracovávať. Zrušené objednávky nájdete v prehľade pod statusom „Odmietnuté“.",
                "cancel_invoice_title": "Kontrola",
                "cancel_invoice_msg": "Faktúra je nenávratne vymazaná a nie je možné ju ďalej spracovávať. Vyplatené faktúry nájdete v prehľade všetkých dokladov pod stavom „Vyplatené“.",
                "assign_to": "Priradiť",
                "reason": "Dôvod",
                "declined_invoice_alert_title": "Odmietnutú faktúru nie je možné znova otvoriť",
                "declined_invoice_alert_message": "Táto faktúra už bola odmietnutá. Možno ju iba poslať na objasnenie, aby sa v prípade potreby upravili údaje. Potom ju už nemožno znova otvoriť a musí sa odoslať nanovo.",
                "clearing_footer_info": "Aktuálna úloha je zrušená. Pre vybranú osobu sa spustí nová úloha na objasnenie.",
                "reassignment_footer_info": "Zmení sa iba osoba, ktorá vykonáva aktuálnu úlohu.",
                "restart_approval_title": "Reštartovať schvaľovací proces",
                "restart_approval_dialog_title": "Reštartovať časovú os",
                "restart_or_clearing_dialog_title": "Reštartovať časovú os alebo priradiť na objasnenie",
                "restart_approval_msg": "Faktúra sa vráti na manuálnu kontrolu a prejde novým schvaľovacím kolom. Predchádzajúca história časovej osi zostane zachovaná.",
                "restart_approval_footer_info": "Faktúra sa vráti na manuálnu kontrolu. Predchádzajúca história časovej osi zostane zachovaná.",
                "cancel_invoice_btn": "Diskvalifikovať",
                "cancel_procurement_btn": "Zrušiť",
                "assign_btn": "Priradiť",
                "restart_approval_btn": "Reštartovať",
                "prevent_approve_group_msg": "Pred schválením priraďte tento krok osobe.",
                "clearing_dialog": {
                    "title": "Osoba na objasnenie ",
                    "procurement_message": "Osoba v kroku „Objasnenie“ je výsledkom rôznych predbežných pridelení zodpovedných ľudí podľa oddelenia, spoločnosti, predbežného pridelenia globálnej role a osoby, ktorá objednávku vytvorila. Osoba v hornej časti zoznamu je vopred priradená k úlohe.",
                    "invoice_message": "Osoba v kroku „Objasnenie“ je výsledkom rôznych predbežných pridelení zodpovedných ľudí na spoločnosť, predbežného pridelenia globálnej role a osoby, ktorá vytvorila faktúru. Osoba v hornej časti zoznamu je vopred priradená k úlohe.",
                    "department_form": "Oddelenie vo formulári",
                    "department_creator": "Oddelenie objednávateľa",
                    "client_form": "Spoločnosť vo forme",
                    "client_creator": "Spoločnosť osoby, ktorá zadáva objednávku",
                    "no_selection": "ešte nevybraté",
                    "no_action": "nepoužiteľné"
                },
                "cancellation_dialog": {
                    "title_procurement": "zrušenie",
                    "btn_procurement": "Zrušiť",
                    "message_procurement": "Naozaj chcete zrušiť túto objednávku?",
                    "title_invoice": "Kontrola",
                    "btn_invoice": "Diskvalifikovať",
                    "message_invoice": "Naozaj chcete zaplatiť tento účet?"
                }
            }
        },
        "tour": {
            "overview": {
                "search_box": "Vyhľadávanie vám umožňuje filtrovať požiadavky v časti Moje úlohy a Všetky potvrdenky a vyhľadávať rôzne informácie, aby ste rýchlejšie našli konkrétne požiadavky.",
                "tab_tasks": "Tu môžete vidieť požiadavky na nákup, za ktoré momentálne zodpovedáte. V pravom stĺpci vidíte stav svojich úloh.",
                "tab_all_procurements": "V tejto stromovej štruktúre nájdete všetky požiadavky na nákup zoradené podľa aktuálneho stavu.",
                "refresh_btn": "Tu môžete aktualizovať prehľad žiadostí o nákup.",
                "type_filter": "Tu môžete filtrovať podľa typu úlohy."
            },
            "procurement": {
                "form_title": "Formulár žiadosti o nákup",
                "form": "Tu nájdete informácie o žiadosti o nákup.",
                "approve_btn_title": "Dopredná požiadavka na nákup",
                "approve_btn": "Keď dokončíte úlohu a chcete požiadavku postúpiť ďalšej zodpovednej osobe alebo kroku, stlačte modré začiarknutie.",
                "reassign_btn": "Ak nechcete úlohu dokončiť, napríklad preto, že je stále neistota alebo by mal na úlohe pokračovať niekto iný, môžete stlačiť červené tlačidlo. Potom môžete úlohu buď odovzdať, alebo ju prideliť niekomu na objasnenie. Žiadosti o nákup je možné zrušiť aj počas objasňovania.",
                "add_comment": "K požiadavke na objednávku môžete pridať komentár pomocou poľa komentár. To sa potom zobrazí na časovej osi.",
                "timeline_title": "Timeline",
                "timeline": "Časová os zobrazuje minulý a budúci priebeh požiadavky na nákup, ako aj aktuálny stav (modrá) a komentáre k požiadavke na nákup. Radenie je možné obrátiť pomocou tlačidla ozubeného kolieska.",
                "timeline_preferences": "Toto tlačidlo možno použiť na nastavenie zobrazenia na časovej osi. Môžete napríklad nastaviť, či sa majú udalosti triediť vzostupne alebo zostupne a či sa majú úpravy požiadavky na nákup zobraziť alebo skryť."
            },
            "invoice": {
                "form_title": "Fakturačný formulár",
                "form": "Tu môžete zadať alebo upraviť informácie o faktúre.",
                "add_line": "Tu môžete pridať položku faktúry.",
                "edit_lines": "Tu môžete upraviť informácie o položkách faktúry.",
                "approve_btn_title": "Dopredná faktúra",
                "approve_btn": "Keď dokončíte úlohu a chcete postúpiť faktúru ďalšej zodpovednej osobe alebo kroku, stlačte modré začiarknutie.",
                "reassign_btn": "Ak nechcete úlohu dokončiť, napríklad preto, že je stále neistota alebo by mal na úlohe pokračovať niekto iný, môžete stlačiť červené tlačidlo. Potom môžete úlohu buď odovzdať, alebo ju prideliť niekomu na objasnenie. Faktúry je možné odstrániť aj počas objasňovania.",
                "add_comment": "Pomocou poľa komentára môžete urobiť komentár k faktúre. To sa potom zobrazí na časovej osi.",
                "timeline_title": "Timeline",
                "timeline": "Časová os zobrazuje minulý a budúci priebeh faktúry, ako aj aktuálny stav (modrá) a komentáre k faktúre. Radenie je možné obrátiť pomocou tlačidla ozubeného kolieska.",
                "timeline_preferences": "Toto tlačidlo možno použiť na nastavenie zobrazenia na časovej osi. Môžete napríklad nastaviť, či sa majú udalosti triediť vzostupne alebo zostupne a či sa majú úpravy faktúr zobraziť alebo skryť."
            },
            "welcome": {
                "logo_title": "Vitajte na liftbase!",
                "logo": "<p>Aby sme vám uľahčili začiatok, vysvetlíme vám najdôležitejšie veci pomocou prehliadky základne výťahu.</p> <p>Na navigáciu v prehliadke použite tlačidlá nižšie alebo klávesy so šípkami. </p>",
                "menu": "V pravom hornom rohu je hlavná ponuka, kde nájdete všetky dôležité oblasti výťahovej základne.",
                "menu_help": "Jednotlivé časti prehliadky môžete kedykoľvek ukončiť a neskôr v ponuke pomocníka znova spustiť.",
                "menu_admin": "Ďalšiu časť prehliadky nájdete tu."
            }
        }
    },
    "liquidity_planning": {
        "subtitle": "Skontrolujte aktuálny cash flow podľa spoločnosti, plánujte ďalšie týždne a porovnávajte alternatívne scenáre.",
        "horizon_hint": "Predvolený pohľad: aktuálny kalendárny týždeň, 12 nasledujúcich týždňov a potom 6 mesačných blokov. Manuálne riadky sa vždy vedú po kalendárnych týždňoch.",
        "scenario_placeholder": "Vybrať scenár",
        "scenario": "Scenár",
        "start_date": "Dátum začiatku",
        "start_date_required": "Zadajte prosím dátum začiatku.",
        "start_date_min_today": "Dátum začiatku musí byť dnes alebo neskôr.",
        "active_filters": "Aktívne filtre",
        "default_scenario_name": "Hlavný scenár",
        "no_scenarios_found": "Nenašli sa žiadne scenáre.",
        "opening_balance": "Počiatočný zostatok",
        "ending_balance": "Koncový zostatok",
        "inflow": "Príjmy",
        "outflow": "Výdavky",
        "total_in_period": "Súčet vo viditeľnom horizonte",
        "last_visible_period": "Zostatok na konci posledného viditeľného obdobia",
        "empty_client_description": "Najprv vyberte spoločnosť, aby sa načítalo plánovanie likvidity.",
        "empty_scenario_description": "Pre túto spoločnosť ešte neexistuje scenár. Vytvorte teraz prvý scenár.",
        "table_row_label": "Položka",
        "manual_row_label": "Názov riadku",
        "manual_row_label_required": "Zadajte názov riadku.",
        "add_manual_row": "Pridať manuálny riadok",
        "add_manual_row_individual": "Zadať jednotlivo",
        "add_manual_row_spreadsheet": "Tabuľka (Excel)",
        "manual_spreadsheet_hint": "Prvý riadok sa zobrazí v pláne. Uloží sa celá tabuľka.",
        "manual_spreadsheet_unavailable": "Tabuľka nie je k dispozícii. Zatvorte editor a otvorte ho znova.",
        "manual_spreadsheet_values_required": "Zadajte aspoň jednu hodnotu alebo vzorec do prvého riadku.",
        "manual_edit": "Upraviť manuálne",
        "manual_entries": "Manuálne položky",
        "manual_entries_hint": "Tu udržiavajte názov a sumu za kalendárny týždeň. Mesačný pohľad tieto týždne automaticky zoskupí.",
        "manual_week": "Kalendárny týždeň",
        "manual_entry_label": "Názov",
        "manual_entry_amount": "Suma",
        "manual_entries_count": "{count} manuálnych položiek",
        "documents_count": "{count} záznamov",
        "pending": "Po splatnosti",
        "open_outgoing_invoices": "Otvorené vystavené faktúry",
        "open_incoming_invoices": "Otvorené prijaté faktúry",
        "open_procurements": "Otvorené objednávky",
        "view_records": "Zobraziť záznamy",
        "records_number": "Číslo",
        "records_name": "Názov",
        "records_date": "Dátum",
        "records_amount": "Suma",
        "unassigned_cost_type": "Bez typu nákladov",
        "unassigned_revenue_type": "Bez typu výnosov",
        "select_cost_type": "Vyberte typ nákladov",
        "select_revenue_type": "Vyberte typ výnosov",
        "manual_row_type_save_error": "Manuálny riadok sa nepodarilo priradiť k zvolenému typu nákladov alebo výnosov. Aktualizujte metadata Hasury (metadata apply) a uložte znova.",
        "balance_source_statement": "Ukotvené bankovým výpisom do {date}",
        "balance_source_manual": "Aktívna je len manuálna úprava scenára",
        "balance_source_none": "Nie je k dispozícii historický bankový zostatok",
        "load_error": "Plánovanie likvidity sa nepodarilo načítať.",
        "save_error": "Scenár sa nepodarilo uložiť.",
        "create_scenario": "Vytvoriť scenár",
        "copy_scenario": "Kopírovať scenár",
        "delete_scenario": "Odstrániť scenár",
        "delete_scenario_confirm": "Naozaj chcete odstrániť tento scenár? Tento krok je nevratný.",
        "create_scenario_prompt": "Zadajte názov nového scenára.",
        "edit_scenario_prompt": "Zadajte nový názov tohto scenára.",
        "copy_scenario_prompt": "Zadajte názov kópie scenára.",
        "copy_suffix": "Kópia",
        "name_required": "Zadajte názov.",
        "delete_manual_row_confirm": "Naozaj chcete odstrániť tento manuálny riadok?",
        "table_width": "Šírka stĺpcov",
        "show_chart": "Zobraziť graf",
        "view_standard": "Standard (13 týždňov + 6 mesiacov)",
        "view_all_weeks": "Všetky týždne",
        "view_all_months": "Všetky mesiace",
        "add_manual_row_inflow": "Manuálny príjem",
        "add_manual_row_outflow": "Manuálny výdaj",
        "discard_unsaved_title": "Neuložené zmeny",
        "discard_unsaved_confirm": "Máte neuložené zmeny. Ak prepnete zobrazenie, vaše úpravy sa stratia. Chcete pokračovať?",
        "discard_unsaved_confirm_button": "Zahodiť zmeny"
    },
    "operator_area": {
        "title": "Operátor",
        "tenant_menu": "Nájomníci",
        "feature_billing_menu": "Feature Monetization",
        "feature_usage_menu": "Feature Usage",
        "mcp_usage_menu": "MCP Usage",
        "invoice_recognition_menu": "Invoice Recognition",
        "ai_llm_menu": "AI/LLM Monitor",
        "holiday_settings_menu": "Sviatky",
        "einvoice_acceptance_menu": "Pravidlá prijatia e-faktúry",
        "bank_statement_fixtures_menu": "Testovacie výpisy účtu",
        "procurement_menu": "Požiadavky na nákup",
        "invoice_menu": "účty",
        "invoice_export_log_menu": "Export Log",
        "no_permission": "Nemáte povolenie na zobrazenie tejto oblasti.",
        "invoice_export_log": {
            "title": "Export Log",
            "filters": {
                "tenant": "Filter tenant",
                "invoice_id": "Invoice ID",
                "export_group": "Export group",
                "module": "Module",
                "source": "Source",
                "include_exported": "Included exported",
                "clear": "Reset filters"
            },
            "sources": {
                "bulk": "Bulk selection",
                "individual": "Individual export"
            },
            "statuses": {
                "success": "Success",
                "partial": "Partial",
                "failed": "Failed",
                "empty": "No export"
            },
            "columns": {
                "id": "ID",
                "status": "Status",
                "created_at": "Created at",
                "tenant": "Tenant",
                "module": "Module",
                "source": "Source",
                "include_exported": "Included exported",
                "requested_by": "Requested by",
                "export_group": "Export group",
                "requested": "Requested",
                "exported": "Exported",
                "skipped": "Skipped",
                "failed": "Failed",
                "requested_invoice_ids": "Requested invoices",
                "actually_exported_invoice_ids": "Actually exported invoices",
                "skipped_already_exported_invoice_ids": "Skipped already exported",
                "failed_invoice_ids": "Failed invoices",
                "error_details": "Registered error"
            },
            "copy_success": "Export log copied.",
            "copy_failed": "The export log could not be copied.",
            "errors": {
                "load_failed": "The export log could not be loaded."
            }
        },
        "holiday_settings": {
            "title": "Holiday calendar",
            "subtitle": "Maintain holidays by country and state/region. Leave the state list empty to make a holiday apply nationwide.",
            "add": "Add holiday",
            "create_title": "Create holiday",
            "edit_title": "Edit holiday",
            "year_filter": "Filter by year",
            "state_filter": "Filter by state",
            "country_filter": "Filter by country",
            "regions_placeholder": "Select or enter states/regions",
            "nationwide": "Nationwide",
            "empty_regions_hint": "If no state/region is stored, the holiday applies to the entire country.",
            "delete_confirm": "Do you really want to delete this holiday?"
        },
        "einvoice_acceptance": {
            "title": "Pravidlá prijatia e-faktúry",
            "subtitle": "Nastavte inštrukcie pre výnimky IA a kritickosť pravidiel pre lokálnu validáciu e-faktúr.",
            "add": "Pridať pravidlo",
            "create_title": "Vytvoriť pravidlo prijatia",
            "edit_title": "Upraviť pravidlo prijatia",
            "error_code": "Pravidlo / kód chyby",
            "error_code_placeholder": "Hľadať pravidlo, napr. BR-CL-23 alebo kód jednotky",
            "error_code_description": "Krátky popis",
            "instruction": "Inštrukcia pre IA",
            "instruction_placeholder": "Pravidlo: BR-CL-23\nZistenie: Nestandardný kód jednotky\nRozhodnutie: ACCEPT, ak množstvo, plnenie, súčty a daňový výpočet ostanú jednoznačné\nOdôvodnenie: Odchýlka sa týka technického kódu jednotky a faktúru automaticky nespracovateľnou nerobí.",
            "enabled": "Aktívne",
            "delete_confirm": "Naozaj chcete toto pravidlo prijatia zmazať?",
            "with_ai": "S IA",
            "without_ai": "Bez IA",
            "edit_lists": "Upraviť zoznamy pravidiel",
            "edit_lists_title": "Upraviť zoznamy pravidiel bez IA",
            "edit_lists_hint": "Presuňte každé lokálne validačné pravidlo do príslušného zoznamu. Zmeny sa použijú až po uložení.",
            "manual_rule": "Manuálne pravidlo",
            "manual_rule_placeholder": "Zadajte ľubovoľný kód pravidla alebo chyby",
            "add_manual_rule": "Pridať pravidlo",
            "critical": "Kritické",
            "critical_hint": "Nález z tohto zoznamu ponechá e-faktúru zablokovanú.",
            "non_critical": "Nekritické",
            "non_critical_hint": "E-faktúra iba s nálezmi z tohto zoznamu môže prejsť lokálnou validáciou.",
            "comment": "Komentár",
            "comment_placeholder": "Voliteľný komentár k tomuto pravidlu",
            "edit_comment_title": "Upraviť komentár pravidla",
            "no_comment": "Bez komentára"
        },
        "bank_statement_fixtures": {
            "title": "Testovacie výpisy účtu",
            "subtitle": "Stiahnite si automaticky generované testovacie súbory bankových výpisov na základe otvorených faktúr aktuálneho tenant-a.",
            "access_notice": "Len pre operatora. ZIP obsahuje tenant-specific test cases vrátane manifest.json.",
            "format_label": "Výstupný formát",
            "format_placeholder": "Vyberte formát bankového výpisu",
            "format_hint": "Vyberte jeden cieľový formát. Všetky stiahnuté varianty budú vygenerované v tomto formáte.",
            "format_required": "Najprv vyberte formát bankového výpisu.",
            "client_hint": "Vyberte spoločnosť, ktorej otvorené faktúry sa majú použiť na generovanie testovacích bankových výpisov.",
            "client_required": "Najprv vyberte spoločnosť.",
            "client_placeholder": "Vyberte spoločnosť s otvorenými faktúrami",
            "load_clients_error": "Nepodarilo sa načítať dostupné spoločnosti.",
            "setup_title": "Nastavenie",
            "setup_hint": "Najprv vyberte cieľový formát a spoločnosť, potom môžete stiahnuť jeden alebo viac testovacích scenárov.",
            "selection_ready": "Pripravené na generovanie testovacích súborov",
            "selection_incomplete": "Dokončite výber, aby sa povolili sťahovania",
            "selection_hint": "Vybraná spoločnosť sa použije na otvorené faktúry aj realistické kmeňové dáta v každom variante.",
            "selection_format": "Formát",
            "selection_company": "Spoločnosť",
            "variants_title": "Dostupné scenáre",
            "variants_hint": "Nižšie vyberte konkrétny scenár alebo po dokončení nastavenia stiahnite celý ZIP.",
            "technical_details": "Technický náhľad",
            "missing_value": "Nie je vybrané",
            "download_all": "Stiahnuť všetky varianty",
            "download_variant": "Stiahnuť variant",
            "download_ready": "Sťahovanie sa spustilo.",
            "download_error": "Testovacie súbory sa nepodarilo stiahnuť.",
            "endpoint_label": "Endpoint",
            "auto_match_title": "Auto-Match",
            "auto_match_description": "Stiahne cielené testovacie prípady, v ktorých by sa mali položky automaticky spárovať s otvorenými faktúrami.",
            "mixed_title": "Zmiešaný scenár",
            "mixed_description": "Obsahuje jeden automatický match, jednu nepriraditeľnú debetnú položku a jednu ignorovanú kreditnú položku.",
            "random_title": "Random Multi-Match",
            "random_description": "Obsahuje viac realistických položiek s viacerými matchmi, ďalšie unmatched položky a jednu ignorovanú kreditnú položku.",
            "supplier_iban_mismatch_title": "Odchýlka IBAN dodávateľa",
            "supplier_iban_mismatch_description": "Stiahne cielený testovací prípad, v ktorom je dodávateľ rozpoznaný, ale IBAN vo výpise sa líši od master data dodávateľa."
        },
        "tenant": {
            "description": "Nájomca",
            "new": "Nový nájomca",
            "edit": "Upraviť",
            "archive": "Archív",
            "delete": "Odstrániť",
            "activate": "Obnoviť",
            "procurement_count": "BANF",
            "user_count": "užívateľ",
            "automatic_billing": "Automatické účtovanie",
            "automatic_billing_via": "Áno (cez {id})",
            "automatic_billing_missing_easybill_id": "Áno (nie je pripojené žiadne ID)",
            "storage_usage": "Úložisko",
            "tabs": {
                "general": "Všeobecné informácie",
                "invoice_config": "Faktúra",
                "ai": "AI"
            },
            "standard_package": "Štandardný balík",
            "invoice": {
                "items": {
                    "label": "Dodatočné položky",
                    "description": "Popis",
                    "price": "Čistá suma",
                    "start_date": "Dátum začiatku",
                    "end_date": "Dátum ukončenia"
                },
                "tiered_price": {
                    "label": "Stupňovité ceny",
                    "unit_price": "Jednotková cena",
                    "base_price": "Základná cena",
                    "doc_amount": "Množstvo"
                }
            },
            "contact_email_tooltip": "Nájomca sa môže najskôr prihlásiť pomocou tohto e-mailu.",
            "no_bank_info": "Údaje ešte neexistujú a môže ich vytvoriť iba nájomca.",
            "no_connection_with_easybill": "Tento nájomca ešte nie je pripojený k Easybill. Zadajte ID nájomcu v systéme Easybill.",
            "sync_with_easybill": "Získajte všetky údaje z Easybill",
            "update_from_easybill_btn": "Načítať z Easybill",
            "update_from_easybill_tooltip": "Získajte nájomcu z Easybill",
            "send_to_easybill_btn": "Vytvorte v Easybill",
            "send_to_easybill_tooltip": "Vytvorte nájomníka v Easybill",
            "link_existing_easybill_btn": "Prepojiť s existujúcim Easybill ID",
            "link_existing_easybill_tooltip": "Manuálne nastaviť existujúce Easybill ID zákazníka",
            "link_easybill_replace_title": "Nahradiť Easybill ID?",
            "link_easybill_replace_message": "Tento nájomca je už prepojený s Easybill ID {current}. Chcete zmeniť prepojenie na {next}?",
            "link_easybill_title": "Prepojiť Easybill ID",
            "link_easybill_prompt": "Zadajte prosím existujúce Easybill ID zákazníka.",
            "link_easybill_invalid": "Zadajte prosím číselné ID.",
            "create_and_send_invoice_tooltip": "Vytvorte faktúru v Easybill a odošlite ju zákazníkom",
            "create_and_send_invoice_btn": "Vytvoriť/odoslať faktúru",
            "open_invoices": "Zobraziť výpisy",
            "delete_procurements": "Odstrániť BANF",
            "delete_invoices": "Vymazať faktúry",
            "confirm_before_delete_msg": "<p>Naozaj chcete vymazať tohto nájomníka a všetky jeho údaje z databázy?</p><p> <i>Táto akcia sa nedá vrátiť späť.</i></p><p><b >Enter Zadajte meno nájomníka:</b></p>",
            "confirm_before_delete_error_msg": "Nájomca nebol odstránený, pretože meno bolo zadané nesprávne.",
            "deleted_msg": "Nájomník bol natrvalo odstránený.",
            "updated_msg": "Bola aktualizovaná.",
            "created_msg": "Bol vytvorený.",
            "sync_msg_error": "Tento nájomca ešte nie je pripojený k Easybill. Zadajte ID nájomcu v systéme Easybill.",
            "create_invoice_dialog": {
                "title": "Vytvoriť fakturáciu",
                "message": "Vyberte obdobie pre faktúru.",
                "date_placeholder": "Vyberte mesiac.",
                "create_btn": "Vytvorte"
            },
            "validation": {
                "name_required": "Zadajte meno.",
                "name_exists": "Názov už existuje.",
                "email_required": "Zadajte kontaktný e-mail.",
                "email_invalid": "Prosím zadajte platný e-mail."
            },
            "ai": {
                "enabled": "Povoliť funkcie AI",
                "model_name": "Názov AI modelu",
                "max_tokens": "Maximálny počet tokenov na požiadavku (na 1 000 tokenov)",
                "price_input_tokens": "Cena za 1 000 vstupných tokenov (centy)",
                "price_output_tokens": "Cena za 1 000 výstupných tokenov (centy)"
            }
        },
        "procurement": {
            "title": "Požiadavky na kúpu nájomcu",
            "delete_title": "Odstrániť požiadavku na nákup",
            "result_found": "Stretnutie",
            "delete_result_found": "Odstrániť prístupy",
            "start_date": "Dátum začiatku",
            "end_date": "Datované",
            "range_separator": "bis",
            "confirm_delete_msg": "Naozaj chcete natrvalo odstrániť vybraté požiadavky z databázy?",
            "confirm_delete_title": "Odstrániť požiadavku na nákup",
            "confirm_delete_btn": "Odstrániť"
        },
        "invoice": {
            "title": "Faktúry nájomníkov",
            "delete_title": "Vymazať faktúry",
            "result_found": "Stretnutie",
            "delete_result_found": "Odstrániť prístupy",
            "start_date": "Dátum začiatku",
            "end_date": "Datované",
            "range_separator": "bis",
            "confirm_delete_msg": "Naozaj chcete natrvalo odstrániť vybraté faktúry z databázy?",
            "confirm_delete_title": "Vymazať faktúru",
            "confirm_delete_btn": "Odstrániť"
        },
        "feature_usage": {
            "title": "Feature usage by tenant",
            "empty_state": "No tracked feature usage was found for the selected period.",
            "not_available": "n/a",
            "unknown_tenant": "Unknown tenant",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "summary": {
                "total_usage": "Tracked usage",
                "active_tenants": "Active tenants",
                "used_features": "Used features",
                "avg_usage_per_tenant": "Avg. usage per tenant",
                "top_feature": "Top feature",
                "of_active_base": "of active base",
                "top_feature_hint": "{usage} tracked uses across {tenants} tenants"
            },
            "charts": {
                "top_features": "Top features",
                "top_features_subtitle": "Most demanded features in the selected period.",
                "daily_trend": "Daily trend",
                "daily_trend_subtitle": "Tracked usage volume per day.",
                "procurement_sources": "Procurement sourcing",
                "procurement_sources_subtitle": "How products enter procurement lines in the selected period.",
                "punchout_providers": "Punchout providers",
                "punchout_providers_subtitle": "Marketplace usage by imported Punchout products.",
                "daily_usage_label": "Usage"
            },
            "procurement_sources": {
                "punchout": "Punchout",
                "catalog": "Product catalog",
                "on_the_fly": "On-the-fly",
                "unknown_punchout": "Unknown punchout"
            },
            "errors": {
                "schema_missing": "Feature usage tracking is not available in this environment yet. Apply the Hasura migration and metadata for tenant_feature_usage and reload the page.",
                "load_failed": "Feature usage could not be loaded."
            },
            "tables": {
                "features": "Feature ranking",
                "features_subtitle": "Demand by feature across the active tenant base.",
                "tenants": "Tenant ranking",
                "tenants_subtitle": "Most active tenants and their dominant features.",
                "modules": "Module overview",
                "modules_subtitle": "Consolidated demand by catalog module."
            },
            "columns": {
                "feature": "Feature",
                "module": "Module",
                "total_usage": "Usage",
                "active_tenants": "Tenants",
                "avg_per_tenant": "Avg./tenant",
                "event_breakdown": "Events",
                "top_tenant": "Top tenant",
                "last_used": "Last usage",
                "tenant": "Tenant",
                "used_features": "Features",
                "top_feature": "Top feature"
            }
        },
        "mcp_usage": {
            "title": "MCP usage",
            "empty_state": "No MCP usage was found for the selected period.",
            "no_errors": "No MCP errors were found for the selected period.",
            "not_available": "n/a",
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "unknown_tenant": "Unknown tenant",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "summary": {
                "total_calls": "MCP calls",
                "active_tenants": "Active tenants",
                "active_users": "Active users",
                "success_rate": "Success rate",
                "error_calls_suffix": "calls with errors",
                "quality_score": "Quality score",
                "quality_score_hint": "Inferred from tool outcomes, warnings and result quality.",
                "answer_completion": "Inferred completion",
                "empty_results_suffix": "empty results",
                "avg_duration": "Avg. duration",
                "paginated_calls": "Paginated calls",
                "quality_signals_suffix": "quality signals",
                "session_feedback": "Session feedback",
                "session_feedback_hint": "Anonymized product insights from MCP conversations."
            },
            "charts": {
                "daily_trend": "Daily trend",
                "daily_trend_subtitle": "MCP calls per day in the selected period.",
                "top_tools": "Top tools",
                "top_tools_subtitle": "Most used MCP tools.",
                "outcomes": "Outcomes",
                "outcomes_subtitle": "Successful, blocked and failed calls.",
                "answer_quality": "Answer quality",
                "answer_quality_subtitle": "Inferred completeness of responses without storing prompts or answers.",
                "entities": "Entities",
                "entities_subtitle": "Business objects touched through MCP.",
                "calls_label": "Calls"
            },
            "tables": {
                "tools": "Tool ranking",
                "tools_subtitle": "Usage, success rate and average duration by tool.",
                "tenants": "Tenant ranking",
                "tenants_subtitle": "Tenants with the highest MCP activity.",
                "quality": "Quality focus",
                "quality_subtitle": "Tools with empty results, warnings, ignored filters or low inferred quality.",
                "answer_reasons": "Answer reasons",
                "answer_reasons_subtitle": "Why answers were complete, partial, blocked or unknown.",
                "errors": "Error focus",
                "errors_subtitle": "Sanitized error categories without prompts or payloads.",
                "session_feedback": "Session feedback",
                "session_feedback_subtitle": "Short anonymized AI notes about routing issues, gaps and suspected bugs."
            },
            "columns": {
                "tool": "Tool",
                "category": "Category",
                "answer_outcome": "Answer",
                "reason": "Reason",
                "calls": "Calls",
                "success_rate": "Success",
                "quality_score": "Quality",
                "empty_results": "Empty",
                "warnings": "Warnings",
                "ignored_filters": "Ignored filters",
                "avg_duration": "Avg. duration",
                "tenant": "Tenant",
                "users": "Users",
                "top_tool": "Top tool",
                "last_used": "Last usage",
                "error": "Error",
                "when": "Kedy",
                "feedback_category": "Kategória",
                "severity": "Závažnosť",
                "summary": "Poznámky",
                "related_tools": "Nástroje",
                "related_entities": "Entity"
            },
            "outcomes": {
                "success": "Success",
                "error": "Error",
                "permission_denied": "Permission denied",
                "rate_limited": "Rate limited",
                "validation_error": "Validation error",
                "timeout": "Timeout",
                "authentication_error": "Authentication error",
                "unknown": "Unknown"
            },
            "answer_outcomes": {
                "complete": "Complete",
                "partial": "Partial",
                "blocked": "Blocked",
                "empty_result": "Empty result",
                "low_confidence": "Low confidence",
                "unknown": "Unknown"
            },
            "feedback_reasons": {
                "success": "Successful",
                "no_data": "No data",
                "authentication_error": "Authentication",
                "permission_denied": "Permission denied",
                "rate_limited": "Rate limited",
                "timeout": "Timeout",
                "validation_error": "Validation error",
                "ambiguous_master_data": "Ambiguous master data",
                "paginated_result": "Paginated results",
                "tool_error": "Tool error",
                "low_confidence": "Low confidence",
                "not_supported": "Not supported",
                "filters_ignored": "Ignored filters",
                "warnings": "Warnings",
                "unknown": "Not specified"
            },
            "entities": {
                "none": "General",
                "bcase": "Workflow",
                "invoice": "Incoming invoices",
                "outgoing_invoice": "Outgoing invoices",
                "procurement": "Purchase orders",
                "contract": "Contracts",
                "bank_statement_entry": "Bank statement entries"
            },
            "no_session_feedback": "No session feedback was found for the selected period.",
            "session_feedback_categories": {
                "bug_suspicion": "Bug suspicion",
                "missing_capability": "Missing capability",
                "wrong_routing": "Wrong routing",
                "data_quality": "Data quality",
                "ux_friction": "UX friction",
                "feature_request": "Feature request",
                "positive_signal": "Positive signal",
                "unknown": "Unknown"
            },
            "session_feedback_severities": {
                "low": "Low",
                "medium": "Medium",
                "high": "High",
                "unknown": "Unknown"
            },
            "no_quality_issues": "No MCP quality signals were found for the selected period.",
            "errors": {
                "schema_missing": "MCP usage analytics is not available in this environment yet. Apply the Hasura migration and metadata for mcp_usage_event and reload the page.",
                "load_failed": "MCP usage could not be loaded."
            }
        },
        "ai_llm": {
            "title": "AI/LLM Monitor",
            "empty_state": "No LLM calls available for the selected period.",
            "no_errors": "No LLM failures in the selected period.",
            "unknown_tenant": "Unknown tenant",
            "unknown_region": "Unknown Azure endpoint",
            "unknown_operation": "Unknown operation",
            "unknown_model": "Unknown model",
            "filters": {
                "tenant_placeholder": "Filter by tenant",
                "operation_placeholder": "Filter by operation",
                "model_placeholder": "Filter by model",
                "status_placeholder": "Filter by status"
            },
            "shortcuts": {
                "this_month": "This month",
                "last_month": "Last month",
                "last_7_days": "Last 7 days",
                "last_30_days": "Last 30 days"
            },
            "summary": {
                "total_calls": "LLM calls",
                "total_calls_hint": "Central Azure OpenAI calls recorded by the backend.",
                "success_rate": "Success rate",
                "succeeded_suffix": "successful calls",
                "fallbacks": "Fallbacks used",
                "fallbacks_hint": "Successful calls that reached a secondary region.",
                "failures": "Failures",
                "rejected_suffix": "non-regional rejections",
                "system_status": "System status",
                "tokens": "Tokens",
                "tokens_hint": "{input} input / {output} output",
                "estimated_cost": "Estimated cost",
                "estimated_cost_hint": "Shown when token price configuration is available."
            },
            "health_states": {
                "unknown": "No data",
                "unknown_hint": "No calls were recorded for the selected filters.",
                "normal": "Normal",
                "normal_hint": "LLM calls are succeeding within the selected period.",
                "degraded": "Degraded",
                "degraded_hint": "Failures or fallback usage need attention.",
                "unavailable": "Unavailable",
                "unavailable_hint": "No successful LLM calls were recorded."
            },
            "alerts": {
                "unavailable_title": "LLM appears unavailable",
                "unavailable_description": "All recorded calls failed or were blocked for the selected period.",
                "failure_rate_high_title": "High LLM failure rate",
                "failure_rate_high_description": "The selected scope has a failure rate of {rate}.",
                "failure_rate_warning_title": "Elevated LLM failure rate",
                "failure_rate_warning_description": "The selected scope has a failure rate of {rate}.",
                "fallbacks_title": "Fallbacks were used",
                "fallbacks_description": "{count} successful call(s) required a secondary Azure endpoint."
            },
            "healthcheck": {
                "action": "Run healthcheck",
                "title": "Manual healthcheck",
                "subtitle": "Live Azure OpenAI endpoint test triggered by an operator.",
                "success": "At least one Azure endpoint responded successfully.",
                "warning": "No Azure endpoint responded successfully.",
                "error": "The LLM healthcheck could not be completed.",
                "no_endpoints_title": "No Azure endpoints were tested",
                "no_endpoints_description": "Check that endpoint, api-key and deployment are configured for Azure OpenAI.",
                "all_ok_title": "All Azure endpoints are reachable",
                "all_ok_description": "{count} Azure endpoint(s) responded successfully.",
                "partial_title": "Some Azure endpoints are reachable",
                "partial_description": "{succeeded} of {total} Azure endpoint(s) responded successfully. Check the per-endpoint error details.",
                "none_ok_title": "No Azure endpoint responded successfully",
                "none_ok_description": "The endpoint can be correct while the API key, deployment name or permissions do not match at least one Azure OpenAI resource."
            },
            "charts": {
                "region_health": "Azure endpoint health",
                "region_health_subtitle": "Successful and failed Azure OpenAI calls by endpoint and operation.",
                "daily_failures": "Failures over time",
                "daily_failures_subtitle": "Failed, rejected and circuit-open calls per day.",
                "failures_label": "Failures"
            },
            "tables": {
                "regions": "Azure endpoints and operations",
                "regions_subtitle": "Aggregated health by Azure OpenAI endpoint, operation and model.",
                "latest_errors": "Latest errors",
                "latest_errors_subtitle": "Recent failed or rejected LLM calls for operational triage."
            },
            "columns": {
                "created_at": "Time",
                "tenant": "Tenant",
                "region": "Region",
                "azure_endpoint": "Azure endpoint",
                "operation": "Operation",
                "model": "Model",
                "calls": "Calls",
                "successes": "Successes",
                "failures": "Failures",
                "failure_rate": "Failure rate",
                "avg_duration": "Avg. duration",
                "status": "Status",
                "http_status": "HTTP",
                "retries": "Retries",
                "duration": "Duration",
                "error": "Error"
            },
            "statuses": {
                "succeeded": "Succeeded",
                "failed": "Failed",
                "rejected": "Rejected",
                "circuit_open": "Region blocked"
            },
            "units": {
                "milliseconds": "{value} ms",
                "seconds": "{value} s"
            },
            "errors": {
                "schema_missing": "LLM call logging is not available in this environment yet. Apply the Hasura migration and metadata for ai_llm_call_log and reload the page.",
                "load_failed": "LLM dashboard data could not be loaded."
            }
        },
        "invoice_recognition": {
            "title": "Invoice Recognition – Monitor",
            "empty_state": "No data available for the selected period.",
            "no_switchovers": "No region switchovers were required in the selected period.",
            "no_in_flight": "No recognitions are currently in the queue.",
            "unknown_tenant": "Unknown tenant",
            "processing_active": "Processing",
            "processing_idle": "Waiting",
            "copy_success": "Copied to clipboard.",
            "copy_failed": "Could not copy.",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "shortcuts": {
                "this_month": "This month",
                "last_month": "Last month",
                "last_7_days": "Last 7 days",
                "last_30_days": "Last 30 days"
            },
            "summary": {
                "invoices_processed": "Invoices processed",
                "invoices_processed_hint": "{attempts} attempts in total",
                "successful": "Recognized successfully",
                "switchovers": "Region switchovers",
                "switchovers_hint": "Invoices that needed at least one region switch (relevant for MS refund).",
                "failed": "Finally failed",
                "failed_hint": "Invoices without a successful recognition (handed over to manual review).",
                "in_flight": "Currently in flight",
                "in_flight_hint": "Invoices currently waiting in the recognition queue."
            },
            "charts": {
                "region_status": "Attempts per region",
                "region_status_subtitle": "Distribution of recognition attempts by region and status.",
                "daily_failures": "Failures over time",
                "daily_failures_subtitle": "Failed attempts per day in the selected period.",
                "failures_label": "Failures"
            },
            "tables": {
                "switchovers": "Invoices with region switchover",
                "switchovers_subtitle": "Invoices that switched at least once to another region. Expand a row to see the full attempt trail incl. provider operation IDs (evidence for MS refund cases).",
                "region_health": "Region health",
                "region_health_subtitle": "Current health of each Azure AI region in the selected period.",
                "in_flight": "In-flight recognitions",
                "in_flight_subtitle": "Invoices currently waiting in the queue for a response."
            },
            "columns": {
                "tenant": "Tenant",
                "invoice_id": "Invoice ID",
                "region_path": "Region path",
                "attempt_count": "Attempts",
                "final_status": "Final status",
                "last_attempt": "Last attempt",
                "operation_id": "Operation ID",
                "region": "Region / model",
                "total_attempts": "Attempts",
                "successes": "Successes",
                "failures": "Failures",
                "failure_rate": "Failure rate",
                "last_failure": "Last failure",
                "poll_attempts": "Polls",
                "elapsed": "Elapsed",
                "processing": "Status"
            },
            "statuses": {
                "submitted": "Submitted",
                "succeeded": "Succeeded",
                "failed": "Failed",
                "timed_out": "Timed out",
                "submission_failed": "Submission failed",
                "circuit_open": "Region blocked"
            },
            "models": {
                "document_intelligence": "Document Intelligence",
                "content_understanding": "Content Understanding",
                "azure_open_ai": "Azure OpenAI"
            },
            "errors": {
                "load_failed": "Could not load data."
            },
            "tabs": {
                "operations": "Prevádzka",
                "quality": "Kvalita",
                "approval_quality": "Kvalita schvaľovania"
            },
            "approval_quality": {
                "scope_manual": "Ručne skontrolované",
                "scope_auto": "Automaticky postúpené",
                "scope_all": "Všetky rozhodnutia",
                "methodology": "Predvolene sa porovnávajú všetky rozhodnutia AI o schválení — vrátane automaticky postúpených. Schválené = účtovníctvo, export alebo dokončené; zrušené = zamietnuté alebo exportované zrušenie. Prebiehajúce a technicky nevyhodnotiteľné rozhodnutia sa do mier kvality nezapočítavajú.",
                "invoices_evaluated": "Vyhodnotené doklady",
                "invoices_evaluated_hint": "{decided} rozhodnutí, z toho {pending} prebieha a {unavailable} nemožno technicky vyhodnotiť",
                "false_approval_rate": "Miera chybných schválení",
                "false_approval_rate_hint": "{falseApprovals} z {aiApprovals} schválení navrhnutých AI bolo neskôr zrušených.",
                "approval_precision": "Správne schválenia AI",
                "approval_precision_hint": "Podiel schválení navrhnutých AI, ktoré zostali vo finálnom výsledku schválené.",
                "missed_automation_rate": "Nevyužitá automatizácia",
                "missed_automation_rate_hint": "{missed} z {approved} finálne schválených dokladov AI neschválila.",
                "agreement_rate": "Zhoda",
                "agreement_rate_hint": "Podiel uzavretých prípadov, v ktorých sa rozhodnutie AI zhoduje s finálnym výsledkom.",
                "matrix_title": "Rozhodnutie AI oproti finálnemu výsledku",
                "matrix_subtitle": "Len uzavreté a technicky vyhodnotiteľné rozhodnutia vo vybranom období.",
                "actual_approved": "Finálne schválené",
                "actual_cancelled": "Finálne zrušené",
                "ai_approved": "AI by schválila",
                "ai_rejected": "AI by neschválila",
                "correct": "Správne",
                "false_approval": "Chybné schválenie",
                "missed_automation": "Nevyužitá automatizácia",
                "false_approvals_title": "Detail chybných schválení",
                "false_approvals_subtitle": "Až 80 dokladov, ktoré by AI schválila, ale ktoré boli nakoniec zrušené.",
                "empty_state": "Vo vybranom období neboli nájdené žiadne chybné schválenia.",
                "load_failed": "Údaje o kvalite schvaľovania sa nepodarilo načítať.",
                "number": "Číslo faktúry",
                "score": "Skóre AI",
                "threshold": "Prah",
                "reasons": "Rozhodujúce signály",
                "final_status": "Finálny stav",
                "auto_forwarded": "Automaticky",
                "decided_at": "Rozhodnutie AI",
                "yes": "Áno",
                "no": "Nie"
            },
            "quality": {
                "scope_all": "Všetky doklady",
                "scope_manual": "Manuálne skontrolované",
                "scope_auto": "Automaticky odoslané KI",
                "methodology": "Porovnanie: snímka po rozpoznaní dokladu a KI validácii s aktuálnym dokladom. Zmenené pole = nesprávne rozpoznanie.",
                "invoices_evaluated": "Hodnotené doklady",
                "invoices_evaluated_hint": "{manual} manuálne skontrolované, {auto} automaticky odoslané",
                "mean_field_rate": "Aritmetický priemer",
                "mean_field_rate_hint": "Priemerná úspešnosť rozpoznania vo všetkých poliach.",
                "median_field_rate": "Medián",
                "median_field_rate_hint": "Úspešnosť prostredného poľa, menej ovplyvnená odľahlými hodnotami.",
                "mean_receipt_score": "Priemer na doklad",
                "median_receipt_score_hint": "Medián na doklad: {median}",
                "field_chart_title": "Úspešnosť podľa poľa",
                "field_chart_subtitle": "Podiel dokladov, pri ktorých pole po rozpoznaní ostalo nezmenené.",
                "groups_title": "Skupiny polí",
                "groups_subtitle": "Vážená úspešnosť podľa skupiny (iba hodnotené polia).",
                "fields_title": "Polia podrobne",
                "fields_subtitle": "Nezmenené = správne rozpoznané. Prázdne polia na oboch stranách sa nezapočítavajú.",
                "invoices_title": "Doklady s najnižšou úspešnosťou",
                "invoices_subtitle": "80 dokladov s najslabšou zhodou vo zvolenom období. Riadok rozbaľte pre zmenené polia.",
                "empty_state": "Pre toto obdobie zatiaľ nie sú k dispozícii žiadne snímky. Meranie začína pri novo rozpoznaných dokladoch po tomto vydaní.",
                "load_failed": "Údaje o kvalite sa nepodarilo načítať.",
                "field": "Pole",
                "group": "Skupina",
                "evaluated": "Hodnotené",
                "matched": "Nezmenené",
                "rate": "Úspešnosť",
                "number": "Číslo faktúry",
                "receipt_score": "Skóre dokladu",
                "fields_short": "Polia",
                "auto_forwarded": "Automaticky",
                "auto_yes": "Áno",
                "auto_no": "Nie",
                "baseline_at": "Snímka",
                "baseline": "Po rozpoznaní",
                "final_value": "Aktuálne",
                "no_mismatches": "Žiadne zmenené polia.",
                "groups": {
                    "document": "Údaje dokladu",
                    "bank": "Bankové údaje",
                    "matching": "Priradenie",
                    "organization": "Organizácia",
                    "lines": "Položky"
                }
            }
        },
        "feature_billing": {
            "title": "Feature monetization",
            "sync": "Sync catalog",
            "new_package": "New package",
            "create_package": "Create package",
            "edit_package": "Edit package",
            "sync_success": "Feature catalog synchronized.",
            "catalog_hint": "This area monetizes existing modules, features and packages without changing the current runtime behavior of the system.",
            "overview_title": "Overview & metrics",
            "show_overview": "Show metrics",
            "hide_overview": "Hide metrics",
            "edit_feature": "Edit monetization",
            "manage_tenants": "Manage tenants",
            "assign_tenant": "Assign tenant",
            "manage_package_tenants": "Manage package tenants",
            "assign_package": "Assign package",
            "assignment_dialog_title": "Tenant feature assignment",
            "package_assignment_dialog_title": "Tenant package assignment",
            "custom_price_hint": "Leave empty to use the feature default price.",
            "not_configured": "Not configured",
            "no_assignments": "No tenant assignment found.",
            "unassigned_module": "Without module",
            "unassigned_module_description": "Features that are monetized independently from any specific module.",
            "package_features_label": "Included features",
            "package_feature_hint": "Select the features that belong to this package.",
            "package_code_placeholder": "stable-package-code",
            "package_code_hint": "Generated automatically from the package name.",
            "catalog_inactive": "Catalog inactive",
            "billing_enabled": "Monetization enabled",
            "billing_disabled": "Monetization disabled",
            "tabs": {
                "features": "Features",
                "packages": "Packages",
                "tenants": "Tenants",
                "ai_automation": "AI automation"
            },
            "summary": {
                "modules": "Modules",
                "features": "Features",
                "packages": "Packages",
                "direct_assignments": "Direct assignments",
                "package_assignments": "Package assignments",
                "active_assignments": "Active assignments",
                "trial_assignments": "Trial assignments"
            },
            "sections": {
                "package_assignments": "Package assignments",
                "direct_feature_assignments": "Direct feature assignments"
            },
            "columns": {
                "module": "Module",
                "feature": "Feature",
                "package": "Package",
                "code": "Code",
                "description": "Description",
                "catalog_status": "Catalog status",
                "billing_type": "Billing type",
                "default_price": "Default price",
                "default_demo_days": "Demo days",
                "pricing": "Pricing",
                "coverage": "Coverage",
                "composition": "Composition",
                "assignments": "Assignments",
                "direct_assignments": "Direct",
                "covered_tenants": "Covered tenants",
                "packages": "Packages",
                "included_features": "Included features",
                "references": "System reference",
                "tenant": "Tenant",
                "status": "Status",
                "effective_price": "Effective price",
                "custom_price": "Custom price",
                "demo_until": "Demo until",
                "active_features": "Active",
                "active_packages": "Packages",
                "trial_features": "Trial",
                "total_assignments": "Total"
            },
            "ai_automation": {
                "title": "AI automation by client and supplier",
                "description": "Evaluates AI-validated invoices by whether they reached export without relevant manual corrections.",
                "details_title": "Monthly evaluation",
                "empty_title": "No AI automation data yet",
                "empty_text": "After the migration is applied and AI-validated invoices have been exported, the evaluation will be filled.",
                "unknown_tenant": "Unknown tenant",
                "unknown_client": "Unknown client",
                "unknown_supplier": "Unknown supplier",
                "no_client": "No client",
                "no_supplier": "No supplier",
                "detail_title": "Invoice details",
                "actions": {
                    "details": "Details"
                },
                "summary": {
                    "total_invoices": "Invoices",
                    "ai_validated": "AI validated",
                    "one_click_export": "One-click export",
                    "best_case": "Best case",
                    "automation_value": "Automation value",
                    "manual_corrections": "Manual corrections"
                },
                "columns": {
                    "company": "Company",
                    "client_supplier": "Client / supplier",
                    "period": "Period",
                    "supplier": "Supplier",
                    "billing_tier": "Billing tier",
                    "ai_validated": "AI validated",
                    "email_imported": "Email",
                    "auto_export": "Auto export",
                    "exported": "Exported",
                    "one_click": "One-click",
                    "best_case": "Best case",
                    "manual_corrections": "Manual corrections"
                },
                "column_help": {
                    "tenant": "Tenant or customer account to which this monthly KPI row belongs.",
                    "client_supplier": "Combination of client and supplier for the invoices counted in this row.",
                    "period": "Calendar month and year covered by this evaluation row.",
                    "billing_tier": "Derived monetization tier based on the measured automation score for this row.",
                    "ai_validated": "How many invoices were AI-validated out of all invoices in the row. The note shows how many came from email import.",
                    "auto_export": "Invoices automatically forwarded toward export. The note shows how many were ultimately exported successfully.",
                    "one_click": "Invoices that reached export with a one-click confirmation after AI validation.",
                    "best_case": "Invoices with the highest automation level, typically email-imported and exported with one click and no relevant manual correction.",
                    "manual_corrections": "Invoices that still required relevant manual changes after AI processing. The note breaks down the correction types.",
                    "actions": "Opens the invoice-level detail view for the selected monthly row."
                },
                "detail_columns": {
                    "invoice": "Invoice",
                    "automation": "Automation",
                    "ki": "AI",
                    "export": "Export",
                    "corrections": "Corrections",
                    "result": "Result"
                },
                "boolean": {
                    "yes": "Yes",
                    "no": "No"
                },
                "labels": {
                    "email": "Email",
                    "validated": "Validated",
                    "auto_forwarded": "Auto export",
                    "one_click": "One-click",
                    "best_case": "Best case",
                    "not_exported": "Not exported"
                },
                "automation_levels": {
                    "unknown": "Unknown",
                    "no_ai": "No AI",
                    "ai_not_validated": "Not validated",
                    "manual_correction": "Manual correction",
                    "ki_validated_waiting": "AI validated",
                    "ki_autonomous_to_export_ready": "Prepared for export",
                    "one_click_export": "One-click export",
                    "email_import_one_click_export": "Email one-click export"
                },
                "billing_tiers": {
                    "premium": "Premium",
                    "advanced": "Advanced",
                    "automation": "Automation",
                    "assist": "Assist",
                    "base": "Base"
                },
                "billing_tier_legend": {
                    "title": "Billing tier guide",
                    "items": {
                        "base": "Little measurable automation value in this row.",
                        "assist": "AI assists the process, but manual work still dominates.",
                        "automation": "Meaningful automation gains; several invoices are export-ready with limited manual effort.",
                        "advanced": "High automation level with only occasional manual intervention.",
                        "premium": "Very high automation level; most invoices run nearly touchless."
                    }
                },
                "correction_types": {
                    "values": "Values",
                    "bank": "Bank",
                    "organization": "Organization",
                    "other": "Other",
                    "note_only": "Note only",
                    "none": "No relevant correction"
                }
            },
            "billing_types": {
                "monthly": "Monthly",
                "yearly": "Yearly",
                "one_time": "One-time",
                "usage": "Usage-based",
                "included": "Included"
            },
            "assignment_statuses": {
                "active": "Active",
                "trial": "Trial",
                "inactive": "Inactive"
            },
            "validation": {
                "package_name_required": "Please enter a package name.",
                "package_code_required": "Please enter a valid package code.",
                "package_features_required": "Please select at least one feature for the package."
            }
        }
    },
    "timeline": {
        "title": "Timeline",
        "preferences": {
            "order_asc": "Najprv najstarší",
            "order_desc": "Najnovšie ako prvé",
            "comment_notifications": "E-mailové upozornenia na komentáre",
            "comment_notifications_enabled": "Upozornenia na komentáre zapnuté.",
            "comment_notifications_disabled": "Upozornenia na komentáre vypnuté."
        },
        "text": {
            "description_assignment": "Úloha bola prijatá.",
            "cancellation": {
                "name": "{name}",
                "description_past_successful_invoice": "Faktúra bola vyradená a archivovaná.",
                "description_past_successful_outgoing-invoice": "Odoslaná faktúra bola zrušená a archivovaná.",
                "description_past_successful_procurement": "Objednávka bola zrušená a archivovaná.",
                "description_past_successful_contract": "Zmluva bola zrušená a archivovaná.",
                "name_procurement": "Zrušenie",
                "name_contract": "Zrušenie",
                "name_outgoing-invoice": "Zrušenie",
                "name_invoice": "Vyradenie"
            },
            "start": {
                "name": "Nová požiadavka na nákup",
                "description_past_successful": "Bola vytvorená nová požiadavka na nákup."
            },
            "select-product": {
                "is_searchable": true,
                "simple_name": "Výber produktu",
                "name": "Výber produktu (úroveň {index})",
                "description_past_unsuccessful": "Výber produktu bol zrušený.",
                "description_past_successful": "Produkty pre túto objednávku boli vybraté.",
                "description_present": "Vyberte produkty pre túto objednávku.",
                "description_future": "Je potrebné vybrať produkty pre túto objednávku."
            },
            "approval": {
                "is_searchable": true,
                "simple_name": "Uvoľniť požiadavku na nákup",
                "name": "Uvoľniť požiadavku na nákup (úroveň {index})",
                "description_past_unsuccessful": "Uvoľnenie objednávky bolo zrušené.",
                "description_past_successful": "Žiadosť o nákup bola skontrolovaná a uvoľnená.",
                "description_present": "Prosím skontrolujte a schváľte žiadosť o objednávku.",
                "description_future": "Žiadosť o nákup musí byť skontrolovaná a schválená."
            },
            "send-order": {
                "is_searchable": true,
                "name": "Zadanie objednávky",
                "description_past_unsuccessful": "Objednávka s doručovacou spoločnosťou bola zrušená.",
                "description_past_successful": "Objednávka bola odoslaná doručovacej spoločnosti.",
                "description_present": "Objednávajte prosím od doručovacej spoločnosti.",
                "description_future": "Objednávku je potrebné zadať doručovacej spoločnosti."
            },
            "delivery": {
                "is_searchable": true,
                "name": "Potvrdenie o doručení",
                "description_past_unsuccessful": "Potvrdenie o prijatí tovaru bolo zrušené.",
                "description_past_successful": "Tovar bol doručený a prevzatie tovaru bolo potvrdené.",
                "description_present": "Potvrďte prosím prevzatie tovaru.",
                "description_future": "Prevzatie tovaru je potrebné potvrdiť."
            },
            "reassignment": {
                "name": "pridelenie",
                "description_past_unsuccessful": "",
                "description_past_successful": "pridelil úlohu používateľovi {name}.",
                "description_past_successful_from_group": "prijal úlohu."
            },
            "clearing": {
                "is_searchable": true,
                "name": "objasnenie",
                "description_past_unsuccessful": "Objasňovanie bolo prerušené.",
                "description_past_successful": "Prípadné nejasnosti v objednávke boli objasnené.",
                "description_present": "Prosím o upresnenie objednávky.",
                "description_finished_unsuccessful": "Objednávka bola zrušená a archivovaná."
            },
            "order-sent-internal": {
                "name": "Systémová správa",
                "description_past_successful": "Objednávka <b>({first_product_name})</b> od doručovacej spoločnosti <b>{supplier}</b> bola potvrdená."
            },
            "order-sent-punchout": {
                "name": "Systémová správa",
                "description_past_successful": "Objednávka <b>({first_product_name})</b> bola odoslaná elektronicky doručovacej spoločnosti <b>{supplier}</b>."
            },
            "product-received": {
                "name": "Systémová správa",
                "description_past_successful": "<b>{quantity} {unit}</b> eingegangen:<p>{product}</p><span style=\"color:#9a9898\">{supplier}</span>"
            },
            "invoice-upload": {
                "name": "Nový účet",
                "description_past_successful": "Faktúra bola nahraná."
            },
            "invoice-recognition": {
                "is_searchable": true,
                "name": "Rozpoznávanie faktúr",
                "description_past_unsuccessful": "Rozpoznanie údajov faktúry bolo zrušené.",
                "description_past_successful": "Rozpoznanie údajov faktúry bolo dokončené.",
                "description_present": "Údaje o faktúre sa načítavajú. Tento proces môže trvať až jednu minútu. Obnovte stránku po tomto čase, aby ste videli výsledky."
            },
            "invoice-manual-check": {
                "is_searchable": true,
                "name": "Manuálna kontrola",
                "description_past_unsuccessful": "Manuálna kontrola nebola dokončená.",
                "description_past_successful": "Faktúra bola skontrolovaná ručne.",
                "description_present": "Skontrolujte fakturačné údaje.",
                "description_future": "Faktúru je potrebné skontrolovať manuálne."
            },
            "invoice-financial-approval": {
                "is_searchable": true,
                "simple_name": "Schválenie faktúry",
                "name": "Schválenie faktúry (Úroveň {index})",
                "description_past_unsuccessful": "Schválenie faktúry bolo zrušené.",
                "description_past_successful": "Faktúra bola skontrolovaná a schválená.",
                "description_present": "Prosím, skontrolujte a schváľte faktúru.",
                "description_future": "Faktúra musí byť skontrolovaná a schválená."
            },
            "invoice-clearing": {
                "is_searchable": true,
                "name": "Objasnenie účtovníctva",
                "description_past_unsuccessful": "Objasňovanie bolo prerušené.",
                "description_past_successful": "Prípadné nejasnosti v návrhu zákona boli objasnené.",
                "description_present": "Prosím o vysvetlenie faktúry.",
                "description_finished_unsuccessful": "Faktúra bola vyplatená a archivovaná."
            },
            "invoice-export": {
                "is_searchable": true,
                "name": "Export",
                "description_past_unsuccessful": "Faktúra nebola exportovaná.",
                "description_past_successful": "Faktúra bola odoslaná spoločnosti {export_name}.",
                "description_present": "Faktúra je pripravená na export.",
                "description_future": "Faktúra je pripravená na export."
            },
            "invoice-accounting": {
                "is_searchable": true,
                "name": "Účtovníctvo",
                "description_past_unsuccessful": "Účtovníctvo bolo zrušené.",
                "description_past_successful": "Účtovníctvo bolo overené.",
                "description_present": "Prosím skontrolujte účtovníctvo.",
                "description_future": "Účtovníctvo treba overiť."
            },
            "invoice-verified": {
                "is_searchable": true,
                "name": "Overené",
                "description_past_unsuccessful": "Overenie bolo zrušené.",
                "description_past_successful": "Faktúra bola overená.",
                "description_present": "Faktúra bude overená.",
                "description_future": "Faktúra bude overená."
            },
            "skip": {
                "name": "zrušenie",
                "description_past_successful": "prerušil krok."
            },
            "contract-start": {
                "name": "Nová zmluva",
                "description_past_successful": "Zmluva bola vytvorená."
            },
            "contract-recognition": {
                "is_searchable": true,
                "name": "Rozpoznanie zmluvy",
                "description_past_successful": "Údaje zmluvy boli rozpoznané.",
                "description_present": "Údaje zmluvy sa rozpoznávajú."
            },
            "contract-check": {
                "is_searchable": true,
                "name": "Kontrola zmluvy",
                "description_past_unsuccessful": "Kontrola nebola dokončená.",
                "description_past_successful": "Zmluva bola skontrolovaná.",
                "description_present": "Prosím, skontrolujte údaje zmluvy."
            },
            "contract-signing": {
                "is_searchable": true,
                "name": "Podpis zmluvy",
                "description_past_unsuccessful": "Zmluva nebola podpísaná.",
                "description_past_successful": "Zmluva bola podpísaná.",
                "description_present": "Prosím, podpíšte zmluvu.",
                "description_future": "Zmluva musí byť podpísaná."
            },
            "contract-clearing": {
                "is_searchable": true,
                "name": "Vyjasnenie zmluvy",
                "description_past_unsuccessful": "Vyjasnenie bolo zrušené.",
                "description_past_successful": "Nejasnosti v zmluve boli vyriešené.",
                "description_present": "Prosím, vyjasnite zmluvu.",
                "description_finished_unsuccessful": "Zmluva bola zrušená a archivovaná."
            }
        }
    },
    "jexcel": {
        "noRecordsFound": "Nenašli sa žiadne záznamy.",
        "showingPage": "Strana {0} z {1}",
        "show": "Šou",
        "entries": "Príspevky",
        "insertANewColumnBefore": "Vložte stĺpec pred neho",
        "insertANewColumnAfter": "Potom vložte stĺpec",
        "deleteSelectedColumns": "Odstrániť vybraté stĺpce",
        "renameThisColumn": "Premenovať stĺpec",
        "orderAscending": "Zoradiť vzostupne",
        "orderDescending": "Zoradiť zostupne",
        "insertANewRowBefore": "Vložte riadok predtým",
        "insertANewRowAfter": "Potom vložte riadok",
        "deleteSelectedRows": "Odstrániť vybraté riadky",
        "copy": "Kopírovať",
        "paste": "Vložiť",
        "saveAs": "Uložiť ako",
        "about": "Koniec",
        "areYouSureToDeleteTheSelectedRows": "Naozaj chcete odstrániť vybraté riadky?",
        "areYouSureToDeleteTheSelectedColumns": "Naozaj chcete odstrániť vybraté stĺpce?",
        "thisActionWillDestroyAnyExistingMergedCellsAreYouSure": "Táto akcia zničí všetky existujúce zlúčené bunky. Si si istý?",
        "thisActionWillClearYourSearchResultsAreYouSure": "Táto akcia vymaže výsledky vyhľadávania. Si si istý?",
        "thereIsAConflictWithAnotherMergedCell": "Došlo ku konfliktu s inou zlúčenou bunkou",
        "invalidMergeProperties": "Neplatné zlúčené vlastníctva",
        "cellAlreadyMerged": "Bunka je už zlúčená",
        "noCellsSelected": "Nie sú vybraté žiadne bunky",
        "save_warning": "Kopírovanie údajov medzi Excelom a webom môže viesť k nesprávnym poradím a stratám ID vzťahov. <br>Prosím, používajte iba online úpravu alebo pridajte údaje z Excelu ako doplnok."
    },
    "system_comment": {
        "name": {
            "allocation": "Pridelenie",
            "datev_export": "Export DATEV",
            "export_error": "Chyba pri exportovaní",
            "export_detail": "Exportný protokol",
            "repeat_recognition": "Zopakovať rozpoznanie faktúry",
            "bank_data_export_summary": "Platobný spôsob",
            "payment": "Platba podľa bankového výpisu",
            "bank_statement_payment": "Platba podľa bankového výpisu",
            "contract-termination-email": "Pripomenutie výpovede zmluvy",
            "ai_validation": "Validácia AI"
        },
        "contract_termination_email_sent": "E-mail s pripomenutím výpovede bol odoslaný príjemcovi {recipient}.",
        "contract_termination_email_failed": "E-mail s pripomenutím výpovede sa nepodarilo odoslať príjemcovi {recipient}. Chyba: {error}.",
        "ai_validation_trusted": "Faktúra bola overená umelou inteligenciou a považovaná za dôveryhodnú.",
        "ai_validation_not_trusted": "Faktúra bola overená umelou inteligenciou a postúpená na manuálnu kontrolu.",
        "invoice_approval_restart": "Schvaľovací proces faktúry bol reštartovaný. Dôvod: {reason}",
        "recognition_was_repeated": "{user_name} zopakoval/a rozpoznanie dokladu.",
        "attach_new_invoice_to_procurement": "Faktúra <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bola priradená k tejto požiadavke na nákup od <b>{user_name}</b>.",
        "attach_new_invoice_to_bcase": "Faktúra <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bola priradená k tomuto dokladu používateľom <b>{user_name}</b>.",
        "change_bcase_of_invoice": "Priradenie faktúry <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bolo odstránené. <br>Faktúra bola priradená k dokladu {link_to_bcase}.",
        "detach_bcase_of_invoice": "Priradenie faktúry <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bolo odstránené.",
        "attach_new_invoice_to_procurement_without_supplier": "Faktúru <b>{link_to_invoice}</b> priradil k tejto nákupnej požiadavke používateľ <b>{user_name}</b>.",
        "change_procurement_of_invoice": "Priradenie faktúry <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bolo opäť odstránené. <br>Faktúra bola priradená k požiadavke na nákup {link_to_procurement}.",
        "change_procurement_of_invoice_without_supplier": "Priradenie faktúry <b>{link_to_invoice}</b> bolo opäť odstránené. <br>Faktúra bola priradená k požiadavke na nákup {link_to_procurement}.",
        "detach_procurement_of_invoice": "Priradenie faktúry <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bolo opäť odstránené.",
        "detach_procurement_of_invoice_without_supplier": "Priradenie faktúry <b>{link_to_invoice}</b> bolo opäť odstránené.",
        "attach_external_invoice_to_procurement": "Faktúra {invoice_number} od <b>{supplier_name}</b> bola priradená k tejto nákupnej požiadavke od <b>{invoice_by}</b>.",
        "insert_datev_note": "Faktúra <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bola odoslaná online spoločnostiam DATEV.",
        "insert_datev_note_without_supplier": "Faktúra <b>{link_to_invoice}</b> bola odoslaná online spoločnostiam DATEV.",
        "on_ms365_export_error_generic": "Chyba pri exporte faktúry do D365. Kontaktujte podporu.",
        "on_ms365_export_validation_error": "Chyba pri exporte faktúry do D365. Kontaktujte podporu. Chyba: {error}",
        "on_export_error": "Faktúru nebolo možné odoslať spoločnostiam DATEV online. {error}",
        "on_export_error_generic": "Chyba pri exporte faktúry do DATEV. Kontaktujte podporu.",
        "on_export_error_validation": "{supplier_external_id_export_validation}{supplier_name_export_validation} Ak chcete skontrolovať konfiguráciu, kontaktujte osobu s oprávneniami správcu.",
        "on_export_error_datev_access_is_not_active": "Musí byť vytvorené pripojenie k DATEV. Kontaktujte niekoho s oprávneniami správcu.",
        "on_export_error_client_has_no_datev_access": "Spoločnosť {client_name} neposkytla žiadne prístupové údaje DATEV. Kontaktujte niekoho s oprávneniami správcu.",
        "on_export_error_client_has_no_datev_permission": "Pri prenose do DATEV sa vyskytla chyba. Prístup DATEV, ktorý bol nastavený, nemá autorizáciu pre spoločnosť {client_name}. Ak chcete skontrolovať prístup alebo nakonfigurované spoločnosti alebo oprávnenia v rámci DATEV, kontaktujte osobu s právami správcu.",
        "on_export_error_datev_has_protocol_entries": "Chyba pri exporte faktúry do DATEV. Skontrolujte exportný protokol alebo kontaktujte podporu.",
        "on_export_error_no_fiscal_year": "Pri prenose do DATEV sa vyskytla chyba. Dátum faktúry nie je vo finančnom roku DATEV. Ak chcete skontrolovať fiškálny rok v DATEV, kontaktujte osobu s právami správcu.",
        "on_export_error_invoice_not_active_for_fiscal_year": "Pri prenose do DATEV sa vyskytla chyba. Finančný rok DATEV nie je uvoľnený na prenos došlých faktúr. Ak chcete skontrolovať fiškálny rok v DATEV, kontaktujte osobu s právami správcu.",
        "on_export_error_running": "Export zablokovaný: Iná inštancia už tento proces vykonáva.",
        "on_export_error_outgoing_invoice_not_supported": "Odchádzajúce faktúry nie je možné exportovať. Workflow končí overením.",
        "on_export_error_document_discount_tax_required": "Zľavu dokladu nie je možné exportovať, pretože chýba sadzba DPH alebo nezodpovedá žiadnej položke faktúry. Vyberte sadzbu DPH zľavy.",
        "on_export_error_document_discount_exceeds_base": "Zľava dokladu je vyššia ako čistý základ zodpovedajúcich položiek a nie je možné ju exportovať.",
        "on_export_error_document_discount_invalid": "Zľavu dokladu nie je možné exportovať. Skontrolujte sumu, základ a sadzbu DPH.",
        "insert_datev_protocol_note": "<b>Stav</b>: {status} <br><br> <b>Protokolleinträge</b>: <br> {protocol}",
        "labels": {
            "ai_validation_trusted_label": "Faktúra bola overená KI a považuje sa za dôveryhodnú.",
            "ai_validation_not_trusted_label": "Faktúra bola overená KI a postúpená na manuálnu kontrolu.",
            "ai_validation_trusted_score_only_label": "Faktúra bola KI klasifikovaná ako dôveryhodná. {score_block}",
            "ai_validation_not_trusted_score_only_label": "Faktúra bola postúpená na manuálnu kontrolu. {score_block}",
            "ai_validation_not_trusted_insufficient_positive_label": "Faktúra bola postúpená na manuálnu kontrolu. {score_block} Pozitívne signály nestačili: {ai_validation_reason_value}.",
            "ai_validation_trusted_reasons_label": "Faktúra bola KI klasifikovaná ako dôveryhodná. {score_block} Rozhodujúce boli navyše: {ai_validation_reason_value}.",
            "ai_validation_not_trusted_reasons_label": "Faktúra bola postúpená na manuálnu kontrolu. {score_block} Rozhodujúce boli: {ai_validation_reason_value}.",
            "ai_validation_score_block_risk_passed": "Z pozitívnych a negatívnych signálov KI vypočítala celkové riziko {score} — to zodpovedá {score_level} úrovni rizika. Pre automatické schválenie musí byť toto riziko pod {threshold}; táto hranica je splnená.",
            "ai_validation_score_block_risk_failed": "Z pozitívnych a negatívnych signálov KI vypočítala celkové riziko {score} — to zodpovedá {score_level} úrovni rizika. Pre automatické schválenie musí byť toto riziko pod {threshold}; táto hodnota je nad hranicou.",
            "ai_validation_score_block_confidence_passed": "Z overených signálov KI vypočítala hodnotu istoty {score} — to zodpovedá {score_level} úrovni. Pre automatické schválenie musí byť táto hodnota aspoň {threshold}; táto požiadavka je splnená.",
            "ai_validation_score_block_confidence_failed": "Z overených signálov KI vypočítala hodnotu istoty {score} — to zodpovedá {score_level} úrovni. Pre automatické schválenie musí byť táto hodnota aspoň {threshold}; dosiahnutá hodnota nestačí.",
            "ai_validation_score_block_green_sum_passed": "Z pozitívnych signálov KI vypočítala súčet {score} — to zodpovedá {score_level} úrovni. Pre automatické schválenie musí byť táto hodnota aspoň {threshold}; táto požiadavka je splnená.",
            "ai_validation_score_block_green_sum_failed": "Z pozitívnych signálov KI vypočítala súčet {score} — to zodpovedá {score_level} úrovni. Pre automatické schválenie musí byť táto hodnota aspoň {threshold}; dosiahnutá hodnota nestačí.",
            "ai_validation_score_level_risk_very_low": "veľmi nízkej",
            "ai_validation_score_level_risk_low": "nízkej",
            "ai_validation_score_level_risk_acceptable": "akceptovateľnej",
            "ai_validation_score_level_risk_elevated": "zvýšenej",
            "ai_validation_score_level_risk_high": "vysokej",
            "ai_validation_score_level_confidence_very_low": "veľmi nízkej",
            "ai_validation_score_level_confidence_low": "nízkej",
            "ai_validation_score_level_confidence_moderate": "strednej",
            "ai_validation_score_level_confidence_high": "vysokej",
            "ai_validation_score_level_confidence_very_high": "veľmi vysokej",
            "ai_validation_score_level_green_sum_very_low": "veľmi nízkej",
            "ai_validation_score_level_green_sum_low": "nízkej",
            "ai_validation_score_level_green_sum_moderate": "strednej",
            "ai_validation_score_level_green_sum_high": "vysokej",
            "ai_validation_score_level_green_sum_very_high": "veľmi vysokej",
            "ai_validation_risk_compensated_label": "Zistené riziká ({ai_validation_secondary_reason_value}) boli vyvážené pozitívnymi signálmi.",
            "ai_validation_positive_signals_label": "Pozitívne signály ({ai_validation_secondary_reason_value}) nestačili na vyváženie rizík.",
            "ai_validation_reason_and": "a",
            "ai_validation_reason_GREEN_01": "povinné polia sú kompletné",
            "ai_validation_reason_GREEN_02": "faktúra zodpovedá doterajšiemu vzoru tohto dodávateľa",
            "ai_validation_reason_GREEN_03": "e-mail odosielateľa je známy a zodpovedá kmeňovým údajom",
            "ai_validation_reason_GREEN_04": "sumy pôsobia voči plneniu vierohodne",
            "ai_validation_reason_GREEN_05": "obdobie plnenia je jasné a bez prekrytia",
            "ai_validation_reason_GREEN_06": "bankové údaje zodpovedajú uloženým kmeňovým údajom",
            "ai_validation_reason_RED_01": "e-mail odosielateľa sa líši od známych adries",
            "ai_validation_reason_RED_02": "obdobie plnenia sa prekrýva s existujúcimi faktúrami",
            "ai_validation_reason_RED_03": "suma alebo inherentné riziko je nezvyčajne vysoké",
            "ai_validation_reason_RED_04": "suma oproti skorším faktúram výrazne vzrástla",
            "ai_validation_reason_RED_05": "objednávka/zmluva chýba alebo sa výrazne odchyľuje",
            "ai_validation_reason_RED_06": "bankové údaje sa líšia od kmeňových údajov",
            "ai_validation_failed": "Faktúra nebola overená.",
            "ai_validation_duplicate_invoice_label": "Validácia AI nepokračovala, pretože bola nájdená duplicitná faktúra. Faktúra bola postúpená na manuálnu kontrolu.",
            "ai_validation_mandatory_fields_missing_label": "Validácia AI zlyhala: Chýbajú nasledujúce povinné polia",
            "ai_validation_client_address_mismatch_label": "Validácia AI nepokračovala, pretože rozpoznaná fakturačná adresa sa líši od kmeňových údajov spoločnosti. Faktúra bola postúpená na manuálnu kontrolu.",
            "ai_validation_client_address_unrecognized_label": "Validácia AI nepokračovala, pretože na faktúre nebola nájdená dostatočne rozpoznateľná fakturačná adresa. Faktúra bola postúpená na manuálnu kontrolu.",
            "magic_suggestions_label": "Automaticky vyplnené polia",
            "magic_suggestions_intro_label": "Tu sú polia, ktoré boli automaticky vyplnené na základe predchádzajúcich dokladov od tohto dodávateľa:",
            "ledger_account_label": "Účet hlavnej knihy",
            "cost_center_label": "Nákladové stredisko",
            "department_label": "Oddelenie",
            "cost_type_label": "Typ nákladov",
            "incoming_revenue_type_label": "Typ príjmu",
            "posting_key_label": "Kľúč účtovania",
            "tax_group_label": "Skupina DPH",
            "tax_item_group_label": "Skupina DPH položky",
            "d365_branch_label": "Pobočka",
            "d365_employee_label": "Zamestnanec",
            "d365_department_label": "D365 Oddelenie",
            "d365_area_label": "D365 Oblasť",
            "d365_sales_channel_label": "D365 Predajný kanál",
            "d365_vehicle_label": "Vozidlo",
            "d365_project_label": "D365 Projekt",
            "supplier_iban_label": "IBAN",
            "supplier_bic_label": "BIC",
            "supplier_bank_country_label": "Krajina banky",
            "supplier_bank_account_label": "Číslo účtu",
            "supplier_bank_code_label": "Smerové číslo banky",
            "supplier_payment_method_label": "Spôsob platby",
            "invoice_number_label": "Číslo faktúry",
            "duplicate_invoice_reference_label": "Duplicitná faktúra",
            "procurement_number_label": "Číslo objednávky",
            "invoice_date_label": "Dátum faktúry",
            "invoice_due_date_label": "Dátum splatnosti",
            "supplier_label": "Dodávateľ",
            "client_label": "Spoločnosť",
            "business_partner_label": "Obchodný partner",
            "total_netto_label": "Celková netto",
            "total_brutto_label": "Celkom s DPH",
            "tax_label": "Sadzba dane",
            "positions_count_label": "pozície",
            "recognition_applied_data_label": "Prevzaté alebo odvodené systémom liftbase",
            "contract_recognition_result_label": "Rozpoznané údaje zmluvy",
            "contract_name_label": "Názov zmluvy",
            "contract_number_label": "Číslo zmluvy",
            "contract_external_number_label": "Externé číslo zmluvy",
            "contract_date_label": "Dátum zmluvy",
            "contract_supplier_label": "Dodávateľ",
            "contract_client_label": "Spoločnosť",
            "contract_category_label": "Kategória",
            "contract_payment_method_label": "Spôsob platby",
            "contract_payment_direction_label": "Smer",
            "contract_payment_timing_label": "Načasovanie platby",
            "contract_term_type_label": "Typ doby trvania",
            "contract_start_date_label": "Začiatok zmluvy",
            "contract_end_date_label": "Koniec zmluvy",
            "contract_duration_label": "Doba trvania zmluvy",
            "contract_renewal_type_label": "Typ predĺženia",
            "contract_renewal_duration_label": "Doba predĺženia",
            "contract_notice_period_label": "Výpovedná lehota",
            "contract_termination_to_label": "Dátum ukončenia",
            "contract_total_net_label": "Celkom netto",
            "contract_total_gross_label": "Celkom brutto",
            "contract_currency_label": "Mena",
            "contract_positions_label": "Položky",
            "origin_field_client_id": "Spoločnosť",
            "origin_field_supplier_id": "Dodávateľ",
            "origin_field_business_partner_id": "Obchodný partner",
            "origin_field_procurement_id": "Objednávka",
            "origin_field_ledger_account_id": "Účet hlavnej knihy",
            "origin_field_cost_center_id": "Nákladové stredisko",
            "origin_field_profit_center_id": "Profit centrum",
            "origin_field_department_id": "Oddelenie",
            "origin_field_posting_key_id": "Účtovací kľúč",
            "origin_field_branch_id": "Pobočka",
            "origin_field_employee_id": "Zamestnanec",
            "origin_field_d365_area_id": "Oblasť",
            "origin_field_d365_department_id": "D365 oddelenie",
            "origin_field_d365_labor_wert_id": "Pracovná hodnota",
            "origin_field_d365_project_id": "Projekt",
            "origin_field_d365_sales_channel_id": "Predajný kanál",
            "origin_field_d365_vehicle_id": "Vozidlo",
            "origin_field_number": "Číslo faktúry",
            "origin_field_total_netto": "Celkom netto",
            "origin_field_total_brutto": "Celkom s DPH",
            "origin_field_invoice_date": "Dátum faktúry",
            "origin_field_due_date": "Dátum splatnosti",
            "origin_field_delivery_date": "Dátum dodania",
            "origin_field_currency": "Mena",
            "origin_field_tax": "Sadzba dane",
            "origin_field_contract_id": "Zmluva",
            "origin_field_cost_type_id": "Druh nákladu",
            "origin_field_incoming_revenue_type_id": "Druh výnosu",
            "origin_field_discount_percentage": "Skonto 1 %",
            "origin_field_discount_amount": "Skonto 1 suma",
            "origin_field_discount_days": "Skonto 1 dni",
            "origin_field_discount_payment_date": "Skonto 1 dátum",
            "origin_field_discount_percentage2": "Skonto 2 %",
            "origin_field_discount_amount2": "Skonto 2 suma",
            "origin_field_discount_days2": "Skonto 2 dni",
            "origin_field_discount_payment_date2": "Skonto 2 dátum",
            "origin_field_lines": "Položky",
            "origin_field_recognized_client_id": "Rozpoznaná spoločnosť",
            "origin_field_recognized_supplier_id": "Rozpoznaný dodávateľ",
            "origin_field_recognized_business_partner_id": "Rozpoznaný obchodný partner",
            "origin_field_supplier_iban": "IBAN dodávateľa",
            "origin_field_supplier_bic": "BIC dodávateľa",
            "origin_field_payment_bank_form_source": "Zdroj bankových údajov",
            "origin_reason_document_extracted": "extrahované priamo z dokladu",
            "origin_reason_from_procurement": "skopírované z priradenej objednávky",
            "origin_reason_from_supplier_master_data": "skopírované z kmeňových údajov dodávateľa",
            "origin_reason_from_business_partner_master_data": "skopírované z kmeňových údajov obchodného partnera",
            "origin_reason_invoice_number_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_total_netto_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_total_brutto_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_invoice_date_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_due_date_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_delivery_date_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_document_discount_amount_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_document_discount_base_amount_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_document_discount_percentage_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_document_discount_tax_percentage_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_client_matched_by_receiver_name_or_vat": "priradené podľa rozpoznaného názvu príjemcu alebo DIČ",
            "origin_reason_client_matched_by_supplier_name_or_vat": "priradené podľa rozpoznaného názvu vystaviteľa alebo DIČ",
            "origin_reason_client_from_creator_profile": "prevzaté z profilu nahrávateľa",
            "origin_reason_client_from_procurement": "skopírované z priradenej objednávky",
            "origin_reason_supplier_matched_by_name_vat_or_iban": "priradené podľa rozpoznaného názvu dodávateľa, DIČ alebo IBAN",
            "origin_reason_business_partner_matched_by_name_vat_or_iban": "priradené podľa rozpoznaného názvu protistrany, DIČ alebo IBAN",
            "origin_reason_business_partner_matched_by_receiver_name_or_vat": "priradené podľa rozpoznaného názvu príjemcu alebo DIČ",
            "origin_reason_supplier_from_single_procurement_supplier": "prevzaté z jediného dodávateľa priradenej objednávky",
            "origin_reason_procurement_matched_by_recognized_reference": "priradené podľa rozpoznanej referencie objednávky",
            "origin_reason_procurement_matched_by_invoice_similarity": "priradené podľa podobnosti sumy, dátumu a položiek",
            "origin_reason_procurement_matched_by_invoice_similarity_without_supplier": "priradené podľa podobnosti sumy, dátumu a položiek pred výberom dodávateľa",
            "origin_reason_ledger_account_from_procurement": "skopírované z priradenej objednávky",
            "origin_reason_cost_center_from_procurement": "skopírované z priradenej objednávky",
            "origin_reason_cost_type_from_procurement": "skopírované z priradenej objednávky",
            "origin_reason_profit_center_from_supplier_master_data": "skopírované z kmeňových údajov dodávateľa",
            "origin_reason_profit_center_from_business_partner_master_data": "skopírované z kmeňových údajov obchodného partnera",
            "origin_reason_department_from_procurement": "skopírované z priradenej objednávky",
            "origin_reason_branch_from_procurement": "skopírované z priradenej objednávky",
            "origin_reason_employee_from_procurement": "skopírované z priradenej objednávky",
            "origin_reason_financial_dimension_from_procurement": "skopírované z priradenej objednávky",
            "origin_reason_ledger_account_from_supplier_master_data": "skopírované z kmeňových údajov dodávateľa",
            "origin_reason_cost_center_from_supplier_master_data": "skopírované z kmeňových údajov dodávateľa",
            "origin_reason_ledger_account_from_business_partner_master_data": "skopírované z kmeňových údajov obchodného partnera",
            "origin_reason_cost_center_from_business_partner_master_data": "skopírované z kmeňových údajov obchodného partnera",
            "origin_reason_posting_key_from_recognized_tax": "odvodené z rozpoznanej sadzby dane",
            "origin_reason_supplier_iban_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_supplier_bic_extracted_from_document": "extrahované priamo z dokladu",
            "origin_reason_payment_bank_data_extracted_from_document": "nastavené podľa rozpoznaných bankových údajov z dokladu",
            "no_data_read_label": "Nezistili sa žiadne údaje.",
            "supplier_external_id_export_validation": "Externé ID doručovacej spoločnosti musí byť vopred nakonfigurované.",
            "supplier_name_export_validation": "Názov doručovacej spoločnosti musí byť vopred nakonfigurovaný.",
            "recognition_was_repeated": "{user_name} zopakoval/a rozpoznanie dokladu.",
            "bankdata_recognized_label": "Bankové spojenie rozpoznané z dokladu",
            "bankdata_form_source_label": "Bankové spojenie vo formulári – zdroj",
            "bankdata_form_changed_label": "Bankové spojenie vo formulári – zmenené",
            "bankdata_matches_masterdata_label": "Bankové spojenie vo formulári sa zhoduje s kmeňovými údajmi",
            "bankdata_written_back_label": "Nové bankové spojenie zapísané do kmeňových údajov",
            "bank_statement_auto_paid_label": "Faktúra bola automaticky označená ako uhradená na základe analýzy bankového výpisu.",
            "payment_date_label": "Dátum platby",
            "payment_amount_label": "Suma",
            "bank_statement_document_label": "Bankový výpis",
            "bank_statement_reference_label": "Účel platby",
            "bank_statement_match_reason_label": "Dôvod priradenia",
            "bank_statement_match_reason_payment_reference": "Platobná referencia",
            "bank_statement_match_reason_invoice_number": "Číslo faktúry",
            "bank_statement_match_reason_invoice_number_formatted": "Interné číslo faktúry",
            "bank_statement_match_reason_procurement_number": "Číslo objednávky",
            "bank_statement_match_reason_supplier_iban": "IBAN dodávateľa",
            "bank_statement_match_reason_supplier_name": "Dodávateľ",
            "contract_id": "Zmluva",
            "termination_deadline": "Termín výpovede",
            "recipient": "Príjemca",
            "error": "Chyba"
        }
    },
    "login": {
        "email": {
            "title": "Prihlasenie",
            "instructions": "Zadajte svoju e-mailovu adresu pre prihlasenie.",
            "punchin_instructions": "Na dokončenie procesu sa musíte prihlásiť a spustiť proces schvaľovania objednávky.",
            "tenant": "Nájomca",
            "place_holder": "Emailová adresa",
            "last_used_emails": "Naposledy použité e-mailové adresy",
            "delete_last_used_emails": "Vymažte „Nedávno použité“.",
            "has_no_account": "Ešte nemáte prístup?",
            "login_link_via_email": "Prihlasovací odkaz prijatý e-mailom",
            "finish_login_title": "Dokončite prihlásenie",
            "finish_login_instructions": "Teraz dostanete e-mail s prihlasovacím odkazom a kódom. Prihlásenie dokončíte kliknutím na odkaz alebo zadaním šesťmiestneho kódu. <br><br>Prihlasovací e-mail bol odoslaný na adresu <br><b>{email}</b><br> a mal by prísť v krátkom čase. V prípade potreby skontrolujte priečinok so spamom.",
            "code_instructions": "Prípadne zadajte šesťmiestny kód z e-mailu:",
            "code_label": "Prihlasovací kód",
            "code_digit_label": "Znak {index} kódu",
            "code_invalid": "Kód je nesprávny, vypršal alebo už bol použitý. Vyžiadajte si nový prihlasovací e-mail.",
            "resend_code": "Odoslať nový prihlasovací e-mail",
            "forgot_passwort": {
                "title": "Zabudol si heslo",
                "login_via_email": "Prihlasenie bez hesla",
                "instructions": "liftbase nepouziva hesla. Pokracujte cez SSO alebo prihlasovaci odkaz e-mailom, alebo pouzite samostatne tlacidlo passkey."
            },
            "no_email": "Žiadny e-mail",
            "no_email_validation": "Pre prihlásenie zadajte svoju e-mailovú adresu.",
            "check_email_title": "Skontrolujte e-mail",
            "check_email_message": "Skontrolujte si teraz svoju e-mailovú schránku a kliknite na prihlasovací odkaz alebo zadajte kód."
        },
        "integration": {
            "title": "Pripájanie integrácie",
            "instructions": "liftbase dokončuje autorizáciu. O chvíľu budete presmerovaní.",
            "retry": "Pripojenie sa nepodarilo pokračovať. Skúste to znova.",
            "retry_button": "Pripojiť znova"
        },
        "auto": {
            "login": "Prihlasit sa",
            "passkey_retry": "Prihlasenie cez passkey zlyhalo. Mozete znova pouzit tlacidlo passkey alebo pokracovat cez SSO alebo e-mail.",
            "status": {
                "discover": "Kontrolujem dostupne metody prihlasenia...",
                "passkey": "Skusam prihlasenie cez passkey...",
                "saml": "Skusam prihlasenie cez {provider}...",
                "email": "Odosielam prihlasovací odkaz a kód e-mailom...",
                "code": "Overujem prihlasovací kód..."
            }
        },
        "or": "alebo",
        "saml": {
            "login": "Pokračovať cez {provider}",
            "error": "SSO prihlásenie zlyhalo. Skúste to znova.",
            "error_expired": "SSO relácia vypršala. Spustite prihlásenie znova.",
            "error_mismatch": "SSO účet sa nezhoduje so zadaným e-mailom."
        },
        "passkey": {
            "title": "Prihláste sa pomocou prístupového kľúča",
            "login": "Prihláste sa pomocou prístupového kľúča",
            "what_is": {
                "title": "Čo sú prístupové kľúče?",
                "first": "Prihláste sa bez čakania na e-mail",
                "second": "Pomocou odtlačku prsta, tváre alebo kódu PIN",
                "third": "Nastavte si ho vo svojom profile hneď v niekoľkých krokoch"
            },
            "error": "Prihlasenie cez passkey zlyhalo. Skuste znova tlacidlo passkey alebo pokracujte cez SSO alebo e-mail."
        }
    },
    "languages": {
        "de": "Deutsch",
        "en": "Angličtina",
        "it": "taliansky",
        "cz": "český",
        "sk": "slovenský"
    },
    "translation-component": {
        "repeated": "Nemôžete vybrať rovnaký jazyk viackrát.",
        "language_empty": "Musíte vybrať jazyk.",
        "translation_empty": "Musíte zadať text pre tento vybraný jazyk.",
        "both_empty": "Musíte zadať aj jazyk, aj text.",
        "language": "Jazyk",
        "no_translation": "Pre tento jazyk nie je zaregistrovaný žiadny text.",
        "at_least_one_required": "Musíte uviesť aspoň jedno meno.",
        "text_without_translation": "Bez prekladu"
    },
    "mailbox": {
        "invoice_lines_group_by_tax": "Zoskupiť položky podľa sadzby dane",
        "invoice_lines_group_by_tax_hint": "Ak je zapnuté, rozpoznané položky sa zoskupia podľa sadzby dane (napr.: Súčet 19 % dane).",
        "ai_validation_mode": "Validácia KI",
        "ai_validation_mode_none": "Bez validácie KI",
        "ai_skip_to_ready_for_export": "Aktivovať a presunúť do stavu „Pripravené na export“",
        "ai_skip_to_ready_for_export_hint": "Ak je táto funkcia aktivovaná, faktúra sa po rozpoznaní umelou inteligenciou presunie priamo do stavu „Pripravené na export“, ak nie sú potrebné žiadne schvaľovacie kroky.",
        "ai_validation_advisory": "Aktivovať a ponechať stav bez zmeny",
        "ai_validation_advisory_hint": "Ak je aktivované, importované faktúry overí KI, výsledok sa zapíše do časovej osi a zobrazia sa detaily skóre bez preskočenia bežného workflow.",
        "description": "P.O. Box",
        "description_plural": "Poštové schránky",
        "name": "Názov poštovej schránky",
        "username": "Emailová adresa",
        "password": "heslo",
        "host": "Hostiteľ",
        "port": "Port",
        "smtp_host": "SMTP host",
        "smtp_port": "SMTP port",
        "smtp_username": "SMTP e-mail / používateľské meno",
        "smtp_password": "SMTP heslo",
        "tab_general": "Všeobecné",
        "tab_import": "Import faktúr",
        "tab_supplier_communication": "Komunikácia s dodávateľom",
        "section_identity": "Schránka a protokol",
        "section_assignment": "Priradenie",
        "section_incoming": "Prístup k schránke",
        "section_processing": "Spracovanie",
        "section_outgoing": "Odosielanie",
        "protocol": "Protokol",
        "ms365": "Microsoft 365",
        "ms365_type": "Typ Microsoft 365",
        "ms365_enterprise_app": "MS365 Enterprise App",
        "app_tenant_id": "Tenant ID",
        "app_client_id": "Client ID",
        "client_secret": "Client Secret",
        "folder": "Priečinok",
        "mailbox": "Poštová schránka",
        "period_in_days": "Obdobie v dňoch",
        "period_in_days_column": "Obdobie (dni)",
        "period_in_days_tooltip": "Vek e-mailov v dňoch",
        "remove_mailbox_msg": "Naozaj chcete odstrániť poštovú schránku?",
        "remove_mailbox_btn": "Odstrániť",
        "import_invoices_automatically": "Import faktúr je aktívny",
        "use_for_supplier_communication": "Komunikácia s dodávateľom aktívna",
        "use_for_supplier_communication_hint": "Ak je zapnuté, táto schránka sa použije na spracovanie odpovedí z komunikácie s dodávateľmi.",
        "supplier_communication_bcase_types": "Typy dokumentov pre komunikáciu s dodávateľom",
        "supplier_communication_bcase_types_hint": "Vyberte typy dokumentov, pre ktoré sa môže táto schránka použiť v komunikácii s dodávateľom.",
        "supplier_communication_bcase_types_placeholder": "Vyberte jeden alebo viac typov dokumentov",
        "import_mode": "Režim importu",
        "import_mode_per_attachment": "Vytvoriť jednu faktúru na každú prílohu e-mailu",
        "import_mode_ai_classified_per_attachment": "Importovať iba prílohy klasifikované AI ako faktúry",
        "import_mode_per_email": "Vytvoriť jednu faktúru na každý e-mail",
        "last_import_errors": "Posledné chyby importu",
        "show_import_errors": "Zobraziť {count} chýb",
        "no_import_errors": "Žiadne chyby importu",
        "check_connection_btn": "Otestujte pripojenie",
        "connectivity_success_msg": "Spojenie bolo úspešne nadviazané.",
        "connectivity_error_msg": "Spojenie sa nepodarilo nadviazať. Skontrolujte nastavenia.",
        "connectivity_graph_client_secret_read_access_denied_msg": "Microsoft Graph odmietol prístup k tejto poštovej schránke.<br><br>Skontrolujte v Azure, či:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>má Enterprise App potrebné Application Permissions:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b></li><li>bol udelený Admin Consent</li><li>má aplikácia povolený prístup k tejto schránke</li></ul>",
        "connectivity_graph_client_secret_access_denied_msg": "Microsoft Graph odmietol prístup k tejto poštovej schránke.<br><br>Skontrolujte v Azure, či:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>má Enterprise App potrebné Application Permissions:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b>, <b>Mail.Send</b></li><li>bol udelený Admin Consent</li><li>má aplikácia povolený prístup k tejto schránke</li></ul>",
        "connectivity_graph_access_denied_msg": "Microsoft Graph odmietol prístup k tejto poštovej schránke. Znova pripojte schránku a skontrolujte, či má používateľ k tejto schránke prístup.",
        "save_and_connect_btn": "Uložiť a pripojiť",
        "disconnect_btn": "odpojiť",
        "disconnect_success_msg": "Spojenie bolo úspešne odpojené."
    },
    "marketplace": {
        "description": "Trhovisko",
        "description_plural": "Trhoviská",
        "name": "Názov / Alias",
        "provider": "Poskytovateľ",
        "country_code": "Krajina",
        "url": "URL",
        "email": "E-mail",
        "order_url": "URL objednávky",
        "order_auth_type": "Overenie objednávky",
        "order_auth_type_none": "Žiadne",
        "order_auth_type_basic": "HTTP Basic Auth",
        "order_auth_username": "Používateľské meno",
        "order_auth_password": "Heslo",
        "identity": "Identita",
        "secret": "Tajomstvo",
        "section_configuration": "Konfigurácia trhoviska",
        "section_sender_identity": "Odosielateľ / Identita",
        "section_order_authentication": "Overenie objednávky",
        "new": "Nový trh",
        "amazon_more_clients_info": "V Liftbase je nakonfigurovaných viac spoločností. <br>Aby boli faktúry z Amazon Business priradené správnej firme, <br>postupujte podľa pokynov na <br><a href='https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen.' target='_blank'>https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen</a>."
    },
    "payment_options": {
        "label": "Spôsob platby dodávateľskej spoločnosti",
        "AUTOMATIC_DEBIT": "Prostredníctvom SEPA inkasa",
        "CREDIT_CARD": "Prostredníctvom kreditnej karty",
        "BANK_TRANSFER": "Prostredníctvom bankového prevodu (IBAN/BIC)",
        "BANK_TRANSFER_FOREIGN": "Zahraničný bankový prevod (číslo účtu/smerové číslo banky)",
        "ONLINE_PAYMENT": "Online platobné služby"
    },
    "errors": {
        "field_required": "Povinné pole vo formulári nebolo vyplnené.",
        "specific_field_required": "Pole {field} je povinné.",
        "invalid_type": "Zadaná hodnota je neplatná.",
        "specific_invalid_type": "Hodnota \"{value}\" nie je platná pre typ {type}.",
        "unique_violation": "Táto hodnota sa už používa.",
        "specific_unique_violation": "Záznam s touto hodnotou v poli {field} už existuje.",
        "foreign_key_violation": "Neplatný odkaz na iný záznam.",
        "specific_foreign_key_violation": "Hodnota v poli {field} nemohla byť priradená k existujúcemu záznamu.",
        "permission_denied": "Nemáš oprávnenie na vykonanie tejto akcie.",
        "check_violation": "Zadané údaje nespĺňajú systémové kritériá.",
        "specific_check_violation": "Hodnota v poli {field} nespĺňa definované pravidlá.",
        "value_too_long": "Hodnota presahuje povolenú dĺžku.",
        "specific_value_too_long": "Hodnota v poli {field} presahuje povolenú dĺžku.",
        "not_found": "Požadovaný zdroj sa nenašiel.",
        "already_exists": "Táto položka je už zaregistrovaná.",
        "validation_failed": "Overenie údajov zlyhalo.",
        "unexpected": "Nastala chyba. Skús to znova alebo kontaktuj podporu.",
        "specific_field_not_found": "Pole {field} nebolo nájdené v type {type}.",
        "expected_type_but_found": "Očakávalo sa {field} typu {type}, ale našiel sa {type_found}.",
        "duplicate_key_violation": "Poskytnutá hodnota už existuje a porušuje obmedzenie unikátneho kľúča {field}.",
        "unexpected_null_value_for_type": "Neočekávaná nulová hodnota pre typ {type}.",
        "timeline_changed": "Doklad bol upravený inou osobou. Stránka sa automaticky obnoví. Skontrolujte doklad znova.",
        "timeline_locked": "Doklad práve upravil {name}. Stránka bola automaticky obnovená. Skontrolujte doklad znova.",
        "save_bcase_error": "Pri ukladaní došlo k chybe.<br>Formulár nebolo možné uložiť.<br>Skontrolujte údaje a skúste to znova.<br>Ak problém pretrváva, kontaktujte podporu."
    },
    "onboarding": {
        "flow_option": "Konfigurácia",
        "custom_option": "Vybrať ukážkové dáta ručne",
        "custom_option_description": "Vyberte si konkrétne ukážkové dáta – ideálne na oboznámenie sa so systémom bez zadávania vlastných údajov.",
        "full_option": "Použiť úplné ukážkové dáta (odporúčané)",
        "full_option_description": "Použite úplnú konfiguráciu ukážkových dát a začnite systém ihneď používať – bez manuálneho nastavenia.",
        "none_option": "Začať bez ukážkových dát",
        "none_option_description": "Začnite s prázdnym prostredím a nakonfigurujte systém výlučne vlastnými údajmi.",
        "btn_start": "Začíname!",
        "btn_finish": "Spustiť!",
        "select_client": "Vyberte spoločnosti, s ktorými chcete pracovať.",
        "select_cost_center": "Vyberte nákladové strediská, s ktorými chcete pracovať.",
        "select_department": "Vyberte oddelenia, s ktorými chcete pracovať.",
        "select_ledger_account": "Vyberte hlavné účty, s ktorými chcete pracovať.",
        "select_posting_key": "Vyberte daňové kľúče, s ktorými chcete pracovať.",
        "select_supplier": "Vyberte dodávateľov, s ktorými chcete pracovať.",
        "select_product": "Vyberte produkty, s ktorými chcete pracovať.",
        "general_config": "Zadajte najdôležitejšie základné nastavenia.",
        "profile_config": "Zadajte dôležité profilové údaje – pre rýchlejšie procesy a jednoduchšie objednávky."
    },
    "contract": {
        "description": "Zmluva",
        "name": "Popis",
        "contract_date": "Dátum zmluvy",
        "contract_number_formatted": "ZM-číslo",
        "contract_number": "Číslo zmluvy",
        "category": "Kategória",
        "status": "Stav",
        "type": "Typ",
        "notes": "Poznámka",
        "payment_method": "Spôsob platby",
        "payment_direction": "Smer",
        "external_contract_number": "Externé číslo zmluvy",
        "responsible_id": "Zodpovedná osoba",
        "recurring_invoice": "Opakovaná faktúra",
        "start_date": "Dátum začiatku",
        "end_date": "Dátum ukončenia",
        "duration": "Doba trvania",
        "min_duration": "Minimálna doba trvania zmluvy",
        "duration_unit_type": "Jednotka doby trvania",
        "renewal_type": "Typ obnovenia",
        "renewal_duration": "Doba obnovenia",
        "renewal_duration_unit_type": "Jednotka obnovenia",
        "notice_period": "Výpovedná lehota",
        "notice_period_unit_type": "Jednotka výpovednej lehoty",
        "termination_special_right": "Špeciálne právo na ukončenie",
        "termination_deadline": "Termín ukončenia",
        "next_possible_contract_end": "Najbližší možný koniec zmluvy",
        "terminated_on": "Ukončené dňa",
        "termination_to": "Ukončenie k",
        "reminder_date": "Dátum pripomenutia",
        "reminder_duration": "Pripomenutie pred dátumom výpovede",
        "reminder_unit_type": "Časová jednotka pripomenutia výpovede",
        "term_type": "Typ trvania",
        "termination_to_options": {
            "none": "Žiadny",
            "day": "Deň",
            "year_end": "Koniec roka",
            "half_year_end": "Koniec polroka",
            "quarter_end": "Koniec štvrťroka",
            "month_end": "Koniec mesiaca",
            "week_end": "Koniec týždňa"
        },
        "duration_unit_type_options": {
            "month": "Mesiac(e)",
            "quarter": "Štvrťrok",
            "semester": "Polrok",
            "year": "Rok(y)",
            "week": "Týždeň(e)"
        },
        "renewal_type_options": {
            "auto": "Automaticky obnovené",
            "none": "Bez obnovenia",
            "once": "Jednorazové obnovenie",
            "manual": "Ručné obnovenie"
        },
        "payment_timing": "Typ platby",
        "payment_timing_options": {
            "advance": "Vopred",
            "postpaid": "Dodatočne",
            "midterm": "V polovici obdobia"
        },
        "usage_type": "Frekvencia použitia",
        "usage_type_options": {
            "usage_based": "Podľa použitia",
            "monthly": "Mesačne",
            "quarterly": "Štvrťročne",
            "semiannually": "Polročne",
            "yearly": "Ročne"
        },
        "category_options": {
            "service": "Služba",
            "subscription": "Predplatné",
            "license": "Licencia",
            "maintenance": "Údržba",
            "consulting": "Konzultácia",
            "leasing": "Leasing",
            "rental": "Prenájom",
            "support": "Podpora",
            "other": "Iné"
        },
        "term_type_options": {
            "fixed": "Na dobu určitú",
            "indefinite": "Na dobu neurčitú",
            "none": "Bez trvania"
        },
        "payment_direction_options": {
            "incoming": "Prichádzajúci",
            "outgoing": "Odchádzajúci",
            "both": "Oba smery"
        },
        "ai": {
            "back": "Späť",
            "add_title": "Nová zmluva",
            "add_subtitle": "Vyberte, ako chcete zmluvu vytvoriť.",
            "manual_title": "Zadať údaje zmluvy",
            "manual_description": "Vytvorte zmluvu ručne pomocou existujúceho formulára.",
            "ai_title": "Rozpoznať zmluvu pomocou AI",
            "ai_description": "Nahrajte PDF a skontrolujte extrahované údaje.",
            "disabled": "AI je pre tohto tenanta deaktivovaná.",
            "upload_title": "Rozpoznať zmluvu pomocou AI",
            "upload_subtitle": "Nahrajte jedno alebo viac PDF. Extrahované údaje sa zobrazia vedľa dokumentu na kontrolu.",
            "upload_info": "Presuňte sem PDF zmlúv alebo kliknutím vyberte súbory.",
            "upload_hint": "Iba PDF, maximálne 30 MB a 50 strán.",
            "file_invalid": "Podporované sú iba súbory PDF.",
            "file_too_large": "PDF nesmie byť väčšie ako 30 MB.",
            "file_size": "{size} MB",
            "select_file_preview": "Vyberte súbor, aby ste zobrazili jeho náhľad.",
            "start_recognition": "Odoslať zmluvy na rozpoznanie",
            "recognition_failed": "Zmluvu sa nepodarilo rozpoznať. Skúste to znova.",
            "document_review_hint": "Pred uložením skontrolujte extrahované polia.",
            "document_loading": "Načítava sa dokument…",
            "new_upload": "Nové nahranie",
            "document_preview_failed": "Ukážku dokumentu sa nepodarilo načítať. Rozpoznané údaje môžete napriek tomu skontrolovať a uložiť.",
            "client_review": "Dokument uvádza ako klienta „{client}“. Skontrolujte vybranú spoločnosť.",
            "persistence_failed": "Zmluva bola vytvorená, ale PDF a AI analýzu sa zatiaľ nepodarilo uložiť.",
            "retry_save": "Skúsiť uložiť znova"
        },
        "statuses": {
            "active": "Aktívna",
            "inactive": "Neaktívna",
            "declined": "Zrušená",
            "expired": "Platnosť vypršala",
            "pending": "Čakajúca",
            "recognition": "Rozpoznávanie",
            "completed": "Podpísaná",
            "check": "Kontrola",
            "clearing": "Vyjasnenie zmluvy"
        },
        "page": {
            "new": "Nová zmluva",
            "create_btn": "Vytvoriť zmluvu",
            "no_edit_permission": "Nemáte oprávnenie na úpravu údajov. Pošlite zmluvu na objasnenie, aby bolo možné vykonať zmeny.",
            "before_leave_msg": "Vaša zmluva nebola uložená. Naozaj chcete stránku opustiť?",
            "no_procurement": "Pre túto zmluvu neboli zaznamenané žiadne objednávky.",
            "no_invoice": "Pre túto zmluvu neboli zaznamenané žiadne faktúry.",
            "recognition_data_title": "Nespracované údaje rozpoznávania",
            "no_recognition_data": "Nezistili sa žiadne údaje.",
            "no_permission_create_contract": "Nemáte oprávnenie vytvoriť novú zmluvu.",
            "period": "Obdobie",
            "no_invoice_for_period": "Žiadne faktúry pre toto obdobie.",
            "confirm_before_leave_msg": "Vaša zmluva nebola uložená. Naozaj chcete opustiť stránku?",
            "reminder_tooltip": "V tento deň vám e-mailom pripomenieme túto zmluvu.",
            "tour": {
                "description": "",
                "save_btn": ""
            },
            "validation": {
                "client_id_required": "Vyberte spoločnosť.",
                "department_id_required": "Vyberte oddelenie.",
                "department_id_required_client_missing": "Najprv vyberte spoločnosť.",
                "cost_center_id_required": "Vyberte nákladové stredisko.",
                "cost_center_id_required_filters_missing": "Najprv vyberte spoločnosť a oddelenie.",
                "cost_center_id_required_department_missing": "Najprv vyberte oddelenie.",
                "cost_center_id_required_client_missing": "Najprv vyberte spoločnosť."
            }
        },
        "reminder_type": {
            "contract_end": "Koniec zmluvy",
            "cancellation_notice": "Výpovedná lehota",
            "invoice_missing": "Chýbajúca faktúra",
            "custom": "Vlastné"
        },
        "procurements": {
            "quantity_ordered": "Objednané",
            "quantity_received": "Prevzaté"
        },
        "documents": "Dokumenty"
    },
    "contract_line": {
        "title": "Položka zmluvy",
        "new_title": "Nová položka zmluvy",
        "name": "Popis",
        "type": "Typ",
        "type_options": {
            "service": "Služba",
            "product": "Produkt",
            "license": "Licencia",
            "maintenance": "Údržba",
            "subscription": "Predplatné",
            "other": "Ostatné"
        },
        "item_number": "Číslo položky",
        "quantity": "Množstvo",
        "total": "Celkom",
        "image_url": "URL obrázka",
        "webshop_url": "URL e-shopu",
        "offer_number": "Číslo ponuky",
        "offer_date": "Dátum ponuky",
        "usage_type": "Frekvencia použitia",
        "add_btn": "Pridať novú položku",
        "delete_btn": "Odstrániť položku zmluvy",
        "edit_btn": "Upraviť položku zmluvy",
        "confirm_before_delete_msg": "Naozaj chcete túto položku natrvalo odstrániť?",
        "confirm_before_delete_title": "Odstrániť položku",
        "confirm_before_delete_btn": "Odstrániť"
    },
    "contract_term": {
        "title": "Doba trvania zmluvy",
        "add_btn": "Pridať novú dobu trvania zmluvy",
        "delete_btn": "Odstrániť dobu trvania zmluvy",
        "edit_btn": "Upraviť dobu trvania zmluvy",
        "section_duration": "Doba trvania",
        "section_renewal": "Obnovenie",
        "section_termination": "Ukončenie",
        "section_reminder": "Pripomenutie",
        "section_term_type": "Typ trvania",
        "term_type_indefinite": "Zmluvy na dobu neurčitú nemajú obnovenie",
        "show_termination_fields_msg": "Obnovené zmluvy možno ukončiť na konci obdobia nasledovne.",
        "do_not_show_termination_fields_msg": "Zmluvy na dobu určitú majú pevný koniec a možno ich ukončiť skôr len so špeciálnym právom.",
        "no_termination_possible_msg": "Dosiahnutý koniec zmluvy, ukončenie nie je možné.",
        "no_renewal_msg": "Zmluvy na dobu neurčitú nemajú obnovenie"
    },
    "copy_contract_dialog": {
        "title": "Preniesť údaje",
        "title_select_contract": "Preniesť údaje zmluvy",
        "select_contract": "Vyberte zmluvu.",
        "message": "Chcete preniesť niektoré údaje zmluvy do tejto objednávky?",
        "overwrite_checkbox": "Prepísať existujúce údaje vo formulári.",
        "confirm_btn": "Potvrdiť"
    },
    "custom_field": {
        "description": "Vlastné pole",
        "label": "Popis",
        "type": "Typ poľa",
        "multilingual": "Viacjazyčné",
        "export_enabled": "Použiť na export",
        "export_field_name": "Názov v exporte {export_name}",
        "bcase_type": "Typ dokumentu",
        "bcase_types": {
            "default_value": "Predvolená hodnota",
            "required": "Povinné pole",
            "readonly": "Len na čítanie",
            "show_in_search": "Vyhľadávacie pole",
            "show_in_export": "Exportné pole",
            "show_in_column_dialog": "Dialóg stĺpcov",
            "show_in_api": "API",
            "order": "Poradie",
            "visible_in_step_types": "Zobraziť v krokoch",
            "all_steps": "Všetky kroky"
        },
        "tooltip": "Tooltip",
        "default_value": "Predvolená hodnota",
        "field_key": "Názov API",
        "type_options": {
            "text": "Text",
            "textarea": "Viacriadkový text",
            "number": "Číslo",
            "currency": "Mena",
            "checkbox": "Zaškrtávacie políčko",
            "radio": "Výber (radio)",
            "enum": "Rozbaľovací zoznam",
            "date": "Dátum",
            "html": "Rich Text (HTML)"
        },
        "page": {
            "new_title": "Nové pole",
            "tab_general": "Všeobecné",
            "tab_options": "Možnosti",
            "tab_validation": "Validácia",
            "tab_labels": "Popisky",
            "tab_tooltips": "Tooltips",
            "tab_permissions": "Skupiny oprávnení",
            "tab_clients": "Spoločnosti",
            "tab_bcase_types": "Prepojené typy dokumentov",
            "tab_bcase_description": "Doplňujúce polia",
            "validation": {
                "label_required": "Zadajte názov.",
                "field_key_required": "Zadajte názov API.",
                "export_field_name_required": "Zadajte názov poľa pre export."
            },
            "options": {
                "repeated": "Rovnakú možnosť nie je možné zadať viackrát.",
                "required_fields": "Musíte zadať popis a ID možnosti.",
                "language_empty": "Musíte vybrať jazyk.",
                "at_least_one_required": "Musíte zadať aspoň jednu možnosť."
            }
        }
    },
    "custom_field_label": {
        "description": "Popisky"
    },
    "custom_field_tooltip": {
        "description": "Tooltips"
    },
    "custom_field_option": {
        "description": "Možnosti"
    },
    "custom_field_bcase_type": {
        "description": "Prepojené typy dokumentov",
        "visible_in_step_types": "Zobraziť v krokoch"
    },
    "bcase_custom_field": {
        "description": "Doplňujúce polia"
    }

}
